import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw12Handlers = [
  // 掲載媒体情報取得 /kymw12/getPublishMediumInfo
  http.post(
    PlessService.SERVICE.getPublishMediumInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getPublishMediumInfo);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載媒体設定更新 /kymw12/UpdatePublishMediumSetting
  http.post(
    PlessService.SERVICE.updatePublishMediumSetting.url,
    async ({ request }) => {
      const req = await request.json();
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 企画回情報取得 /kymw12/getCatalogInfo
  http.post(
    PlessService.SERVICE.KYMW12getCatalogInfo.url,
    async ({ request }) => {
      const req = await request.json();
      getCatalogInfo.result.obj.CatalogInfo.CatalogFixFlg = '0'; // 0:未確定企画 / 1:確定企画
      return HttpResponse.json(getCatalogInfo);
      // return HttpResponse.json(getCatalogInfoPreviousEmpty);
      // return HttpResponse.json(getCatalogInfoNextEmpty);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 特集コード一覧取得 /kymw12/getFeatureCodeList
  http.post(
    PlessService.SERVICE.getFeatureCodeList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getFeatureCodeList);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 価格プロモーションリスト取得 /kymw12/getPricePromotionList
  http.post(
    PlessService.SERVICE.getPricePromotionList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getPricePromotionList);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 企画回別商品一覧情報取得 /kymw12/getPublishPlanGoodsCategoryListInfo
  http.post(
    PlessService.SERVICE.getPublishPlanGoodsCategoryListInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getPublishPlanGoodsCategoryListInfo);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // サイクル情報登録 /kymw12/registCycleInfo
  http.post(PlessService.SERVICE.registCycleInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(registCycleInfo);
    // return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // サイクル情報保存 /kymw12/saveCycleInfo
  http.post(PlessService.SERVICE.saveCycleInfo.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 企画回別商品一覧表出力 /KYMW12/outputPublishPlanGoodsCategoryListInfo
  http.post(PlessService.SERVICE.outputPublishPlanGoodsCategoryListInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(outputPublishPlanGoodsCategoryListInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }),

  // ノンブル取得	/KYMW12/getFolio
  http.post(PlessService.SERVICE.getFolio.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getFolioResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }),

  // サイクル企画商品クロス設定情報削除
  http.post(PlessService.SERVICE.deleteCyclePlanGoodsCross.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(deleteCyclePlanGoodsCrossResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // // サイクル設定媒体選択項目取得 /kymw12/getCycleMediumSelectItems
  // http.post(
  //   PlessService.SERVICE.getCycleMediumSelectItems.url,
  //   async ({ request }) => {
  //     const req: any = await request.json();
  //     if ('1' === req?.data?.parameter?.PastCycle) {
  //       return HttpResponse.json(getCycleMediumSelectItemsResponsePast);
  //     } else {
  //       return HttpResponse.json(getCycleMediumSelectItemsResponse);
  //     }
  //     // return ResponseUtils.getSysError();
  //     // return ResponseUtils.getE0100();
  //     // return ResponseUtils.get500();
  //   }
  // ),

  // サイクル設定表示条件取得 /kymw12/getCycleDispCondition
  http.post(
    PlessService.SERVICE.getCycleDispCondition.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleDispConditionResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 企画未確定受注コード一覧取得 /kymw12/getNonFixedOrderList
  http.post(
    PlessService.SERVICE.getNonFixedOrderList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getNonFixedOrderListResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // バイヤー選択項目取得 /kymw12/getBuyerSelectItems
  http.post(
    PlessService.SERVICE.getBuyerSelectItems.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getBuyerSelectItemsResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // WK実績履歴情報作成 /kymw12/registWkResultList
  http.post(
    PlessService.SERVICE.registWkResultList.url,
    async ({ request }) => {
      const req = await request.json();
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // サイクル設定予実情報取得 /kymw12/getCycleSummary
  http.post(PlessService.SERVICE.getCycleSummary.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getCycleSummaryResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // サイクル設定予実変更差分取得 /kymw12/getCycleSummaryDiff
  http.post(
    PlessService.SERVICE.getCycleSummaryDiff.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleSummaryDiffResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // サイクル設定商品情報取得 /kymw12/getCycleItemInfo
  http.post(PlessService.SERVICE.getCycleItemInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getCycleItemInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // サイクル設定他媒体情報取得 /kymw12/getOtherMediums
  http.post(PlessService.SERVICE.getOtherMediums.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getOtherMediumsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // サイクル設定商品情報登録 /kymw12/registCycleItemInfo
  http.post(
    PlessService.SERVICE.registCycleItemInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // サイクル設定表示条件情報登録 /kymw12/registCycleDispCondition
  http.post(
    PlessService.SERVICE.registCycleDispCondition.url,
    async ({ request }) => {
      const req = await request.json();
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // サイクル設定商品表示順登録 /kymw12/registCycleSort
  http.post(PlessService.SERVICE.registCycleSort.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 代行バイヤーコード取得 /kymw12/getBuyerCodeForAgent
  http.post(
    PlessService.SERVICE.getBuyerCodeForAgent.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getBuyerCodeForAgentResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // サイクル設定一覧表出力 /kymw12/outputCycleItemInfo
  http.post(
    PlessService.SERVICE.outputCycleItemInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(outputCycleItemInfoResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 配下バイヤー選択項目取得 /kymw12/getStaffBuyerSelectItems
  http.post(
    PlessService.SERVICE.getStaffBuyerSelectItems.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getStaffBuyerSelectItemsResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
];

const registCycleInfo = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "WarningList": [
        {
          "PCodeList": [
            "P1111111"
          ],
          "MessageID": "I0526"
        },
        {
          "PCodeList": [
            "P2222222",
            "P3333333"
          ],
          "MessageID": "I0527"
        },
        {
          "PCodeList": [
            "P3333333",
            "P4444444"
          ],
          "MessageID": "I0528"
        }
      ],
      "Message": "選定可能な商品のみサイクル確定しました。\n下記商品は選定できません。{0}",
      "CheckResult": "01", // 00: 正常終了、 01: 警告発生
      "MessageID": "I0525"
    }
  }
}

const getPublishMediumInfo = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      PCode: 'P0000000',
      GuideGoodsName:
        '商品名＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞最大６０文字ＥＮＤ',
      GuideStandardName:
        '規格名＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞最大３０文字ＥＮＤ',
      PublishMediumList: [
        {
          IsSelected: false,
          MediumType: '026',
          MediumName: 'ｅフレンズ専用',
        },
        { IsSelected: false, MediumType: '029', MediumName: '新発売' },
        { IsSelected: true, MediumType: '001', MediumName: 'ハピデリ' },
        { IsSelected: false, MediumType: '021', MediumName: 'プチハピ' },
        { IsSelected: false, MediumType: '016', MediumName: 'からだの願い' },
        {
          IsSelected: false,
          MediumType: '023',
          MediumName: 'コスメｄｅきれい（ＣＤ）',
        },
        { IsSelected: false, MediumType: '003', MediumName: 'ぐるめぐり' },
        {
          IsSelected: true,
          MediumType: '004',
          MediumName: 'きらきらベビー',
        },
        {
          IsSelected: false,
          MediumType: '007',
          MediumName: 'ライフスタイル',
        },
        { IsSelected: true, MediumType: '018', MediumName: 'ＩＴ先着順' },
        { IsSelected: false, MediumType: '025', MediumName: '別チラシ６' },
        {
          IsSelected: false,
          MediumType: '006',
          MediumName: 'らくらくコープデリ',
        },
        { IsSelected: false, MediumType: '008', MediumName: '別チラシ３' },
        { IsSelected: false, MediumType: '009', MediumName: '別チラシ４' },
        {
          IsSelected: false,
          MediumType: '080',
          MediumName: 'ハピデリきらきら',
        },
        {
          IsSelected: false,
          MediumType: '081',
          MediumName: 'ヴィナチュール',
        },
        { IsSelected: false, MediumType: '090', MediumName: '使用不可' },
      ],
    },
  },
};

const getCatalogInfo = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CatalogInfo: {
        PreviousCatalogId: '8月3回',
        PreviousOrderCode: '2023220',
        PreviousCatalogFixFlg: '0', // 未確定
        CatalogId: '8月4回',
        OrderCode: '2023230',
        CatalogFixFlg: '0', // 未確定
        NextCatalogId: '8月5回',
        NextOrderCode: '2023240',
        NextCatalogFixFlg: '0', // 未確定
      },
    },
  },
};

const getCatalogInfoPreviousEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CatalogInfo: {
        PreviousCatalogId: '',
        PreviousOrderCode: '',
        PreviousCatalogFixFlg: '0', // 未確定
        CatalogId: '8月4回',
        OrderCode: '2023230',
        CatalogFixFlg: '0', // 未確定
        NextCatalogId: '8月5回',
        NextOrderCode: '2023240',
        NextCatalogFixFlg: '0', // 未確定
      },
    },
  },
};

const getCatalogInfoNextEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CatalogInfo: {
        PreviousCatalogId: '8月3回',
        PreviousOrderCode: '2023220',
        PreviousCatalogFixFlg: '0', // 未確定
        CatalogId: '8月4回',
        OrderCode: '2023230',
        CatalogFixFlg: '0', // 未確定
        NextCatalogId: '',
        NextOrderCode: '',
        NextCatalogFixFlg: '0', // 未確定
      },
    },
  },
};

const getFeatureCodeList = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      FeatureCodeList: [
        {
          FeatureCode: '00001',
          FeatureName: '特集名1',
        },
        {
          FeatureCode: '00002',
          FeatureName: '特集名2',
        },
        {
          FeatureCode: '00003',
          FeatureName: '特集名3',
        },
      ],
    },
  },
};

const getPricePromotionList = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      PricePromotionList: [
        {
          MarkCode: '5',
          MarkName: '９９：スーパープライス',
        },
        {
          MarkCode: '6',
          MarkName: '０１：今週のお買得',
        },
        {
          MarkCode: '50',
          MarkName: '０１：最安値',
        },
        {
          MarkCode: '53',
          MarkName: '０１：おためし価格',
        },
      ],
    },
  },
};

const getPublishPlanGoodsCategoryListInfo = {
  status: 'ok',
  message: '処理終了',
  result: {
    obj: {
      ConfirmFlg: '0',
      UseNumPeople: '1000',
      TotalLineNum: '46',
      MediumSurfaceLineNum: '87',
      LargeComaNum: '15',
      PlanResult: '1000000',
      Supply: '123.4',
      Gp: '56.7',
      PublishPlanGoodsCategoryList: [
        // データ1
        {
          OrderCode: '2023230',
          CatalogId: '20230804',
          ClassName: '農産',
          MiddleClassName: '国産柑橘',
          SmallClassName: 'ハウスみかん',
          GoodsName: 'グリーンハウスみかん（サイズ込）',
          GoodsStandardName: '４００ｇ（２Ｓ～Ｍ）',
          PCode: 'P1111111',
          ItemCode: '11111111',
          JanCode: '1111111190123',
          LargeClassName: '果物',
          PayeeClientKanji: '取引先名1',
          OrderClientKanji: '発注先名1',
          ApplyTermEnd: '20230310',
          SpecialFeature: '00002',
          Folio: '9',
          Edlp: '0',
          RememberGoods: '1',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ1',
          BuyerComment: 'バイヤーコメント-1',
          CoopFlg142: '0',
          CoopFlg163: '0',
          CoopFlg185: '0',
          CoopFlg240: '0',
          CoopFlg210: '1',
          CoopFlg302: '1',
          CoopFlg515: '1',
          CoopFlg451: '1',
          CoopEnabledFlg142: '0',
          CoopEnabledFlg163: '0',
          CoopEnabledFlg185: '0',
          CoopEnabledFlg240: '0',
          CoopEnabledFlg210: '0',
          CoopEnabledFlg302: '0',
          CoopEnabledFlg515: '0',
          CoopEnabledFlg451: '0',
          PricePattern: '1',
          PricePromotion: '5',
          BargainMarkFlg: '1',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '6',
          OrderNumQuotaCode: '',
          OrderNumQuotaName: '',
          MediumWPublishFlg: '1',
          CrossCode: '11111111',
          PCodeOfCross: 'P1111111,P2222222,P3333333',
          CrossDecisionFlg: '0',
          WCrossFlg: '0',
          ThisTimeSupplyPrice: '398',
          ThisTimeCostPrice: '258',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '',
          PlanNum: '458',
          WCarryingFlg: '0',
          MainCoopCode: '142',
        },
        // データ2
        {
          OrderCode: '2023230',
          CatalogId: '20230904',
          ClassName: '農産',
          MiddleClassName: 'さくらんぼ',
          SmallClassName: 'アメリカンチェリー',
          GoodsName: 'アメリカンチェリー',
          GoodsStandardName: '３００ｇ',
          PCode: 'P2222222',
          ItemCode: '22222222',
          JanCode: '2222222290123',
          LargeClassName: '果物',
          PayeeClientKanji: '取引先名2',
          OrderClientKanji: '発注先名2',
          ApplyTermEnd: '20230310',
          SpecialFeature: '00002',
          Folio: '9',
          Edlp: '1',
          RememberGoods: '0',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ2',
          BuyerComment: 'バイヤーコメント-2',
          CoopFlg142: '1',
          CoopFlg163: '1',
          CoopFlg185: '1',
          CoopFlg240: '1',
          CoopFlg210: '0',
          CoopFlg302: '0',
          CoopFlg515: '0',
          CoopFlg451: '0',
          CoopEnabledFlg142: '0',
          CoopEnabledFlg163: '0',
          CoopEnabledFlg185: '0',
          CoopEnabledFlg240: '0',
          CoopEnabledFlg210: '0',
          CoopEnabledFlg302: '0',
          CoopEnabledFlg515: '0',
          CoopEnabledFlg451: '0',
          PricePattern: '1',
          PricePromotion: '6',
          BargainMarkFlg: '1',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '5',
          OrderNumQuotaCode: '',
          OrderNumQuotaName: '',
          MediumWPublishFlg: '1',
          CrossCode: '22222222',
          PCodeOfCross: '',
          CrossDecisionFlg: '0',
          WCrossFlg: '0',
          ThisTimeSupplyPrice: '450',
          ThisTimeCostPrice: '292',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '3249',
          PlanNum: '3232',
          WCarryingFlg: '0',
          MainCoopCode: '142',
        },
        // データ3
        {
          OrderCode: '2023230',
          CatalogId: '20231004',
          ClassName: '農産',
          MiddleClassName: '桃',
          SmallClassName: 'ネクタリン',
          GoodsName: 'ワッサー',
          GoodsStandardName: '６００ｇ（３～５個）',
          PCode: 'P3333333',
          ItemCode: '33333333',
          JanCode: '3333333390123',
          LargeClassName: '果物',
          PayeeClientKanji: '取引先名3',
          OrderClientKanji: '発注先名3',
          ApplyTermEnd: '20230310',
          SpecialFeature: '00002',
          Folio: '9',
          Edlp: '0',
          RememberGoods: '1',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ3',
          BuyerComment: 'バイヤーコメント-3',
          CoopFlg142: '0',
          CoopFlg163: '0',
          CoopFlg185: '0',
          CoopFlg240: '0',
          CoopFlg210: '1',
          CoopFlg302: '1',
          CoopFlg515: '1',
          CoopFlg451: '1',
          CoopEnabledFlg142: '1',
          CoopEnabledFlg163: '1',
          CoopEnabledFlg185: '1',
          CoopEnabledFlg240: '1',
          CoopEnabledFlg210: '1',
          CoopEnabledFlg302: '1',
          CoopEnabledFlg515: '1',
          CoopEnabledFlg451: '1',
          PricePattern: '1',
          PricePromotion: '50',
          BargainMarkFlg: '0',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '4',
          OrderNumQuotaCode: '',
          OrderNumQuotaName: '',
          MediumWPublishFlg: '0',
          CrossCode: '33333333',
          PCodeOfCross: 'P1111111,P2222222,P3333333',
          CrossDecisionFlg: '1',
          WCrossFlg: '1',
          ThisTimeSupplyPrice: '368',
          ThisTimeCostPrice: '240',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '4475',
          PlanNum: '4490',
          WCarryingFlg: '0',
          MainCoopCode: '142',
        },
        // データ4
        {
          OrderCode: '2023230',
          CatalogId: '20231104',
          ClassName: '農産',
          MiddleClassName: '柿',
          SmallClassName: '平たねなし柿',
          GoodsName: 'たねなし柿',
          GoodsStandardName: '１ｋｇ（５～７個）',
          PCode: 'P4444444',
          ItemCode: '44444444',
          JanCode: '4444444490123',
          LargeClassName: '果物',
          PayeeClientKanji: '取引先名4',
          OrderClientKanji: '発注先名4',
          ApplyTermEnd: '20230310',
          SpecialFeature: '00002',
          Folio: '9',
          Edlp: '1',
          RememberGoods: '0',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ4',
          BuyerComment: 'バイヤーコメント-4',
          CoopFlg142: '1',
          CoopFlg163: '1',
          CoopFlg185: '1',
          CoopFlg240: '1',
          CoopFlg210: '0',
          CoopFlg302: '0',
          CoopFlg515: '0',
          CoopFlg451: '0',
          CoopEnabledFlg142: '1',
          CoopEnabledFlg163: '1',
          CoopEnabledFlg185: '1',
          CoopEnabledFlg240: '1',
          CoopEnabledFlg210: '1',
          CoopEnabledFlg302: '1',
          CoopEnabledFlg515: '1',
          CoopEnabledFlg451: '1',
          PricePattern: '1',
          PricePromotion: '53',
          BargainMarkFlg: '0',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '3',
          OrderNumQuotaCode: '',
          OrderNumQuotaName: '',
          MediumWPublishFlg: '0',
          CrossCode: '44444444',
          PCodeOfCross: '',
          CrossDecisionFlg: '1',
          WCrossFlg: '1',
          ThisTimeSupplyPrice: '398',
          ThisTimeCostPrice: '248.4',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '729',
          PlanNum: '732',
          WCarryingFlg: '0',
          MainCoopCode: '142',
        },
        // データ5
        {
          OrderCode: '2023231',
          CatalogId: '20231204',
          ClassName: '農産',
          MiddleClassName: '梨',
          SmallClassName: '２０世紀梨',
          GoodsName: 'なし（サンセーキ）',
          GoodsStandardName: '４．８ｋｇ箱（１２～１６個）',
          PCode: 'P5555555',
          ItemCode: '55555555',
          JanCode: '5555555590123',
          LargeClassName: '果実',
          PayeeClientKanji: '取引先名5',
          OrderClientKanji: '発注先名5',
          ApplyTermEnd: '20230310',
          SpecialFeature: '00002',
          Folio: '9',
          Edlp: '0',
          RememberGoods: '1',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ5',
          BuyerComment: 'バイヤーコメント-5',
          CoopFlg142: '0',
          CoopFlg163: '0',
          CoopFlg185: '0',
          CoopFlg240: '0',
          CoopFlg210: '1',
          CoopFlg302: '1',
          CoopFlg515: '1',
          CoopFlg451: '1',
          CoopEnabledFlg142: '0',
          CoopEnabledFlg163: '0',
          CoopEnabledFlg185: '0',
          CoopEnabledFlg240: '0',
          CoopEnabledFlg210: '0',
          CoopEnabledFlg302: '0',
          CoopEnabledFlg515: '0',
          CoopEnabledFlg451: '0',
          PricePattern: '1',
          PricePromotion: '',
          BargainMarkFlg: '1',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '6',
          OrderNumQuotaCode: '',
          OrderNumQuotaName: '',
          MediumWPublishFlg: '1',
          CrossCode: '55555555',
          PCodeOfCross: 'P1111111,P2222222,P3333333',
          CrossDecisionFlg: '0',
          WCrossFlg: '0',
          ThisTimeSupplyPrice: '398',
          ThisTimeCostPrice: '258',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '450',
          PlanNum: '458',
          WCarryingFlg: '0',
          MainCoopCode: '142',
        },
        // データ6
        {
          OrderCode: '2023232',
          CatalogId: '20240104',
          ClassName: '畜産',
          MiddleClassName: '焼肉・焼しゃぶ',
          SmallClassName: 'アメリカ牛',
          GoodsName: '牛カルビ焼肉用',
          GoodsStandardName: '２２０ｇ',
          PCode: 'P6666666',
          ItemCode: '66666666',
          JanCode: '6666666690123',
          LargeClassName: '精肉',
          PayeeClientKanji: '取引先名6',
          OrderClientKanji: '発注先名6',
          ApplyTermEnd: '20230310',
          SpecialFeature: '00002',
          Folio: '9',
          Edlp: '1',
          RememberGoods: '0',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ6',
          BuyerComment: 'バイヤーコメント-6',
          CoopFlg142: '1',
          CoopFlg163: '1',
          CoopFlg185: '1',
          CoopFlg240: '1',
          CoopFlg210: '0',
          CoopFlg302: '0',
          CoopFlg515: '0',
          CoopFlg451: '0',
          CoopEnabledFlg142: '0',
          CoopEnabledFlg163: '0',
          CoopEnabledFlg185: '0',
          CoopEnabledFlg240: '0',
          CoopEnabledFlg210: '0',
          CoopEnabledFlg302: '0',
          CoopEnabledFlg515: '0',
          CoopEnabledFlg451: '0',
          PricePattern: '1',
          PricePromotion: '',
          BargainMarkFlg: '1',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '6',
          OrderNumQuotaCode: '',
          OrderNumQuotaName: '',
          MediumWPublishFlg: '1',
          CrossCode: '66666666',
          PCodeOfCross: '',
          CrossDecisionFlg: '0',
          WCrossFlg: '0',
          ThisTimeSupplyPrice: '450',
          ThisTimeCostPrice: '292',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '3249',
          PlanNum: '3232',
          WCarryingFlg: '0',
          MainCoopCode: '142',
        },
        // データ7
        {
          OrderCode: '2023233',
          CatalogId: '20240204',
          ClassName: '畜産',
          MiddleClassName: '焼肉・焼しゃぶ',
          SmallClassName: '国産牛',
          GoodsName: '国産牛豚焼肉セット',
          GoodsStandardName: '５００ｇ',
          PCode: 'P7777777',
          ItemCode: '77777777',
          JanCode: '7777777790123',
          LargeClassName: '精肉',
          PayeeClientKanji: '取引先名7',
          OrderClientKanji: '発注先名7',
          ApplyTermEnd: '20230310',
          SpecialFeature: '00002',
          Folio: '9',
          Edlp: '0',
          RememberGoods: '1',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ7',
          BuyerComment: 'バイヤーコメント-7',
          CoopFlg142: '0',
          CoopFlg163: '0',
          CoopFlg185: '0',
          CoopFlg240: '0',
          CoopFlg210: '1',
          CoopFlg302: '1',
          CoopFlg515: '1',
          CoopFlg451: '1',
          CoopEnabledFlg142: '1',
          CoopEnabledFlg163: '1',
          CoopEnabledFlg185: '1',
          CoopEnabledFlg240: '1',
          CoopEnabledFlg210: '1',
          CoopEnabledFlg302: '1',
          CoopEnabledFlg515: '1',
          CoopEnabledFlg451: '1',
          PricePattern: '1',
          PricePromotion: '',
          BargainMarkFlg: '0',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '6',
          OrderNumQuotaCode: '071',
          OrderNumQuotaName: 'TEST071',
          MediumWPublishFlg: '0',
          CrossCode: '77777777',
          PCodeOfCross: 'P1111111,P2222222,P3333333',
          CrossDecisionFlg: '1',
          WCrossFlg: '1',
          ThisTimeSupplyPrice: '368',
          ThisTimeCostPrice: '240',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '4475',
          PlanNum: '4490',
          WCarryingFlg: '0',
          MainCoopCode: '142',
        },
        // データ8
        {
          OrderCode: '2023234',
          CatalogId: '20240304',
          ClassName: '畜産',
          MiddleClassName: '焼肉・焼しゃぶ',
          SmallClassName: '産直牛',
          GoodsName: '牛カルビ焼肉用',
          GoodsStandardName: '２５０ｇ',
          PCode: 'P8888888',
          ItemCode: '88888888',
          JanCode: '8888888890123',
          LargeClassName: '精肉',
          PayeeClientKanji: '取引先名8',
          OrderClientKanji: '発注先名8',
          ApplyTermEnd: '20230310',
          // SpecialFeature: '00002',
          SpecialFeature: '',
          Folio: '',
          Edlp: '1',
          RememberGoods: '0',
          OrderReceptionStartCatalog: '20230202',
          OrderReceptionEndCatalog: '20240202',
          GoodsMemo: '商品メモ8',
          BuyerComment: 'バイヤーコメント-8',
          CoopFlg142: '1',
          CoopFlg163: '1',
          CoopFlg185: '1',
          CoopFlg240: '1',
          CoopFlg210: '0',
          CoopFlg302: '0',
          CoopFlg515: '0',
          CoopFlg451: '0',
          CoopEnabledFlg142: '1',
          CoopEnabledFlg163: '1',
          CoopEnabledFlg185: '1',
          CoopEnabledFlg240: '1',
          CoopEnabledFlg210: '1',
          CoopEnabledFlg302: '1',
          CoopEnabledFlg515: '1',
          CoopEnabledFlg451: '1',
          PricePattern: '1',
          PricePromotion: '',
          BargainMarkFlg: '0',
          KomaPromotion: '02',
          PromotionMark: '038',
          AppearDiv: '6',
          OrderNumQuotaCode: '001', // ハピデリOCR（親媒体がハピデリとなる）
          OrderNumQuotaName: 'ハピデリOCR',
          MediumWPublishFlg: '0',
          CrossCode: '88888888',
          PCodeOfCross: '',
          CrossDecisionFlg: '0',
          WCrossFlg: '0',
          ThisTimeSupplyPrice: '398',
          ThisTimeCostPrice: '248.4',
          SupplyPriceStandard: "1000",
          SupplyPriceSpecial1: "2000",
          SupplyPriceSpecial2: "3000",
          CostPriceStandard: "3500",
          CostPriceSpecial1: "4000",
          CostPriceSpecial2: "5000",
          BundlePrice: '1',
          PlanNumAiPrediction: '729',
          PlanNum: '732',
          WCarryingFlg: '1',
          MainCoopCode: '142',
        },
      ],
    },
  },
};

const outputPublishPlanGoodsCategoryListInfoResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      FileName: "/tmp/peace/data/WebData/downloadtemp/KYMW1201_001_00000001_302_20240814_161931.xlsx"
    }
  }
};

const getFolioResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      Folio: "1"
    }
  }
};

const deleteCyclePlanGoodsCrossResponse = {
  "status": "ok",
  "message": "処理終了",
}

const getCycleMediumSelectItemsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      { Code: '001', Name: 'ハピデリ' },
      { Code: '003', Name: 'ぐるめぐり' },
      { Code: '004', Name: 'きらきらベビー' },
      { Code: '006', Name: 'らくらくコープデリ' },
      { Code: '007', Name: 'ライフスタイル' },
      { Code: '008', Name: '別チラシ３' },
      { Code: '009', Name: '別チラシ４' },
    ],
  },
};
const getCycleMediumSelectItemsResponsePast = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      { Code: '001', Name: 'ハピデリ' },
      { Code: '003', Name: 'ぐるめぐり' },
      { Code: '004', Name: 'きらきらベビー' },
      { Code: '006', Name: 'らくらくコープデリ' },
      { Code: '007', Name: 'ライフスタイル' },
    ],
  },
};
const getCycleDispConditionResponse = {
  status: 'ok',
  message: '処理完了',
  // result: null,
  result: {
    obj: {
      DispMedium: '007',
      DispBuyer: '12345678',
      DispCoop: 'ALL',
      DispDiv: '001',
      StartOrderCode: '2023160',
      EndOrderCode: '2023200',
    },
  },
};
// const getCycleDispConditionResponse = {
//   "status": "ok",
//   "message": "処理完了",
//   "result": {
//     "obj": {
//       "DispMedium": "001",
//       "DispBuyer": "00600020",
//       "DispCoop": "ALL",
//       "DispDiv": "001",
//       "StartOrderCode": "2025120",
//       "EndOrderCode": "2025120"
//     }
//   }
// };
const getNonFixedOrderListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        OrderCode: '2023180',
        CatalogID: '20230703',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023190',
        CatalogID: '20230704',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023200',
        CatalogID: '20230801',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023210',
        CatalogID: '20230802',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023220',
        CatalogID: '20230803',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023230',
        CatalogID: '20230804',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023240',
        CatalogID: '20230805',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023250',
        CatalogID: '20230901',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023260',
        CatalogID: '20230902',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023270',
        CatalogID: '20230903',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023280',
        CatalogID: '20230904',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023290',
        CatalogID: '20231001',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023300',
        CatalogID: '20231002',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023310',
        CatalogID: '20231003',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023320',
        CatalogID: '20231004',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023330',
        CatalogID: '20231101',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023340',
        CatalogID: '20231102',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023350',
        CatalogID: '20231103',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023360',
        CatalogID: '20231104',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023370',
        CatalogID: '20231105',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023380',
        CatalogID: '20231201',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023390',
        CatalogID: '20231202',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023400',
        CatalogID: '20231203',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023410',
        CatalogID: '20231204',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023420',
        CatalogID: '20231205',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023430',
        CatalogID: '20240101',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023440',
        CatalogID: '20240102',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023450',
        CatalogID: '20240103',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023460',
        CatalogID: '20240104',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023470',
        CatalogID: '20240201',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023480',
        CatalogID: '20240202',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023490',
        CatalogID: '20240203',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2023500',
        CatalogID: '20240204',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2023510',
        CatalogID: '20240301',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2023520',
        CatalogID: '20240302',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2023530',
        CatalogID: '20240303',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2024010',
        CatalogID: '20240304',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2024020',
        CatalogID: '20240401',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2024030',
        CatalogID: '20240402',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2024040',
        CatalogID: '20240403',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2024050',
        CatalogID: '20240404',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2024060',
        CatalogID: '20240501',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2024070',
        CatalogID: '20240502',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2024080',
        CatalogID: '20240503',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2024090',
        CatalogID: '20240504',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2024100',
        CatalogID: '20240505',
        RegistCycle: 'Ｂ週',
      },
      {
        OrderCode: '2024110',
        CatalogID: '20240601',
        RegistCycle: 'Ｃ週',
      },
      {
        OrderCode: '2024120',
        CatalogID: '20240602',
        RegistCycle: 'Ｄ週',
      },
      {
        OrderCode: '2024130',
        CatalogID: '20240603',
        RegistCycle: 'Ａ週',
      },
      {
        OrderCode: '2024140',
        CatalogID: '20240604',
        RegistCycle: 'Ｂ週',
      },
    ],
  },
};
const getBuyerSelectItemsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      { Code: '00000001', Name: 'バイヤー１' },
      { Code: '00000002', Name: 'バイヤー２' },
      { Code: '00000003', Name: 'バイヤー３' },
      { Code: '00000004', Name: 'バイヤー４' },
      { Code: '12345678', Name: 'バイヤー１２３' },
      { Code: '23456789', Name: 'バイヤー２３４' },
      { Code: '34567890', Name: 'バイヤー３４５' },
    ],
    // obj: [],
  },
};
// const getBuyerSelectItemsResponse = {
//   "status": "ok",
//   "message": "処理完了",
//   "result": {
//     "obj": [
//       {
//         "Code": "00600020",
//         "Name": "テスト用100"
//       },
//       {
//         "Code": "10000001",
//         "Name": "テスト権限20"
//       },
//       {
//         "Code": "10000001",
//         "Name": "テスト用バイヤー01"
//       },
//       {
//         "Code": "10000001",
//         "Name": "デリ宅配農産_G長"
//       },
//       {
//         "Code": "10000001",
//         "Name": "デリ宅配商品_G長"
//       },
//       {
//         "Code": "10000001",
//         "Name": "デリ宅配農産_パート・派遣"
//       },
//       {
//         "Code": "10000001",
//         "Name": "テスト用100"
//       },
//       {
//         "Code": "10000001",
//         "Name": "デリ宅配農産_職員"
//       }
//     ]
//   }
// };
const getCycleSummaryResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        OrderCode: '2023160',
        CatalogId: '20230701',
        Budget: 9000,
        Plan: 2100,
        Result: 1900,
        PrevResult: 1919,
      },
      {
        OrderCode: '2023170',
        CatalogId: '20230702',
        Budget: 1009,
        Plan: 348,
        Result: 3400,
        PrevResult: 3434,
      },
      {
        OrderCode: '2023180',
        CatalogId: '20230703',
        Budget: 240,
        Plan: 0,
        Result: 200,
        PrevResult: 202,
      },
      {
        OrderCode: '2023190',
        CatalogId: '20230704',
        Budget: 3000,
        Plan: 2750,
        Result: 2500,
        PrevResult: 2525,
      },
      {
        OrderCode: '2023200',
        CatalogId: '20230801',
        Budget: 2640,
        Plan: 2420,
        Result: 2200,
        PrevResult: 2222,
      },
      {
        OrderCode: '2023210',
        CatalogId: '20230802',
        Budget: 2400,
        Plan: 2200,
        Result: 2000,
        PrevResult: 2020,
      },
      {
        OrderCode: '2023220',
        CatalogId: '20230803',
        Budget: 4200,
        Plan: 3850,
        Result: 3500,
        PrevResult: 3535,
      },
      {
        OrderCode: '2023230',
        CatalogId: '20230804',
        Budget: 1200,
        Plan: 1100,
        Result: 1000000,
        PrevResult: 1010000,
      },
      {
        OrderCode: '2023240',
        CatalogId: '20230805',
        Budget: 2880,
        Plan: 2640,
        Result: 2400,
        PrevResult: 2424,
      },
      {
        OrderCode: '2023250',
        CatalogId: '20230901',
        Budget: 2760,
        Plan: 2530,
        Result: 2300,
        PrevResult: 2323,
      },
      {
        OrderCode: '2023260',
        CatalogId: '20230902',
        Budget: 2520,
        Plan: 2310,
        Result: 2100,
        PrevResult: 2121,
      },
      {
        OrderCode: '2023270',
        CatalogId: '20230903',
        Budget: 5280,
        Plan: 4840,
        Result: 4400,
        PrevResult: 4444,
      },
      {
        OrderCode: '2023280',
        CatalogId: '20230904',
        Budget: 1320,
        Plan: 1210,
        Result: 1100,
        PrevResult: 1111,
      },
      {
        OrderCode: '2023290',
        CatalogId: '20231001',
        Budget: 3960,
        Plan: 3630,
        Result: 3300,
        PrevResult: 3333,
      },
      {
        OrderCode: '2023300',
        CatalogId: '20231002',
        Budget: 1200,
        Plan: 1100,
        Result: 1000,
        PrevResult: 1010,
      },
      {
        OrderCode: '2023310',
        CatalogId: '20231003',
        Budget: 5160,
        Plan: 4730,
        Result: 4300,
        PrevResult: 4343,
      },
      {
        OrderCode: '2023320',
        CatalogId: '20231004',
        Budget: 5400,
        Plan: 4950,
        Result: 4500,
        PrevResult: 4545,
      },
      {
        OrderCode: '2023330',
        CatalogId: '20231101',
        Budget: 1440,
        Plan: 1320,
        Result: 1200,
        PrevResult: 1212,
      },
      {
        OrderCode: '2023340',
        CatalogId: '20231102',
        Budget: 3120,
        Plan: 2860,
        Result: 2600,
        PrevResult: 2626,
      },
      {
        OrderCode: '2023350',
        CatalogId: '20231103',
        Budget: 360,
        Plan: 330,
        Result: 300,
        PrevResult: 303,
      },
      {
        OrderCode: '2023360',
        CatalogId: '20231104',
        Budget: 4320,
        Plan: 3960,
        Result: 3600,
        PrevResult: 3636,
      },
      {
        OrderCode: '2023370',
        CatalogId: '20231105',
        Budget: 5520,
        Plan: 5060,
        Result: 4600,
        PrevResult: 4646,
      },
      {
        OrderCode: '2023380',
        CatalogId: '20231201',
        Budget: 1560,
        Plan: 1430,
        Result: 1300,
        PrevResult: 1313,
      },
      {
        OrderCode: '2023390',
        CatalogId: '20231202',
        Budget: 3240,
        Plan: 2970,
        Result: 2700,
        PrevResult: 2727,
      },
      {
        OrderCode: '2023400',
        CatalogId: '20231203',
        Budget: 480,
        Plan: 440,
        Result: 400,
        PrevResult: 404,
      },
      {
        OrderCode: '2023410',
        CatalogId: '20231204',
        Budget: 4440,
        Plan: 4070,
        Result: 3700,
        PrevResult: 3737,
      },
      {
        OrderCode: '2023420',
        CatalogId: '20231205',
        Budget: 5640,
        Plan: 5170,
        Result: 4700,
        PrevResult: 4747,
      },
      {
        OrderCode: '2023430',
        CatalogId: '20240101',
        Budget: 1680,
        Plan: 1540,
        Result: 1400,
        PrevResult: 1414,
      },
      {
        OrderCode: '2023440',
        CatalogId: '20240102',
        Budget: 3360,
        Plan: 3080,
        Result: 2800,
        PrevResult: 2828,
      },
      {
        OrderCode: '2023450',
        CatalogId: '20240103',
        Budget: 600,
        Plan: 550,
        Result: 500,
        PrevResult: 505,
      },
      {
        OrderCode: '2023460',
        CatalogId: '20240104',
        Budget: 4560,
        Plan: 4180,
        Result: 3800,
        PrevResult: 3838,
      },
      {
        OrderCode: '2023470',
        CatalogId: '20240201',
        Budget: 5760,
        Plan: 5280,
        Result: 4800,
        PrevResult: 4848,
      },
      {
        OrderCode: '2023480',
        CatalogId: '20240202',
        Budget: 1800,
        Plan: 1650,
        Result: 1500,
        PrevResult: 1515,
      },
      {
        OrderCode: '2023490',
        CatalogId: '20240203',
        Budget: 3480,
        Plan: 3190,
        Result: 2900,
        PrevResult: 2929,
      },
      {
        OrderCode: '2023500',
        CatalogId: '20240204',
        Budget: 720,
        Plan: 660,
        Result: 600,
        PrevResult: 606,
      },
      {
        OrderCode: '2023510',
        CatalogId: '20240301',
        Budget: 4680,
        Plan: 4290,
        Result: 3900,
        PrevResult: 3939,
      },
      {
        OrderCode: '2023520',
        CatalogId: '20240302',
        Budget: 5880,
        Plan: 5390,
        Result: 4900,
        PrevResult: 4949,
      },
      {
        OrderCode: '2023530',
        CatalogId: '20240303',
        Budget: 1920,
        Plan: 1760,
        Result: 1600,
        PrevResult: 1616,
      },
      {
        OrderCode: '2024010',
        CatalogId: '20240304',
        Budget: 3600,
        Plan: 3300,
        Result: 3000,
        PrevResult: 3030,
      },
      {
        OrderCode: '2024020',
        CatalogId: '20240401',
        Budget: 840,
        Plan: 770,
        Result: 700,
        PrevResult: 707,
      },
      {
        OrderCode: '2024030',
        CatalogId: '20240402',
        Budget: 4800,
        Plan: 4400,
        Result: 4000,
        PrevResult: 4040,
      },
      {
        OrderCode: '2024040',
        CatalogId: '20240403',
        Budget: 6000,
        Plan: 5500,
        Result: 5000,
        PrevResult: 5050,
      },
      {
        OrderCode: '2024050',
        CatalogId: '20240404',
        Budget: 2040,
        Plan: 1870,
        Result: 1700,
        PrevResult: 1717,
      },
      {
        OrderCode: '2024060',
        CatalogId: '20240501',
        Budget: 3720,
        Plan: 3410,
        Result: 3100,
        PrevResult: 3131,
      },
      {
        OrderCode: '2024070',
        CatalogId: '20240502',
        Budget: 960,
        Plan: 880,
        Result: 800,
        PrevResult: 808,
      },
      {
        OrderCode: '2024080',
        CatalogId: '20240503',
        Budget: 4920,
        Plan: 4510,
        Result: 4100,
        PrevResult: 4141,
      },
      {
        OrderCode: '2024090',
        CatalogId: '20240504',
        Budget: 6120,
        Plan: 5610,
        Result: 5100,
        PrevResult: 5151,
      },
      {
        OrderCode: '2024100',
        CatalogId: '20240505',
        Budget: 2160,
        Plan: 1980,
        Result: 1800,
        PrevResult: 1818,
      },
      {
        OrderCode: '2024110',
        CatalogId: '20240601',
        Budget: 3840,
        Plan: 3520,
        Result: 3200,
        PrevResult: 3232,
      },
      {
        OrderCode: '2024120',
        CatalogId: '20240602',
        Budget: 1080,
        Plan: 990,
        Result: 900,
        PrevResult: 909,
      },
      {
        OrderCode: '2024130',
        CatalogId: '20240603',
        Budget: 5040,
        Plan: 4620,
        Result: 4200,
        PrevResult: 4242,
      },
    ],
  },
};
const getCycleSummaryDiffResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        OrderCode: '2023160',
        CatalogId: '20230701',
        Plan: 410,
      },
      {
        OrderCode: '2023170',
        CatalogId: '20230702',
        Plan: -1240,
      },
    ],
  },
};
const getCycleItemInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CycleItemInfoList: [
        {
          MediumName: 'ハピデリ',
          MediumType: '018',
          ClassCode: '01',
          ClassName: '水産',
          MiddleClassName: '貝・海藻',
          SmallClassName: 'その他海藻',
          CategoryTagId: '00000001',
          CategoryTagName: 'タグ名',
          TagInfoList: [
            { TagId: '00000001', TagName: 'タグ１' },
            { TagId: '00000002', TagName: 'タグ２' },
            { TagId: '00000003', TagName: 'タグ３' },
          ],
          GoodsName: '食べたい分だけ「アカモク」',
          StandardName: '６００ｇ（２０ｇ×３０袋）',
          SupplyTaxWithoutStd: 1000,
          CostPriceStandard: 50000.0,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 2000,
          CostPriceSpecial1: 10000.0,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 3000000,
          CostPriceSpecial2: 15000.0,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2616664',
          ItemCode: '3881474',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '2400000093916',
          LargeClassName: '惣菜魚１',
          PayeeClient: 'アイケイ（ダイレクト）',
          OrderClient: 'アイケイ（ダイレクト）',
          ApplyTermEnd: '99999999',
          ApplyTermStart: '20260211',
          GoodsMemo: 'タグ２｜設定可｜□・表紙｜△・裏表紙｜□・特集｜☆・無｜　',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '0',
              PricePattern: '2',
              FeatureCode: '001H1',
              SelectedOthers: '0',
              DispValue1: 1200,
              DispValue2: 144000,
              DelivStartDate: '20260921',
              CatalogMemo: '企画回メモ１'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '0',
              PricePattern: '1',
              FeatureCode: '001H2',
              SelectedOthers: '1',
              DispValue1: 1400,
              DispValue2: 140000,
              DelivStartDate: '20260921',
              CatalogMemo: '企画回メモ２'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '0',
              PricePattern: '2',
              FeatureCode: '00199',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20260921',
              CatalogMemo: '企画回メモ３'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '3',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20260921',
              CatalogMemo: '企画回メモ４'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: null,
              DispValue2: null,
              DelivStartDate: '20260921',
              CatalogMemo: '企画回メモ５'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '018',
          ClassCode: '02',
          ClassName: '食品',
          MiddleClassName: '機能性飲料',
          SmallClassName: 'その他',
          CategoryTagId: '00000003',
          CategoryTagName: 'タグ名',
          TagInfoList: [
            { TagId: '00000001', TagName: 'タグ１' },
            { TagId: '00000002', TagName: 'タグ２' },
            { TagId: '00000003', TagName: 'タグ３' },
          ],
          GoodsName: '酵素美人－赤（ピンクグレープフルーツ',
          StandardName: '７２０ｍｌ',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '0',
          EnableSet: '1',
          Pcode: 'P2641252',
          ItemCode: '4102177',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4953035051003',
          LargeClassName: '飲料',
          PayeeClient: 'アイケイ（ダイレクト）',
          OrderClient: 'アイケイ（ダイレクト）',
          ApplyTermEnd: '20230801',
          ApplyTermStart: '20160101',
          GoodsMemo: 'タグ３｜設定可｜〇・無｜△・表紙｜□・裏表紙｜☆・特集｜　',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '1',
              PricePattern: '0',
              FeatureCode: '',
              SelectedOthers: '0',
              DispValue1: 1300,
              DispValue2: 169000,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ６'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '1',
              FeatureCode: '001H1',
              SelectedOthers: '1',
              DispValue1: 2400,
              DispValue2: 240000,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ７'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '2',
              FeatureCode: '001H2',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ８'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '3',
              FeatureCode: '00199',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ９'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ１０'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '03',
          ClassName: '食品',
          MiddleClassName: 'その他',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'きくいも粒３６ｇ（２００ｍｇ×１８０粒）',
          StandardName: '【ポスト投函でお届け】',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2645135',
          ItemCode: '4145186',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4589650100439',
          LargeClassName: '機能性食品',
          PayeeClient: 'アイケイ（ダイレクト）',
          OrderClient: 'アイケイ（ダイレクト）',
          ApplyTermEnd: '20221031',
          ApplyTermStart: '20160101',
          GoodsMemo: 'タグ無｜設定不可｜△・無｜〇・無｜□・特集｜　｜　',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '1',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1400,
              DispValue2: 196000,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ１１'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '0',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 3400,
              DispValue2: 340000,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ１２'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '2',
              FeatureCode: '00199',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ１３'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '1',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ１４'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20230701',
              CatalogMemo: '企画回メモ１５'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '04',
          ClassName: '食品',
          MiddleClassName: '海藻',
          SmallClassName: 'その他',
          CategoryTagId: '00000002',
          CategoryTagName: 'タグ名',
          TagInfoList: [
            { TagId: '00000001', TagName: 'タグ１' },
            { TagId: '00000002', TagName: 'タグ２' },
            { TagId: '00000003', TagName: 'タグ３' },
          ],
          GoodsName: '三陸産アカモク粉末　１００ｇ×２袋',
          StandardName: '【ポスト投函でお届け】',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2646091',
          ItemCode: '4155815',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '2400000122951',
          LargeClassName: '乾物',
          PayeeClient: 'アイケイ（ダイレクト）',
          OrderClient: 'アイケイ（ダイレクト）',
          ApplyTermEnd: '20221031',
          ApplyTermStart: '20160101',
          GoodsMemo: 'タグ２｜設定可｜□・裏表紙｜☆・特集｜　｜　｜△・裏表紙',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '2',
              FeatureCode: '001H2',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 225000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ１６'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '3',
              FeatureCode: '00199',
              SelectedOthers: '1',
              DispValue1: 4400,
              DispValue2: 440000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ１７'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ１８'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ１９'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '1',
              FeatureCode: '001H2',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２０'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '05',
          ClassName: '食品',
          MiddleClassName: 'その他',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'バターコーヒーパウダー',
          StandardName: '４５ｇ（１．５ｇ×３０包）×２',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646095',
          ItemCode: '4155866',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '2027890000208',
          LargeClassName: '嗜好飲料',
          PayeeClient: 'アイケイ（ダイレクト）',
          OrderClient: 'アイケイ（ダイレクト）',
          ApplyTermEnd: '20221031',
          ApplyTermStart: '20160101',
          GoodsMemo: 'タグ無｜設定不可｜〇・無｜　｜〇・無｜　｜　',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '0',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1600,
              DispValue2: 256000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２１'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 5400,
              DispValue2: 540000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２２'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '0',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２３'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２４'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２５'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '05',
          ClassName: '食品',
          MiddleClassName: 'その他',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: '国産素材のごぼう玉ねぎ菊芋茶',
          StandardName: '４０ｇ（２ｇ×２０包）×２袋',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646098',
          ItemCode: '4155890',
          RelationPcode: 'P2170663',
          CoopCode: '210',
          JanCode: '2400000122982',
          LargeClassName: '嗜好飲料',
          PayeeClient: 'アイケイ（ダイレクト）',
          OrderClient: 'アイケイ（ダイレクト）',
          ApplyTermEnd: '20221031',
          ApplyTermStart: '20160101',
          GoodsMemo: 'タグ無｜設定不可｜　｜　｜☆・無｜　｜　',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1700,
              DispValue2: 289000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２６'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 6400,
              DispValue2: 640000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２７'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '3',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２８'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ２９'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３０'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '06',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '00000001',
          CategoryTagName: 'タグ名',
          TagInfoList: [
            { TagId: '00000001', TagName: 'タグ１' },
            { TagId: '00000002', TagName: 'タグ２' },
            { TagId: '00000005', TagName: 'タグ５' },
          ],
          GoodsName: 'ダ）ハンディ振動マシン',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2646539',
          ItemCode: '4160762',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4571521490015',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: '99999999',
          ApplyTermStart: '20160101',
          GoodsMemo:
            'タグ５｜設定可｜☆・特集｜☆・無｜△・表紙｜〇・裏表紙｜□・表紙',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '3',
              FeatureCode: '00199',
              SelectedOthers: '1',
              DispValue1: 1800,
              DispValue2: 324000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３１'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '3',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 7400,
              DispValue2: 740000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３２'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '1',
              FeatureCode: '001H1',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３３'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '0',
              FeatureCode: '001H2',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３４'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '2',
              FeatureCode: '001H1',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３５'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '07',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '00000001',
          CategoryTagName: 'タグ名',
          TagInfoList: [
            { TagId: '00000001', TagName: 'タグ１' },
            { TagId: '00000002', TagName: 'タグ２' },
            { TagId: '00000004', TagName: 'タグ４' },
          ],
          GoodsName: 'ダ）ハンディファン（ホワイト）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2646540',
          ItemCode: '4160770',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4981747071347',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: '99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: 'タグ４｜設定可｜〇・無｜〇・無｜〇・特集｜△・表紙｜☆・特集',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '0',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1900,
              DispValue2: 361000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３６'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '0',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 8400,
              DispValue2: 840000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３７'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '0',
              FeatureCode: '00199',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３８'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '1',
              FeatureCode: '001H1',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ３９'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '3',
              FeatureCode: '00199',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４０'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '08',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）衣類乾燥除湿機（ホワイト）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2646541',
          ItemCode: '4160789',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4906128357131',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: '99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '0',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 2000,
              DispValue2: 400000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４１'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '1',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 9400,
              DispValue2: 940000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４２'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４３'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '3',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４４'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４５'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '09',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）ＤＣモーター　３０ｃｍ　リビング扇風機（リモコン式）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2646542',
          ItemCode: '4160797',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4571102092249',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: '99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 2100,
              DispValue2: 441000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４６'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '1',
              PricePattern: '1',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 2500,
              DispValue2: 250000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４７'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４８'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '3',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ４９'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５０'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '10',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）ステンレスミニボトル（ダンデライオン）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2646543',
          ItemCode: '4160800',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4904710425404',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: '99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 2200,
              DispValue2: 484000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５１'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '2',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 2200,
              DispValue2: 484000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５２'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５３'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '3',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５４'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５５'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '11',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）ステンレスミニボトル（ダンデライオン）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '1',
          Pcode: 'P2646550',
          ItemCode: '4160800',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4904710425404',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: '99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [
            {
              OrderCode: '2023160',
              CatalogId: '20230701',
              Status: '2',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 2200,
              DispValue2: 484000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５６'
            },
            {
              OrderCode: '2023170',
              CatalogId: '20230702',
              Status: '2',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 2200,
              DispValue2: 484000,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５７'
            },
            {
              OrderCode: '2023180',
              CatalogId: '20230703',
              Status: '1',
              PricePattern: '2',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５８'
            },
            {
              OrderCode: '2023190',
              CatalogId: '20230704',
              Status: '0',
              PricePattern: '3',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ５９'
            },
            {
              OrderCode: '2023200',
              CatalogId: '20230801',
              Status: '0',
              PricePattern: '',
              FeatureCode: '',
              SelectedOthers: '1',
              DispValue1: 1500,
              DispValue2: 151500,
              DelivStartDate: '20250101',
              CatalogMemo: '企画回メモ６０'
            },
          ],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '12',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）ＡＣハンディークリーナー',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646544',
          ItemCode: '4160819',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4975058524128',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '13',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）大風量ネックファン（ブラウン）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646545',
          ItemCode: '4160827',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4550454063107',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '14',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）コーヒーメーカー',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646546',
          ItemCode: '4160835',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4974305209009',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '15',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）防水形クロックラジオ',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646547',
          ItemCode: '4160843',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4560158872578',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '16',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）コードレススティッククリーナー',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646548',
          ItemCode: '4160851',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4549873111537',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '17',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: 'その他',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）紙パック式クリーナー',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646549',
          ItemCode: '4160878',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4549873087719',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '18',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: '家電小物',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）コードレス回転モップクリーナー　Ｎｅｏ＋（ブラック）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646964',
          ItemCode: '4165454',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4906064274097',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '19',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: '家電小物',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）コードレス回転モップクリーナー　Ｎｅｏ＋（ベージュ）',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646965',
          ItemCode: '4165462',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4906064274080',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 123456,
          PriceSum: 1245,
        },
        {
          MediumName: 'ハピデリ',
          MediumType: '001',
          ClassCode: '20',
          ClassName: '住関連',
          MiddleClassName: '電気小物',
          SmallClassName: '家電小物',
          CategoryTagId: '',
          CategoryTagName: 'タグ名',
          TagInfoList: [],
          GoodsName: 'ダ）タワーファン',
          StandardName: '当選は宅配便でお届け',
          SupplyTaxWithoutStd: 100,
          CostPriceStandard: 50,
          GprStd: "50%",
          SupplyTaxWithoutSpc1: 200,
          CostPriceSpecial1: 100,
          GprSpc1: "50%",
          SupplyTaxWithoutSpc2: 300,
          CostPriceSpecial2: 150,
          GprSpc2: "50%",
          AllCoop: '1',
          EnableSet: '0',
          Pcode: 'P2646966',
          ItemCode: '4165470',
          RelationPcode: '',
          CoopCode: '210',
          JanCode: '4571102091914',
          LargeClassName: 'バラエティ',
          PayeeClient: 'ＣＮ共同購入物流',
          OrderClient: 'ＣＮ共同購入物流',
          ApplyTermEnd: ' 99999999',
          ApplyTermStart: '20160101',
          GoodsMemo: '',
          CatalogInfoList: [],
          NumSum: 1234567890,
          PriceSum: 124567890,
        },
      ],
      TagSelectionInfo: [
        {
          ClassCode: "01",
          TagSelectionList: [
            {
              TagId: "00000001",
              TagName: "タグ1"
            }
          ]
        },
        {
          ClassCode: "02",
          TagSelectionList: [
            {
              TagId: "00000001",
              TagName: "タグ1"
            },
            {
              TagId: "00000002",
              TagName: "タグ2"
            },
          ]
        },
        {
          ClassCode: "03",
          TagSelectionList: [
            {
              TagId: "00000001",
              TagName: "タグ1"
            },
            {
              TagId: "00000002",
              TagName: "タグ2"
            },
            {
              TagId: "00000003",
              TagName: "タグ3"
            },
          ]
        },
        {
          ClassCode: "04",
          TagSelectionList: [
            {
              TagId: "00000001",
              TagName: "タグ1"
            },
            {
              TagId: "00000002",
              TagName: "タグ2"
            },
            {
              TagId: "00000003",
              TagName: "タグ3"
            },
            {
              TagId: "00000004",
              TagName: "タグ4"
            },
          ]
        }
      ]
    },
  }
};
// const getCycleItemInfoResponse = {
//   "status": "ok",
//   "message": "処理完了",
//   "result": {
//     "obj": [
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",
//         "TagInfoList": [],
//         "GoodsName": "かつお節（本枯節）",
//         "StandardName": "２本（４００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0017531",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0017531",
//         "JanCode": "4904825700212",
//         "LargeClassName": "乾物",
//         "PayeeClient": "カネソ２２",
//         "OrderClient": "カネソ２２",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "千葉県産寿司はね",
//         "StandardName": "板のり１０枚×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0051675",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0051675",
//         "JanCode": "4961873252001",
//         "LargeClassName": "乾物",
//         "PayeeClient": "金庄",
//         "OrderClient": "金庄",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "3",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           },
//           {
//             "TagId": "00000776",
//             "TagName": "ＳＰ"
//           }
//         ],
//         "GoodsName": "ひとくちこうや豆腐だし付き",
//         "StandardName": "８６ｇ（こうや豆腐５６ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0083771",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0083771",
//         "JanCode": "4902220279234",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "こうや豆腐玉子とじ用",
//         "StandardName": "７９ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0093416",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0093416",
//         "JanCode": "4902220272044",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "仙台麸（あぶら麸）",
//         "StandardName": "２本",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0095990",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0095990",
//         "JanCode": "4979803100117",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "四万十川の青のり",
//         "StandardName": "５ｇ×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0107514",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0107514",
//         "JanCode": "4972727200109",
//         "LargeClassName": "乾物",
//         "PayeeClient": "小善本店",
//         "OrderClient": "小善本店",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産あずき",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0113301",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0113301",
//         "JanCode": "4975282133172",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           },
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "たづくり",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0126683",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0126683",
//         "JanCode": "4903156031101",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマト食品株式会社",
//         "OrderClient": "ヤマト食品株式会社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "北海道冬島産　日高昆布（徳用）",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0179833",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0179833",
//         "JanCode": "4536657000026",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "駿河湾産無着色桜えび",
//         "StandardName": "７ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0206962",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0206962",
//         "JanCode": "4903156011196",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマト食品株式会社",
//         "OrderClient": "ヤマト食品株式会社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "お茶漬",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お茶づけ海苔５０袋",
//         "StandardName": "２３５ｇ（４．７ｇ×５０袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0263044",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0263044",
//         "JanCode": "4902388013053",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "きかんしゃトーマスふりかけ４種３２袋",
//         "StandardName": "７０．４ｇ（２．２ｇ×３２袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0336114",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0336114",
//         "JanCode": "4902184005467",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "朝からフルーツ　ミックス",
//         "StandardName": "１９０ｇ（固形量１００ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0571539",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0571539",
//         "JanCode": "4902560171069",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さけ（からふとます）水煮",
//         "StandardName": "９０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P0667765",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "0667765",
//         "JanCode": "4902165500776",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "瀬戸内海産　かたくちにぼし",
//         "StandardName": "１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1006916",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1006916",
//         "JanCode": "4975314555064",
//         "LargeClassName": "乾物",
//         "PayeeClient": "玉鈴",
//         "OrderClient": "玉鈴",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "ケーキシロップ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000833",
//             "TagName": "シロップ"
//           }
//         ],
//         "GoodsName": "メイプルシロップ１００％",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1009885",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1009885",
//         "JanCode": "4902220329823",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "だしはこれ（純にぼし粉）",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1036084",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1036084",
//         "JanCode": "4973411403011",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "みそ汁用こうや細ぎり",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1063979",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1063979",
//         "JanCode": "4902029108377",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000016",
//             "TagName": "味噌づくり"
//           }
//         ],
//         "GoodsName": "北海道産大豆",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1077201",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1077201",
//         "JanCode": "4975282132182",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あさ漬の素こんぶ風味",
//         "StandardName": "４ｇ×３０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1088831",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1088831",
//         "JanCode": "4901497472096",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "無着色　桜えび",
//         "StandardName": "１３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1096001",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1096001",
//         "JanCode": "4903156020808",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマト食品株式会社",
//         "OrderClient": "ヤマト食品株式会社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "伊勢志摩産あおさ",
//         "StandardName": "１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1099604",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1099604",
//         "JanCode": "4909531040201",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道十勝産　スイートコーンドライパック",
//         "StandardName": "１１０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1108832",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1108832",
//         "JanCode": "4902165616286",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000029",
//             "TagName": "朝食"
//           }
//         ],
//         "GoodsName": "しそ入りひじきふりかけ",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1152653",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1152653",
//         "JanCode": "4902371202549",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "松前漬の素（たれ付）",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1166344",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1166344",
//         "JanCode": "4972150070126",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "発芽玄米麹使用　あま酒",
//         "StandardName": "２３０ｇ（３人前）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1167758",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1167758",
//         "JanCode": "4970085022685",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産きんかんのはちみつ漬",
//         "StandardName": "２６０ｇ（固形量１３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1177729",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1177729",
//         "JanCode": "4976662607139",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ふりかけ詰合せ（４種）",
//         "StandardName": "２．５ｇ×４０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1189689",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1189689",
//         "JanCode": "4978574101927",
//         "LargeClassName": "乾物",
//         "PayeeClient": "山陽商事",
//         "OrderClient": "山陽商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "五穀ブレンド",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1222066",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1222066",
//         "JanCode": "4902571160601",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "春の七草",
//         "StandardName": "２．０ｇ（２～３人分）×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1245821",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1245821",
//         "JanCode": "4972530602039",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000029",
//             "TagName": "朝食"
//           }
//         ],
//         "GoodsName": "シナモン＆アップルジャム",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1256041",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1256041",
//         "JanCode": "4902220320141",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "象徴価値エリア",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "松山あげ　きざみ",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1269356",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1269356",
//         "JanCode": "4977247032353",
//         "LargeClassName": "乾物",
//         "PayeeClient": "風見（食品）",
//         "OrderClient": "風見（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お豆と雑穀ごはんの素",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1316435",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1316435",
//         "JanCode": "4902571287056",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "きざんだピクルス",
//         "StandardName": "１７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1356127",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1356127",
//         "JanCode": "4902220320356",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "卓上朝食のり緑（味のり）",
//         "StandardName": "８切４４枚（板のり５．５枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1359606",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1359606",
//         "JanCode": "4901673259541",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "丹波黒大豆（２Ｌ）",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1388215",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1388215",
//         "JanCode": "4903004110088",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カリフォルニアプルーンエキス",
//         "StandardName": "２８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1406892",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1406892",
//         "JanCode": "4902220320424",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "仕上がりぬか床　つかっ樽",
//         "StandardName": "２ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1413317",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1413317",
//         "JanCode": "4970085056178",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産甘夏みかん（身割れ）",
//         "StandardName": "１８５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P1417509",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "1417509",
//         "JanCode": "4967129102182",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "焼のりすしはね",
//         "StandardName": "板のり１０枚×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2009242",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2009242",
//         "JanCode": "4902122049508",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産レンゲ蜂蜜",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2027852",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2027852",
//         "JanCode": "4976662209012",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "6,8,10,1月",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "松前漬　たれ付",
//         "StandardName": "４０ｇたれ１２０ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2039958",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2039958",
//         "JanCode": "4901878003499",
//         "LargeClassName": "乾物",
//         "PayeeClient": "リアス",
//         "OrderClient": "リアス",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "丹波篠山　大納言小豆",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2048167",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2048167",
//         "JanCode": "4908549020038",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "松前漬の素（貝柱・タレ付）",
//         "StandardName": "７１ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2060051",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2060051",
//         "JanCode": "4972150072298",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "卓上朝食のり緑（味のり）",
//         "StandardName": "８切４４枚×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2064618",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2064618",
//         "JanCode": "4901673259558",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "瀬戸内海産　無着色小えび",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2115549",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2115549",
//         "JanCode": "4902220281787",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おいしい雑穀十五穀",
//         "StandardName": "２０ｇ×１０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2144891",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2144891",
//         "JanCode": "4902220000227",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "黒米（国内産）",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2162377",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2162377",
//         "JanCode": "4902220001101",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "おにぎり具材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ゆかり",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2172143",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2172143",
//         "JanCode": "4902765302220",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手造り佃煮（黒酢たれ）",
//         "StandardName": "９３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2183161",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2183161",
//         "JanCode": "4904825208985",
//         "LargeClassName": "乾物",
//         "PayeeClient": "カネソ２２",
//         "OrderClient": "カネソ２２",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーツミックス",
//         "StandardName": "１９０ｇ（固形量１１０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2183188",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2183188",
//         "JanCode": "4902220310883",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "無着色　干しえび",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2196034",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2196034",
//         "JanCode": "4903156020587",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマト食品株式会社",
//         "OrderClient": "ヤマト食品株式会社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "のりたま",
//         "StandardName": "２．５ｇ×４０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2200465",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2200465",
//         "JanCode": "4978574101019",
//         "LargeClassName": "乾物",
//         "PayeeClient": "山陽商事",
//         "OrderClient": "山陽商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "十勝産スイートコーン　〈ホールカーネル〉",
//         "StandardName": "１８０ｇ（固形量１２５ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2200473",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2200473",
//         "JanCode": "4902220310821",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "十勝産スイートコーン　〈うらごしタイプ〉",
//         "StandardName": "１８０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2200481",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2200481",
//         "JanCode": "4902220310852",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "無漂白寒天",
//         "StandardName": "２本入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2207052",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2207052",
//         "JanCode": "4971889120010",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お釜にポン　小粒",
//         "StandardName": "２．１ｇ×５５粒",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2227282",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2227282",
//         "JanCode": "4902220002221",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000841",
//             "TagName": "その他"
//           }
//         ],
//         "GoodsName": "かんてんパウダー",
//         "StandardName": "２ｇ×１６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2228858",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2228858",
//         "JanCode": "4902220281930",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "高千穂郷産　乾しいたけどんこ",
//         "StandardName": "３８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2245590",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2245590",
//         "JanCode": "4902220271115",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "高千穂郷産　乾しいたけ無選別",
//         "StandardName": "３８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2245604",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2245604",
//         "JanCode": "4902220271092",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "信州はるさめ",
//         "StandardName": "１５０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2252899",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2252899",
//         "JanCode": "4901617128216",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "十六穀ごはん",
//         "StandardName": "３０ｇ×１５袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2254018",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2254018",
//         "JanCode": "4902571160878",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道十勝産　小豆",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2255456",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2255456",
//         "JanCode": "4904655215009",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "島根県産　唐がらし",
//         "StandardName": "１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2255820",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2255820",
//         "JanCode": "4975825998350",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "発芽玄米と八穀ごはん",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2260972",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2260972",
//         "JanCode": "4902571286325",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "宮城県産　ひたし豆",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2261111",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2261111",
//         "JanCode": "4904655262003",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お赤飯の素　国内産ささげ豆",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2261138",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2261138",
//         "JanCode": "4904655101012",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000841",
//             "TagName": "その他"
//           }
//         ],
//         "GoodsName": "スープ用糸寒天",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2269066",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2269066",
//         "JanCode": "4901138886145",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "プリン用タブレット",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2270145",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2270145",
//         "JanCode": "4964348431598",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "風見（食品）",
//         "OrderClient": "風見（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "焼のり",
//         "StandardName": "板のり１０枚×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2271915",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2271915",
//         "JanCode": "4902220282197",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000069",
//             "TagName": "節分"
//           }
//         ],
//         "GoodsName": "焼のり寿司はね",
//         "StandardName": "板のり１０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2271923",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2271923",
//         "JanCode": "4902220282333",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食べるごま（しょうゆ味）",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2273926",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2273926",
//         "JanCode": "4902220271283",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "皮むきいりごま",
//         "StandardName": "８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2273934",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2273934",
//         "JanCode": "4902220271276",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000029",
//             "TagName": "朝食"
//           }
//         ],
//         "GoodsName": "シナモン＆アップルジャム",
//         "StandardName": "２６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2274906",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2274906",
//         "JanCode": "4902220321094",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "象徴価値エリア",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000016",
//             "TagName": "味噌づくり"
//           }
//         ],
//         "GoodsName": "手づくり味噌用　麹（こうじ）",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2282828",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2282828",
//         "JanCode": "4902955005122",
//         "LargeClassName": "乾物",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のいちじくジャム",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2286645",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2286645",
//         "JanCode": "4902220321087",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本の檸檬マーマレード",
//         "StandardName": "１９５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2286653",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2286653",
//         "JanCode": "4902220321070",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           },
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "北海道産　するめ",
//         "StandardName": "２枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2296101",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2296101",
//         "JanCode": "4972150070287",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           },
//           {
//             "TagId": "00000854",
//             "TagName": "とちぎ・ぐ・な・に"
//           }
//         ],
//         "GoodsName": "きゅうりの辛子漬",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2302012",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2302012",
//         "JanCode": "4902487082110",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "四国産ゆず皮（フリーズドライ）",
//         "StandardName": "４ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2303477",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2303477",
//         "JanCode": "4972530804310",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "丹波黒大豆　極大粒",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2310511",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2310511",
//         "JanCode": "4907129100191",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "茹でずに使える緑豆春雨",
//         "StandardName": "１２０ｇ（１５ｇ×８）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2315912",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2315912",
//         "JanCode": "4526983000180",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産はるさめ",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2320584",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2320584",
//         "JanCode": "4904081203458",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000258",
//             "TagName": "ぐんま"
//           },
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "車麸",
//         "StandardName": "６枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2327228",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2327228",
//         "JanCode": "4977687060831",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "パントッピング",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ツナ・マヨネーズ風味",
//         "StandardName": "５０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2327244",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2327244",
//         "JanCode": "4902220311484",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産　名撰十六穀",
//         "StandardName": "３０ｇ×６袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2333481",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2333481",
//         "JanCode": "4902571287735",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "紫峰あわ漬",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2334305",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2334305",
//         "JanCode": "4965249700110",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産フルーツみつ豆",
//         "StandardName": "２０５ｇ（固形量１４０ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2351919",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2351919",
//         "JanCode": "4901133928239",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "ミニ",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産　虎豆",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2357526",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2357526",
//         "JanCode": "4904655292000",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お釜にポン",
//         "StandardName": "４．６ｇ×５０粒×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2359499",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2359499",
//         "JanCode": "4902220003181",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "切干大根（人参ミックス）",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2369192",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2369192",
//         "JanCode": "4902220271757",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "切干大根",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2369214",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2369214",
//         "JanCode": "4902220271450",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "塩吹昆布",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2378124",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2378124",
//         "JanCode": "4902220282593",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "菌茸類の缶詰",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "国産ぎんなん水煮",
//         "StandardName": "８５ｇ（固形量５５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2384000",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2384000",
//         "JanCode": "4901592886910",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実実感　つぶつぶブルーベリージャム",
//         "StandardName": "３４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2500421",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2504944",
//         "JanCode": "4902701901647",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "愛媛県産　和栗甘露煮",
//         "StandardName": "１３０ｇ（固形量６５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2501470",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2517868",
//         "JanCode": "4901592887245",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産きくらげ",
//         "StandardName": "１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2501666",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2520095",
//         "JanCode": "4970310033707",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000839",
//             "TagName": "ぜんざい"
//           }
//         ],
//         "GoodsName": "甘さすっきりのおしるこ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2502044",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2524376",
//         "JanCode": "4901011600684",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000841",
//             "TagName": "その他"
//           }
//         ],
//         "GoodsName": "スープ・サラダ用　糸寒天",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2503957",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2546698",
//         "JanCode": "4902220282821",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "そのまま食べられるのりカップ",
//         "StandardName": "２４枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2504338",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2551098",
//         "JanCode": "4560331900074",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実実感　ざくざくオレンジマーマレード",
//         "StandardName": "３４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2504637",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2554372",
//         "JanCode": "4902701901654",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産天草使用　黒みつ豆寒天",
//         "StandardName": "２３０ｇ（固形量１３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2505436",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2564076",
//         "JanCode": "4901688217307",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "水煮大豆",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2505437",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2564084",
//         "JanCode": "4901033725297",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "瀬戸内海産　無着色　小えび",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2505589",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2565757",
//         "JanCode": "4902220282791",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "マンナンヒカリ（通販用）",
//         "StandardName": "１．５ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2505980",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2570114",
//         "JanCode": "4901150530125",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "オニザキのつきごま白",
//         "StandardName": "８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2507053",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2582317",
//         "JanCode": "4947303117003",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "オニザキのつきごま黒",
//         "StandardName": "８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2507054",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2582325",
//         "JanCode": "4947303117102",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "オニザキのつきごま金",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2507055",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2582333",
//         "JanCode": "4947303117201",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "ケーキシロップ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000833",
//             "TagName": "シロップ"
//           }
//         ],
//         "GoodsName": "モンファボリ　メープルシロップ",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2507937",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2592266",
//         "JanCode": "4936790133412",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "発芽玄米　あきたこまち",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2508680",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2600625",
//         "JanCode": "4902220003617",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "姿やきのり金（有明海産）",
//         "StandardName": "板のり１０枚×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2508887",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2602903",
//         "JanCode": "4901673495536",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           },
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "北海道根室産　棹前早煮昆布",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2508890",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2602946",
//         "JanCode": "4972150901949",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "北海道白口浜産　函館真昆布",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2510021",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2615630",
//         "JanCode": "4972150900584",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "マッシュルーム缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産マッシュルーム　まるごとスライス",
//         "StandardName": "１３０ｇ（固形量７５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2510066",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2616122",
//         "JanCode": "4901605421343",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "信州味噌漬の素（一夜漬の素）",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2510498",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2620979",
//         "JanCode": "4902713119351",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さけ（からふとます）水煮",
//         "StandardName": "１８０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2511140",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2628295",
//         "JanCode": "4902165511840",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産の果実をつかったネーブルオレンジのマーマレード",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2511987",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2637642",
//         "JanCode": "4902220320943",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "アンパンマンのこうや豆腐",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2513364",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2653370",
//         "JanCode": "4902220271917",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "マロニーちゃん（スタンダードタイプ）",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2514071",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2661276",
//         "JanCode": "4902902303004",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "卓上パック　味付韓国産のり",
//         "StandardName": "８切４８枚（全形６枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2514872",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2670607",
//         "JanCode": "4902220283088",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごましお",
//         "StandardName": "４５ｇ（３ｇ×１５本）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2514988",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2671883",
//         "JanCode": "4902820010787",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "切らずに使える　国産はるさめ",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2514990",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2671905",
//         "JanCode": "4902220271955",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000059",
//             "TagName": "中華アジアン"
//           }
//         ],
//         "GoodsName": "卓上パック　味付韓国産のり",
//         "StandardName": "８切４８枚×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2515074",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2672820",
//         "JanCode": "4902220283101",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "焼のり　おにぎり・おもち用",
//         "StandardName": "３切５０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2516003",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2683229",
//         "JanCode": "4978250204010",
//         "LargeClassName": "乾物",
//         "PayeeClient": "小善本店",
//         "OrderClient": "小善本店",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ドラえもんふりかけお得な３２袋入り",
//         "StandardName": "２．２ｇ×３２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2516379",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2687461",
//         "JanCode": "4902184051419",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "熊本産　甘夏",
//         "StandardName": "２９５ｇ（固形量１６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2517250",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2697173",
//         "JanCode": "4967129102205",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "シーズンパック",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実実感　ぷちぷちキウイフルーツジャム",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2518244",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2708213",
//         "JanCode": "0000049806809",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "鬼からし漬の素きゅうり用",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2519439",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2721600",
//         "JanCode": "4903016082120",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手間いらずお赤飯",
//         "StandardName": "２合用",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2519440",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2721619",
//         "JanCode": "4904655101302",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "北海道十勝産小豆使用　つぶあん",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2520853",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2737485",
//         "JanCode": "4902220272082",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "北海道十勝産小豆使用　こしあん",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2520854",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2737493",
//         "JanCode": "4902220272099",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000839",
//             "TagName": "ぜんざい"
//           }
//         ],
//         "GoodsName": "十勝産小豆のぜんざい",
//         "StandardName": "１６０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2520855",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2737507",
//         "JanCode": "4902220302765",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "京小花麩",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2523566",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2767899",
//         "JanCode": "4970733101007",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "無漂白かんぴょう",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2523973",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2772531",
//         "JanCode": "4902220272143",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道十勝産大正金時",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2524045",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2773333",
//         "JanCode": "4901632905670",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食塩無添加コーン",
//         "StandardName": "２００ｇ（固形量１５５ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2524631",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2779978",
//         "JanCode": "4901133966040",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2020年共同仕入れ・4・5・11・12",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "日光白たまり漬けの素",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2524672",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2780410",
//         "JanCode": "4975290417301",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手巻きかつお",
//         "StandardName": "４ツ切５枚入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2525210",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2786427",
//         "JanCode": "4902381006731",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           },
//           {
//             "TagId": "00000841",
//             "TagName": "その他"
//           }
//         ],
//         "GoodsName": "押麦",
//         "StandardName": "８００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2525253",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2786893",
//         "JanCode": "4902220003976",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000841",
//             "TagName": "その他"
//           }
//         ],
//         "GoodsName": "米粒状麦",
//         "StandardName": "８００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2525258",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2786958",
//         "JanCode": "4902220003969",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産豆１００％食塩無添加ミックスビーンズ",
//         "StandardName": "５０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2526361",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2799553",
//         "JanCode": "4901133427442",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産みかん",
//         "StandardName": "１４０ｇ（固形量８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2527383",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2811227",
//         "JanCode": "4901605341443",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "シーズンパック",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000133",
//             "TagName": "価値コマ"
//           }
//         ],
//         "GoodsName": "北海道冬島産　日高昆布（カットタイプ）",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2528421",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2822938",
//         "JanCode": "4536657000231",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ババロリア　バニラ味",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2529487",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2834928",
//         "JanCode": "4901138880563",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ポクポク蒸かし豆　大正金時豆",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2529621",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2836661",
//         "JanCode": "4901489500035",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "塩糀",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2529645",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2836939",
//         "JanCode": "4901141123077",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000029",
//             "TagName": "朝食"
//           },
//           {
//             "TagId": "00000034",
//             "TagName": "弁当"
//           },
//           {
//             "TagId": "00000101",
//             "TagName": "お魚食べよう"
//           }
//         ],
//         "GoodsName": "ご飯にかけるいわし削りぶし",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2529726",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2837846",
//         "JanCode": "4973591490566",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "プラス糀　生塩糀",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2530173",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2843005",
//         "JanCode": "4902713125932",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000225",
//             "TagName": "いばらき"
//           },
//           {
//             "TagId": "00000258",
//             "TagName": "ぐんま"
//           }
//         ],
//         "GoodsName": "紫峰あわ漬",
//         "StandardName": "１０００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2530866",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2850923",
//         "JanCode": "4965249700509",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おいしい雑穀　十五穀　増量品",
//         "StandardName": "１０袋（２０ｇ×１０袋）＋１袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2531152",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2854317",
//         "JanCode": "4902220003761",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産豆１００％食塩無添加ミックスビーンズ",
//         "StandardName": "５０ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2531326",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2856328",
//         "JanCode": "4901133245190",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産天草使用　抹茶豆寒天",
//         "StandardName": "２３０ｇ（固形量１３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2532483",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2869144",
//         "JanCode": "4901688217314",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           },
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "いりぬか",
//         "StandardName": "４ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2532995",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2874830",
//         "JanCode": "4902939010791",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産小豆使用ゆであずき",
//         "StandardName": "１２０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2533556",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2881128",
//         "JanCode": "4902220300112",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産春の七草（きざみ）",
//         "StandardName": "４ｇ（２ｇ×２袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2533657",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2882213",
//         "JanCode": "4513569000207",
//         "LargeClassName": "乾物",
//         "PayeeClient": "風見（食品）",
//         "OrderClient": "風見（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産みつば",
//         "StandardName": "２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2533658",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2882221",
//         "JanCode": "4902703037184",
//         "LargeClassName": "乾物",
//         "PayeeClient": "風見（食品）",
//         "OrderClient": "風見（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "＜新海苔＞有明産　初づみ焼のり",
//         "StandardName": "板のり１０枚×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2533840",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2884291",
//         "JanCode": "4541044312200",
//         "LargeClassName": "乾物",
//         "PayeeClient": "山陽商事",
//         "OrderClient": "山陽商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000003",
//             "TagName": "低脂肪"
//           }
//         ],
//         "GoodsName": "脂肪の少ないコンビーフ",
//         "StandardName": "８０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2534657",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2893657",
//         "JanCode": "4902701906154",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごま工房　味付ごま　しょうゆ味",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2535222",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2900173",
//         "JanCode": "4901155319343",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000839",
//             "TagName": "ぜんざい"
//           }
//         ],
//         "GoodsName": "ぜんざい　十勝産あずき１００％使用",
//         "StandardName": "１人前（１６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2535308",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2901129",
//         "JanCode": "4901605512102",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ババロリア　ストロベリー味　フルーツソース付",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2536247",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2911604",
//         "JanCode": "4901138880570",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000003",
//             "TagName": "低脂肪"
//           }
//         ],
//         "GoodsName": "ノザキの脂肪分５０％カットコンビーフ",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2536310",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2912309",
//         "JanCode": "4902161610363",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あんずジャム（プレザーブスタイル）",
//         "StandardName": "５３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2537119",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2921340",
//         "JanCode": "4972829150197",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "浅漬けの素　レギュラー",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2537860",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2929767",
//         "JanCode": "4901108005316",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "やきとり　とりたま　たれ味",
//         "StandardName": "９０ｇ（固形量６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2537980",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2931389",
//         "JanCode": "4902511009465",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃん　小いか醤油煮",
//         "StandardName": "１５０ｇ（固形量７５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2537983",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2931419",
//         "JanCode": "4953009112815",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しじみ醤油味付のり１００",
//         "StandardName": "１２切１００枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2539066",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2943441",
//         "JanCode": "4901191231029",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "愛知県産ちりめん",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2539493",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2948303",
//         "JanCode": "4903156031095",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマト食品株式会社",
//         "OrderClient": "ヤマト食品株式会社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あさ漬の素　かつお風味",
//         "StandardName": "３２ｇ（４ｇ×８本）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2539510",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2948494",
//         "JanCode": "4901497472287",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あっさりなす漬の素（徳用）",
//         "StandardName": "１００ｇ（２０ｇ×５袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2539815",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2951932",
//         "JanCode": "4954797000650",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ふっくらあずき水煮（砂糖不使用）",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2539982",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2953765",
//         "JanCode": "4902553043090",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あんみつ　黒みつ・あずきあん付き",
//         "StandardName": "２５５ｇ（固形量１６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2539992",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2953889",
//         "JanCode": "4901605514106",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "みつ豆　黒みつ付き",
//         "StandardName": "２２５ｇ（固形量１３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2539993",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2953897",
//         "JanCode": "4901605514113",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "粒あん入り　宇治抹茶のデザート",
//         "StandardName": "２８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2540787",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2962829",
//         "JanCode": "4970249000566",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ゆであずき　甘さひかえめ",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2541285",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2968622",
//         "JanCode": "4902557021582",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "国産海藻サラダ",
//         "StandardName": "１２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542098",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2977842",
//         "JanCode": "4974601012563",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お徳用　食べちゃう寒天",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542100",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2977869",
//         "JanCode": "4971889120683",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "熟成ぬか床",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542119",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2978091",
//         "JanCode": "4954797000759",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "牛肉大和煮",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "牛肉大和煮",
//         "StandardName": "９０ｇ（固形量５５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542196",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2978997",
//         "JanCode": "4902701389513",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "パインアップル缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひとくちカットパインアップル　厚切り",
//         "StandardName": "４２５ｇ（固形量２７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542253",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2979624",
//         "JanCode": "4901605313419",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "岩手県宮古地区産　早採りカットわかめ",
//         "StandardName": "１４ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542352",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2980711",
//         "JanCode": "4952952000828",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国太楼",
//         "OrderClient": "国太楼",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あんこ・黒みつ入り　あんみつ",
//         "StandardName": "３３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542429",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2981556",
//         "JanCode": "4970249000542",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           },
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "みやここうじ",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542897",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2986957",
//         "JanCode": "4970085018732",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産一番摘原料使用焼のり",
//         "StandardName": "板のり１０枚×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542905",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2987058",
//         "JanCode": "4902122046828",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "岩手産　やわらか糸こんぶ",
//         "StandardName": "１４ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542909",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2987090",
//         "JanCode": "4952952000811",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国太楼",
//         "OrderClient": "国太楼",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産ブルーベリーのジャム",
//         "StandardName": "４３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2542921",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2987236",
//         "JanCode": "4908010734280",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大戸屋もちもちした食感の五穀ご飯",
//         "StandardName": "３０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2543200",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2990377",
//         "JanCode": "4902571162179",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000225",
//             "TagName": "いばらき"
//           },
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "紫峰ぬか漬",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2543440",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2993066",
//         "JanCode": "4965249610112",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道雑穀十二種ブレンド",
//         "StandardName": "２５ｇ×７袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2543512",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "2993856",
//         "JanCode": "4900390703733",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海一番摘み焼海苔＜焼きたて配達！＞",
//         "StandardName": "全形８枚×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2544257",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3002284",
//         "JanCode": "4541044340104",
//         "LargeClassName": "乾物",
//         "PayeeClient": "山陽商事",
//         "OrderClient": "山陽商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "黒ごまクリーム",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2544385",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3003671",
//         "JanCode": "4902220321681",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "きな粉クリーム",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2544388",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3003728",
//         "JanCode": "4902220321711",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はごろもシーチキン　マイルド",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2544391",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3003752",
//         "JanCode": "4902220312917",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ヨーグルトで食べようナタデココ（パウチ）",
//         "StandardName": "１５０ｇ（固形量５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2544419",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3004244",
//         "JanCode": "4901605803033",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ヨーグルトで食べようアロエ（パウチ）",
//         "StandardName": "１５０ｇ（固形量５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2544420",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3004252",
//         "JanCode": "4901605803002",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はごろもシーチキン　Ｌフレーク",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2545729",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3019470",
//         "JanCode": "4902220312924",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "「くだもの王国」ふくしまの白桃",
//         "StandardName": "４２５ｇ（固形量２５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2545740",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3019594",
//         "JanCode": "4571296574019",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "シーズンパック",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイーツつくろ！カスタードクリームミックス〈チャック付〉",
//         "StandardName": "８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2546256",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3025306",
//         "JanCode": "4902170094499",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "オイルサーディン",
//         "StandardName": "１０５ｇ（固形量７５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2547312",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3037339",
//         "JanCode": "4902560044264",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "釧路のいわし　味付",
//         "StandardName": "１５０ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2547384",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3038122",
//         "JanCode": "4962528042046",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しまじろうふりかけミニパック",
//         "StandardName": "２２袋入（４種）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2547934",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3044319",
//         "JanCode": "4902820120325",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食塩無添加ライトツナフレークノンオイル",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2548525",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3050939",
//         "JanCode": "4901133884900",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食塩無添加ライトツナフレークノンオイル",
//         "StandardName": "７０ｇ×２４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2548526",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3050947",
//         "JanCode": "4901133061516",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カナダ産純粋はちみつ",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2548527",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3050955",
//         "JanCode": "4901390178767",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "小容量",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2548538",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3051080",
//         "JanCode": "4902220311323",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "いつでも",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さばみそ煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2548539",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3051099",
//         "JanCode": "4902220311347",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さけ（からふとます）水煮",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2549475",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3061507",
//         "JanCode": "4902165335620",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2549492",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3061698",
//         "JanCode": "4902150109915",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000063",
//             "TagName": "かさばる物"
//           },
//           {
//             "TagId": "00000113",
//             "TagName": "重たいもの"
//           }
//         ],
//         "GoodsName": "ライトツナフレーク　スーパーノンオイル",
//         "StandardName": "７０ｇ×２４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2549578",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3062694",
//         "JanCode": "4901133061509",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000063",
//             "TagName": "かさばる物"
//           },
//           {
//             "TagId": "00000113",
//             "TagName": "重たいもの"
//           }
//         ],
//         "GoodsName": "ライトツナフレーク　スーパーノンオイル",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2549579",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3062708",
//         "JanCode": "4901133884825",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "植物性ゼリーの素　コープアガー",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2549993",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3067521",
//         "JanCode": "4902220283743",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "仙台麸（あぶら麸）スライス",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2550073",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3068412",
//         "JanCode": "4979803110109",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サンヨーおかず缶セット",
//         "StandardName": "６種各２缶入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2550136",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3069117",
//         "JanCode": "4901605111107",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "防災",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "信州産　紅玉りんごジャム",
//         "StandardName": "２１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2550189",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3069699",
//         "JanCode": "4906525232079",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "粒あんとクリームで食べるさくらのデザート",
//         "StandardName": "２８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2550320",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3071146",
//         "JanCode": "4970249000573",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "わかめふりかけ（鮭入り）",
//         "StandardName": "４５ｇ×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2550725",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3075621",
//         "JanCode": "4902220283903",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "わかめふりかけ（しらす入り）",
//         "StandardName": "３５ｇ×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2550726",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3075648",
//         "JanCode": "4902220283880",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "信州寒天サラダ",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2551070",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3080560",
//         "JanCode": "4971889120102",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "やきとり　柚子こしょう味",
//         "StandardName": "７０ｇ（固形量５５ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2551179",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3081834",
//         "JanCode": "4902511008604",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産大豆使用ひとくちこうや豆腐（粉末だし３袋付）",
//         "StandardName": "８６ｇ（こうや豆腐５６ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2552057",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3091732",
//         "JanCode": "4902220272402",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキの和風コンビーフ",
//         "StandardName": "７５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2552409",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3095606",
//         "JanCode": "4902161610455",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　１０種ミックス（豆と穀物）",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2552420",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3095738",
//         "JanCode": "4901577046858",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "のりあーと　さくら",
//         "StandardName": "板のり１．２５枚（２０枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2552648",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3098249",
//         "JanCode": "4972727500759",
//         "LargeClassName": "乾物",
//         "PayeeClient": "小善本店",
//         "OrderClient": "小善本店",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しらす入り味付海苔",
//         "StandardName": "１０切２０枚（板のり２枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2552847",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3100421",
//         "JanCode": "4901673254645",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "塩こうじ",
//         "StandardName": "２３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553196",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3104516",
//         "JanCode": "4902401507590",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナフレーク　オイル無添加",
//         "StandardName": "７０ｇ×２４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553348",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3106187",
//         "JanCode": "4902220313105",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まぐろフレーク味付",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553395",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3106705",
//         "JanCode": "4901901096252",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "うずら卵水煮",
//         "StandardName": "１０個",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553399",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3106756",
//         "JanCode": "4906336008115",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "黒ゴマクリーム",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553400",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3106764",
//         "JanCode": "4974434900341",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "マンゴーチャンク",
//         "StandardName": "２３４ｇ（固形量１３９ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553402",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3106780",
//         "JanCode": "4935850102184",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つまスモーク　かき",
//         "StandardName": "５０ｇ（固形量３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553421",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3106993",
//         "JanCode": "4901592905475",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つま　スモーク　鮭ハラス",
//         "StandardName": "５０ｇ（固形量３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553422",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3107000",
//         "JanCode": "4901592905413",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　愛媛県産真穴（まあな）みかん",
//         "StandardName": "１９０ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553439",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3107183",
//         "JanCode": "4901592905109",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "フレッシュ限定",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "黒みつ入りくずきり",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553729",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3110389",
//         "JanCode": "4970249000559",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "瀬戸内産食べるいりこ",
//         "StandardName": "１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2553732",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3110419",
//         "JanCode": "4971717205025",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "なすのわさび漬けの素",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2554398",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3118169",
//         "JanCode": "4904621050788",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "植物性ゼリーの素　コープアガー　分包タイプ",
//         "StandardName": "８ｇ×６袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2554582",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3120201",
//         "JanCode": "4902220283842",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナフレーク　まぐろ油漬",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2554884",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3123758",
//         "JanCode": "4901901084266",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナフレーク　かつお油漬",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2554916",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3124118",
//         "JanCode": "4901901084303",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あま酒　雪っ子",
//         "StandardName": "３５０ｇ（濃縮５人前）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2555850",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3134806",
//         "JanCode": "4970085028724",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産みかん",
//         "StandardName": "３５０ｇ（固形量２０５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2555874",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3135136",
//         "JanCode": "4902560110235",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナフレーク　まぐろ油漬",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2555884",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3135233",
//         "JanCode": "4902220313174",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーチキン炙りとろ",
//         "StandardName": "７５ｇ（固形量５５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2555893",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3135330",
//         "JanCode": "4902560009911",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトフレーク　かつお油漬フレーク",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2556866",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3146359",
//         "JanCode": "4972195079627",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "花の真珠　国産純粋はちみつ　みかん",
//         "StandardName": "１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2556908",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3146812",
//         "JanCode": "4973882121711",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "埼玉養蜂",
//         "OrderClient": "埼玉養蜂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "のりあーと　ハロウィン",
//         "StandardName": "板のり１枚（１６枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2556962",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3147428",
//         "JanCode": "4972727500773",
//         "LargeClassName": "乾物",
//         "PayeeClient": "小善本店",
//         "OrderClient": "小善本店",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お新香　三五八",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2557484",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3153487",
//         "JanCode": "4902674000064",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "デコふり　楽しい６色入り　たまご風味",
//         "StandardName": "１８ｇ（３ｇ×６袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2557517",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3153843",
//         "JanCode": "4902560414425",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "ケーキシロップ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "バンホーテン　チョコレートシロップ業務用",
//         "StandardName": "６３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2557711",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3156206",
//         "JanCode": "4901305405582",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　山形県産黄桃（黄金桃）",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2557762",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3156753",
//         "JanCode": "4901592905147",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "フレッシュ限定",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "江戸前サラダ海苔（味付のり）",
//         "StandardName": "１２切５枚１８束",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558246",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3162281",
//         "JanCode": "4969570110549",
//         "LargeClassName": "乾物",
//         "PayeeClient": "千葉県漁連",
//         "OrderClient": "千葉県漁連",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "乾燥おから",
//         "StandardName": "４８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558387",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3163881",
//         "JanCode": "4902524222349",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000061",
//             "TagName": "ストック"
//           }
//         ],
//         "GoodsName": "さばみそ煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558741",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3168158",
//         "JanCode": "4901901145691",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さけ（からふとます）細肉（ほそにく）水煮",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558745",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3168190",
//         "JanCode": "4902165301731",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さけ（からふとます）水煮",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558746",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3168204",
//         "JanCode": "4902165300062",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　いちご",
//         "StandardName": "２５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558789",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3168735",
//         "JanCode": "4562452230016",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　ブルーベリー",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558790",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3168743",
//         "JanCode": "4562452230047",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　マンゴー",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558791",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3168751",
//         "JanCode": "4562452230054",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "ごまあえの素",
//         "StandardName": "２５ｇ×３袋入り",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558906",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3170047",
//         "JanCode": "4902220507641",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産ひじき使用　白和えの素",
//         "StandardName": "豆腐一丁用　５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2558907",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3170055",
//         "JanCode": "4902220283828",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2559102",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3172244",
//         "JanCode": "4901901145714",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ポークランチョンミート",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2559103",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3172252",
//         "JanCode": "5762385162425",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "信州産あんずジャム",
//         "StandardName": "２１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2559104",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3172260",
//         "JanCode": "4906525222124",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "液体塩こうじ",
//         "StandardName": "３５０ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2559383",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3175650",
//         "JanCode": "4902401507514",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "つけものたまり",
//         "StandardName": "１ｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2559577",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3177890",
//         "JanCode": "4955120040138",
//         "LargeClassName": "乾物",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000061",
//             "TagName": "ストック"
//           }
//         ],
//         "GoodsName": "さばみそ煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ×２４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2560380",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3186881",
//         "JanCode": "4901901145691",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　白桃",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2560381",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3186903",
//         "JanCode": "4562452230023",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮",
//         "StandardName": "１９０ｇ×２４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2561464",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3199142",
//         "JanCode": "4901901145714",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "月花（つきはな）さば水煮",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2561471",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3199215",
//         "JanCode": "4901901145899",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "おにぎり具材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付おかか",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2561499",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3199525",
//         "JanCode": "4902381909360",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ピーナッツバター　スーパーチャンク",
//         "StandardName": "３４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2561582",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3200728",
//         "JanCode": "0037600112314",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　あんず",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2562396",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3210006",
//         "JanCode": "4562452230030",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "信州産川中島白桃ジャム",
//         "StandardName": "２１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2562400",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3210049",
//         "JanCode": "4906525291502",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "毎日サラダ　ミックスビーンズ",
//         "StandardName": "１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2562412",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3210189",
//         "JanCode": "4901133245305",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "発色剤無添加コンビーフハッシュ",
//         "StandardName": "６３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2562426",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3210332",
//         "JanCode": "4960801009229",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "沖縄県物産公社",
//         "OrderClient": "沖縄県物産公社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "雑穀クッキングクラブもち黒米",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2562452",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3210626",
//         "JanCode": "4902571287827",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産二十八穀",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2562746",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3213986",
//         "JanCode": "4978645516599",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ポケモン　きりぬきのり",
//         "StandardName": "全型１枚（４切４枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2563087",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3217981",
//         "JanCode": "4902820918175",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "南半球ブレンド純粋はちみつ",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2563344",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3221016",
//         "JanCode": "4973882114256",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "埼玉養蜂",
//         "OrderClient": "埼玉養蜂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "毎日サラダ　食塩無添加ミックスビーンズ",
//         "StandardName": "１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2563348",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3221059",
//         "JanCode": "4901133245299",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "タイムセール",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　熊本県産でこぽん",
//         "StandardName": "１８５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2563350",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3221075",
//         "JanCode": "4901592905178",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サンヨー飯缶セット　牛めし・とりめし・五目めし",
//         "StandardName": "各３缶入（１８５ｇ×９）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2563355",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3221121",
//         "JanCode": "4901605520466",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "防災",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーチキンＬ",
//         "StandardName": "１４０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2563359",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3221172",
//         "JanCode": "4902560015028",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "牛乳寒天の素",
//         "StandardName": "１００ｇ×３袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564006",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3231097",
//         "JanCode": "4901138884363",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産もち麦",
//         "StandardName": "２８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564021",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3231259",
//         "JanCode": "4994790310677",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "パインアップル缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "厚切りパイン　一口カット",
//         "StandardName": "１３０ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564108",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3232379",
//         "JanCode": "4902220313532",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "1",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーツミックス",
//         "StandardName": "１３０ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564110",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3232395",
//         "JanCode": "4902220313457",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産みかん",
//         "StandardName": "１４０ｇ（固形量８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564112",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3232417",
//         "JanCode": "4902220313518",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "1",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　１０種ミックス（豆と穀物）",
//         "StandardName": "４０ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564239",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3233804",
//         "JanCode": "4901577046858",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "パインアップル缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "厚切りパイン　ひとくちカット",
//         "StandardName": "２２７ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564312",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3234622",
//         "JanCode": "4901605313389",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　熊本県産甘夏みかん",
//         "StandardName": "１８５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564366",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3235211",
//         "JanCode": "4901592905185",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱　割り身",
//         "StandardName": "６５ｇ（固形量４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564385",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3235424",
//         "JanCode": "4901901267195",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ピーナツあえの素",
//         "StandardName": "４８ｇ（８ｇ×６）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564673",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3238679",
//         "JanCode": "4902765403545",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごまあえの素",
//         "StandardName": "４８ｇ（８ｇ×６）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564674",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3238687",
//         "JanCode": "4902765402548",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産十六穀米　業務用",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564680",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3238741",
//         "JanCode": "4953575125387",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごま一粒一粒に味をつけたごましお",
//         "StandardName": "３８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2564971",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3242056",
//         "JanCode": "4902820106107",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "熟成ぬか床パック",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2565138",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3243893",
//         "JanCode": "4902220272587",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いか味付",
//         "StandardName": "１５５ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2565205",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3244636",
//         "JanCode": "4901901371564",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキのコンビーフ",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2565244",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3245055",
//         "JanCode": "4902161610301",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000061",
//             "TagName": "ストック"
//           }
//         ],
//         "GoodsName": "フルーツミックス",
//         "StandardName": "１３０ｇ（固形量７０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2565345",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3246191",
//         "JanCode": "4902220313501",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "白ゴマクリーム",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2565361",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3246361",
//         "JanCode": "4974434900334",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "南半球ブレンド純粋はちみつ",
//         "StandardName": "８００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2566515",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3259439",
//         "JanCode": "4973882114263",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "埼玉養蜂",
//         "OrderClient": "埼玉養蜂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "牛肉大和煮",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキの牛肉大和煮",
//         "StandardName": "８７ｇ（固形量５０ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2566582",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3260216",
//         "JanCode": "4902161622328",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000061",
//             "TagName": "ストック"
//           },
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "大豆ドライパック",
//         "StandardName": "１４０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2566638",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3260836",
//         "JanCode": "4902220313679",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つまスモーク　たこ",
//         "StandardName": "５０ｇ（固形量３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2566667",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3261158",
//         "JanCode": "4901592906977",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "味付椎茸ぬか（こうじ入り）",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2566735",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3261891",
//         "JanCode": "4970085051333",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "小えび",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567150",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3266567",
//         "JanCode": "4975314777350",
//         "LargeClassName": "乾物",
//         "PayeeClient": "玉鈴",
//         "OrderClient": "玉鈴",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "なす漬けの素",
//         "StandardName": "２０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567193",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3267032",
//         "JanCode": "4978239170510",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シャキッとコーン",
//         "StandardName": "６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567662",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3272702",
//         "JanCode": "4902560226202",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　熊本県産　でこぽん",
//         "StandardName": "１８５ｇ（固形量１１０ｇ×１２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567683",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3273008",
//         "JanCode": "4901592905178",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つまスモーク　貝柱",
//         "StandardName": "５０ｇ（固形量３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567684",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3273016",
//         "JanCode": "4901592905444",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つまスモーク　豚タン",
//         "StandardName": "５０ｇ（固形量３５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567685",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3273024",
//         "JanCode": "4901592908452",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さけ中骨水煮",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567698",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3273164",
//         "JanCode": "4901901332343",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "トロピカルフルーツパパイヤパイン",
//         "StandardName": "２２７ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567758",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3273822",
//         "JanCode": "4901605230167",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "小原紅（おばらべに）みかん　香川県産小原紅早生使用",
//         "StandardName": "２９５ｇ（固形量１７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567759",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3273830",
//         "JanCode": "4973941001091",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "シーズンパック",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お赤飯用あずき水煮",
//         "StandardName": "２３０ｇ（固形量１００ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567774",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3274004",
//         "JanCode": "4902220313631",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カナダ産純粋はちみつ",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567775",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3274012",
//         "JanCode": "4902220322169",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "主力",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーン　ドライパック",
//         "StandardName": "９０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2567776",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3274020",
//         "JanCode": "4902220313617",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "うるめ煮干　無頭",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568258",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3279812",
//         "JanCode": "4901497462356",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産白花豆",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568303",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3280314",
//         "JanCode": "4904655331501",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "のりあーと　リラックマ",
//         "StandardName": "８種×２枚（板のり１枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568382",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3281280",
//         "JanCode": "4972727500810",
//         "LargeClassName": "乾物",
//         "PayeeClient": "小善本店",
//         "OrderClient": "小善本店",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はちみつブルーベリー",
//         "StandardName": "４８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568487",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3282457",
//         "JanCode": "4902220322183",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ひじき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひじきドライパック",
//         "StandardName": "１１０ｇ×１２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568489",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3282473",
//         "JanCode": "4902220313693",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナまぐろ油漬フレーク",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568622",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3283941",
//         "JanCode": "4972195079665",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "沖縄県産パイナップルのジャム",
//         "StandardName": "４３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568623",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3283968",
//         "JanCode": "4908010699992",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "そのまま食べられる　レッドキドニー",
//         "StandardName": "１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568624",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3283976",
//         "JanCode": "4972195066139",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "貝柱ほぐし身",
//         "StandardName": "７０ｇ（固形量４０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568643",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3284387",
//         "JanCode": "4902150123751",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　瀬戸内産伊予柑",
//         "StandardName": "１９０ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568656",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3284522",
//         "JanCode": "4901592908476",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産焼のり",
//         "StandardName": "１０切８０枚（板のり８枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568847",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3286622",
//         "JanCode": "4902122013295",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000258",
//             "TagName": "ぐんま"
//           },
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           },
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           },
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           },
//           {
//             "TagId": "00000856",
//             "TagName": "とちぎ・ぐんま・ながの・にいがた"
//           }
//         ],
//         "GoodsName": "なすの辛子漬の素",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568953",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3287785",
//         "JanCode": "4902487050454",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "徳用さっぱり漬の素",
//         "StandardName": "１５ｇ×８袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568955",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3287807",
//         "JanCode": "4904056111429",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "日光たまり漬けの素",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2568956",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3287815",
//         "JanCode": "4975290417202",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "キムチベース　むーひ",
//         "StandardName": "１０００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569433",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3293637",
//         "JanCode": "4975183213263",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はごろも　シャキッとコーン",
//         "StandardName": "１９０ｇ（固形量１２０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569487",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3294250",
//         "JanCode": "4902220313419",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はごろも素材そのままシーチキンマイルド　オイル無添加",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569488",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3294269",
//         "JanCode": "4902220312894",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "信州産　秋映（あきばえ）りんごジャム",
//         "StandardName": "２１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569524",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3294668",
//         "JanCode": "4906525232611",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "牛肉大和煮",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキの牛肉大和煮",
//         "StandardName": "８７ｇ（固形量５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569526",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3294684",
//         "JanCode": "4902161622304",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーン　ホール",
//         "StandardName": "１２０ｇ（固形量７２ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569577",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3295249",
//         "JanCode": "4902431021943",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "豚の角煮",
//         "StandardName": "１６０ｇ（固形量８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569578",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3295257",
//         "JanCode": "4972195070129",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道十勝産　小豆",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569948",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3299538",
//         "JanCode": "4902220272709",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産　大豆",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2569949",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3299546",
//         "JanCode": "4902220272624",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "北海道産　黒豆",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2570130",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3301745",
//         "JanCode": "4902220272723",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道十勝産　大正金時",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2570131",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3301753",
//         "JanCode": "4902220272716",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "マンゴー　大きめひとくちカット",
//         "StandardName": "２３４ｇ（固形量１３５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2570430",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3305228",
//         "JanCode": "4901605230174",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "そのまま食べられる　ひよこ豆（ガルバンゾ）",
//         "StandardName": "１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2570475",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3305716",
//         "JanCode": "4972195066115",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産乾しいたけ　どんこ",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2570853",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3310132",
//         "JanCode": "4902859144811",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産小粒どんこしいたけ",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2570903",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3310698",
//         "JanCode": "4970310034599",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "やきとりふりかけ",
//         "StandardName": "２７ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571409",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3316696",
//         "JanCode": "4902511010485",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ハローキティおにぎりラップのり",
//         "StandardName": "２切７枚（板のり３．５枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571414",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3316750",
//         "JanCode": "4904071405572",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おむすび山　鮭わかめ",
//         "StandardName": "３１ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571448",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3317129",
//         "JanCode": "4902106838746",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おむすび山　青菜",
//         "StandardName": "３１ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571449",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3317137",
//         "JanCode": "4902106838753",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "雑穀クッキングクラブ　キヌア",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571450",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3317145",
//         "JanCode": "4902571477082",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "雑穀クッキングクラブ　アマランサス",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571451",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3317153",
//         "JanCode": "4902571477099",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "即席焼ビーフン３個パック",
//         "StandardName": "１９５ｇ（６５ｇ×３）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571585",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3318648",
//         "JanCode": "4901483021154",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           },
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "粉とうふトーフミール",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571586",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3318656",
//         "JanCode": "4902758202445",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "こうや豆腐",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571587",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3318664",
//         "JanCode": "4902758202421",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　ガルバンゾ（ひよこ豆）",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571649",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3319342",
//         "JanCode": "4901577337383",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　オレンジ",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571650",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3319350",
//         "JanCode": "4562452230276",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　レッドキドニー（赤いんげん豆）",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571651",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3319369",
//         "JanCode": "4901577337376",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "とりささみフレーク　食塩無添加",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2571653",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3319385",
//         "JanCode": "4901133568053",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産上どんこしいたけ",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2572310",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3326934",
//         "JanCode": "4970310034407",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産果実　白桃２つ割り",
//         "StandardName": "４２５ｇ（固形量２５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2572398",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3327892",
//         "JanCode": "4902220313044",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つま匠　国産牛すじ軟骨どて煮（関西風）",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2572497",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3329038",
//         "JanCode": "4901592911162",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カスタードクリーム",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2572555",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3329666",
//         "JanCode": "4901671200248",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "もち麦",
//         "StandardName": "５０ｇ×１２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2572734",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3331636",
//         "JanCode": "4902571112686",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000009",
//             "TagName": "オーガニック"
//           },
//           {
//             "TagId": "00000771",
//             "TagName": "１１８有機和"
//           }
//         ],
//         "GoodsName": "有機いりごま　黒",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2573161",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3336409",
//         "JanCode": "4902220272211",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000009",
//             "TagName": "オーガニック"
//           },
//           {
//             "TagId": "00000771",
//             "TagName": "１１８有機和"
//           }
//         ],
//         "GoodsName": "有機いりごま　白",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2573162",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3336417",
//         "JanCode": "4902220272181",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　東北産　白桃（あかつき）",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2573486",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3339998",
//         "JanCode": "4901592905130",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "フレッシュ限定",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付けうずら卵（しょうゆ）",
//         "StandardName": "１６個",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2574158",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3347451",
//         "JanCode": "4901577060175",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "コープデリクーポン",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "けんちん汁",
//         "StandardName": "８２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2574368",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3349772",
//         "JanCode": "4933467201030",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ぜにふ",
//         "StandardName": "２１枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2574733",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3354008",
//         "JanCode": "4902867004046",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産徳用香信しいたけ",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2575112",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3358216",
//         "JanCode": "4970310034872",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産どんこ椎茸",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2575302",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3360423",
//         "JanCode": "4908870020028",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           },
//           {
//             "TagId": "00000002",
//             "TagName": "低糖質"
//           }
//         ],
//         "GoodsName": "スパム　２５％減塩",
//         "StandardName": "３４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2576359",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3372316",
//         "JanCode": "0037600542708",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "減塩",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産果実　甘夏みかん",
//         "StandardName": "１３０ｇ（固形量８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2576388",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3372634",
//         "JanCode": "4901605341498",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産果実　黄桃　薄切り",
//         "StandardName": "１３０ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2576389",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3372642",
//         "JanCode": "4901605341467",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産乾しいたけスライス",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2576396",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3372715",
//         "JanCode": "4970310034902",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒天麩",
//         "StandardName": "１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577117",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3381013",
//         "JanCode": "4971889121055",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ブルーベリージャム",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577237",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3382443",
//         "JanCode": "4902220322251",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "マーマレード",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577239",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3382478",
//         "JanCode": "4902220322268",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "福岡県産きくらげ",
//         "StandardName": "１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577462",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3384950",
//         "JanCode": "4901401062764",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大麦効果",
//         "StandardName": "６０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577465",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3384985",
//         "JanCode": "4902571112617",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印　アルゼンチン産＆カナダ産純粋はちみつ",
//         "StandardName": "１０００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577563",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3386066",
//         "JanCode": "4901390180869",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2020年5・6・11・12月共同仕入れ",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印　アルゼンチン産＆カナダ産純粋はちみつ",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577565",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3386082",
//         "JanCode": "4901390180852",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2020年5・6・11・12月共同仕入れ",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "炊飯器でらくらくパエリア",
//         "StandardName": "２～３人前",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2577723",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3387828",
//         "JanCode": "4901011613103",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトフレーク（かつお油漬）",
//         "StandardName": "７０ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2578427",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3395987",
//         "JanCode": "4901133941320",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナ　えごま油",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2578428",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3395995",
//         "JanCode": "4901133587146",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つまホルモン　鶏ハラミ　直火焼",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2578747",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3399575",
//         "JanCode": "4901592913227",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶つまホルモン　牛マルチョウ　直火焼",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2578749",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3399591",
//         "JanCode": "4901592913234",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒天海藻サラダ",
//         "StandardName": "５ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2579110",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3403645",
//         "JanCode": "4902378032446",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スーパーフードナイン",
//         "StandardName": "１２０ｇ（２０ｇ×６包）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2579290",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3405648",
//         "JanCode": "4953575127442",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "無塩せきポークランチョンミート",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2579521",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3408175",
//         "JanCode": "4936790520205",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "ナチュール",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱　フレーク",
//         "StandardName": "７０ｇ（固形量４０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2579577",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3408795",
//         "JanCode": "4901133590245",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産果実　りんご",
//         "StandardName": "１３０ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2579609",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3409147",
//         "JanCode": "4901605341474",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産果実　白桃　薄切り",
//         "StandardName": "１３０ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2579610",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3409155",
//         "JanCode": "4901605341450",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スーパー三穀ブレンド",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2579795",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3411230",
//         "JanCode": "4902571477105",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "旨しお海苔　ごま油風味",
//         "StandardName": "８切４０枚（板のり５枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2580436",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3418448",
//         "JanCode": "4902604901911",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産純粋蜂蜜　マロニエ",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2580679",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3421244",
//         "JanCode": "4976662210247",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "フリー月",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印　アルゼンチン産＆カナダ産純粋はちみつ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581279",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3427927",
//         "JanCode": "4901390180968",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2020年5・6・11・12月共同仕入れ",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本の苺ジャム（長崎県産苺使用）",
//         "StandardName": "１９５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581295",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3428109",
//         "JanCode": "4902220322398",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "福岡県産きくらげ",
//         "StandardName": "１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581315",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3428338",
//         "JanCode": "4979603233121",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　チキンささみ（国産）",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581357",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3428788",
//         "JanCode": "4901577134524",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "鶏ささみフレーク",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581547",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3430944",
//         "JanCode": "4902220313853",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップゼリー８０℃　ぶどう味",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581596",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3431487",
//         "JanCode": "4901138882840",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手間いらずしょうゆおこわ（金時豆入）",
//         "StandardName": "２合用",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581794",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3433668",
//         "JanCode": "4904655110304",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産カットわかめ",
//         "StandardName": "９ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581835",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3434168",
//         "JanCode": "4902378032484",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産お徳用カットわかめ",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2581836",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3434176",
//         "JanCode": "4902378032538",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大豆ドライパック",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2582131",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3437426",
//         "JanCode": "4902220313662",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーンドライパック",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2582132",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3437434",
//         "JanCode": "4902220313600",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "粕汁",
//         "StandardName": "８２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2582207",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3438260",
//         "JanCode": "4933467207049",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "釧路のいわし　味噌煮",
//         "StandardName": "１５０ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2582208",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3438279",
//         "JanCode": "4962528042053",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "パントッピング",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ディッパーシーチキンマヨネーズタイプ",
//         "StandardName": "４０ｇ×３（小袋１２袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2582326",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3439569",
//         "JanCode": "4902560405379",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産カットわかめ徳用",
//         "StandardName": "３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2583372",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3451267",
//         "JanCode": "4902220284276",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産カットわかめ",
//         "StandardName": "１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2583373",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3451275",
//         "JanCode": "4902220284269",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "甘酒粉末タイプ",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2583379",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3451348",
//         "JanCode": "4902888552304",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産カットわかめ",
//         "StandardName": "１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2583846",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3456595",
//         "JanCode": "4902371441214",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "岩手県産カットわかめ",
//         "StandardName": "３３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2583847",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3456609",
//         "JanCode": "4902371441313",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱割り身",
//         "StandardName": "６５ｇ（固形量４０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2584795",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3467198",
//         "JanCode": "4901901267225",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "宇治抹茶クリーム",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2584916",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3468550",
//         "JanCode": "4901401040717",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "トリプルベリージャム",
//         "StandardName": "７８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2584917",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3468569",
//         "JanCode": "4901401040977",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "熊本県産きくらげ",
//         "StandardName": "８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2585361",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3473457",
//         "JanCode": "4902028310771",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ゆであずき（北海道産小豆使用）",
//         "StandardName": "４３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2585430",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3474283",
//         "JanCode": "4902220313655",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ブルーベリージャム",
//         "StandardName": "７８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2586229",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3483363",
//         "JanCode": "4902220322435",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いちごジャム",
//         "StandardName": "７８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2586232",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3483401",
//         "JanCode": "4902220322367",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "愛媛産　ぽんかん",
//         "StandardName": "２９５ｇ（固形量１７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2586241",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3483509",
//         "JanCode": "4560342583310",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まぐろステーキ",
//         "StandardName": "１３０ｇ（固形量７５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2586255",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3483657",
//         "JanCode": "4902150122600",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩塩こうじ",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587071",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3492699",
//         "JanCode": "4902401508474",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩わかめごはん",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587072",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3492702",
//         "JanCode": "4904561011863",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しそふりかけ",
//         "StandardName": "２６ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587073",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3492710",
//         "JanCode": "4904561011719",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "宮崎県産わりぼし大根",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587099",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3493008",
//         "JanCode": "4942869938116",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ビーフン",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587330",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3495612",
//         "JanCode": "4901483020140",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産　みかん",
//         "StandardName": "４２５ｇ（固形量２４５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587453",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3496961",
//         "JanCode": "4903310130114",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いわし蒲焼",
//         "StandardName": "１００ｇ（固形量８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587461",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3497062",
//         "JanCode": "4902220317875",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "マッシュルーム缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "美味しいマッシュルーム　ランダムスライス",
//         "StandardName": "８５ｇ（固形量５０ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587528",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3497798",
//         "JanCode": "4953009112655",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "甘さをおさえたブルーベリージャム",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587887",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3501892",
//         "JanCode": "4902220322510",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "甘さをおさえたいちごジャム",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587888",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3501906",
//         "JanCode": "4902220322480",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "甘さをおさえたオレンジマーマレード",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587894",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3501965",
//         "JanCode": "4902220322534",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "甘さをおさえたりんごジャム",
//         "StandardName": "１５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587895",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3501973",
//         "JanCode": "4902220322152",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "七味とうがらし",
//         "StandardName": "１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2587997",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3503100",
//         "JanCode": "4901969001243",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃんいか味付け",
//         "StandardName": "１３５ｇ（固形量６５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588082",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3504042",
//         "JanCode": "4953009113423",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "杏仁豆腐",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588083",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3504050",
//         "JanCode": "4970249000726",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ファインスーパーフード　チアシード",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588407",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3507661",
//         "JanCode": "4976652010345",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ファインスーパーフード　金のローストキヌア",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588414",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3507750",
//         "JanCode": "4976652010338",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ファインスーパーフード　根昆布",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588416",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3507777",
//         "JanCode": "4976652011090",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "マンナンヒカリ　スティックタイプ",
//         "StandardName": "７５ｇ×７袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588503",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3508730",
//         "JanCode": "4901150530514",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ＥＰＡ＋ＤＨＡ配合　いわし生姜煮",
//         "StandardName": "１００ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588582",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3509656",
//         "JanCode": "4902150124239",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ＥＰＡ＋ＤＨＡ配合　いわし味噌煮",
//         "StandardName": "１００ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2588590",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3509737",
//         "JanCode": "4902150124246",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　愛媛県産　紅まどんな",
//         "StandardName": "１８５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2589258",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3517454",
//         "JanCode": "4901592911278",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のさば　水煮",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2589259",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3517462",
//         "JanCode": "4902431060409",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のさば　味噌煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2589260",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3517470",
//         "JanCode": "4902431080438",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　チキンささみ（国産）",
//         "StandardName": "４０ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2589842",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3524337",
//         "JanCode": "4901577134524",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　玄米ミックス（玄米、もち玄米、押麦）",
//         "StandardName": "４０ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2589897",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3526186",
//         "JanCode": "4901577064739",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "ケーキシロップ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000833",
//             "TagName": "シロップ"
//           }
//         ],
//         "GoodsName": "ホットケーキシロップ",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2590078",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3528332",
//         "JanCode": "4902220321599",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "Ｓｕｎ＆Ｔａｂｌｅ　濃いあじいちご",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2590247",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3530205",
//         "JanCode": "4901671300788",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ミニオンズふりかけミニパック",
//         "StandardName": "５０ｇ（２０袋入）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2590825",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3536661",
//         "JanCode": "4902820120363",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お野菜まる　たたききゅうりの素",
//         "StandardName": "４０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2591029",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3539296",
//         "JanCode": "4902833833212",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お野菜まる　なすのコク旨たれ",
//         "StandardName": "４０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2591030",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3539318",
//         "JanCode": "4902833833243",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お野菜まる　もやしナムルの素",
//         "StandardName": "４０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2591031",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3539326",
//         "JanCode": "4902833833236",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "ＳｕｉＳｕｉオープンさばみそ煮減塩３０％",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2591103",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3540111",
//         "JanCode": "4902150125632",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "減塩",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "ＳｕｉＳｕｉオープンさば水煮減塩３０％",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2591130",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3540405",
//         "JanCode": "4902150125625",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "減塩",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "チキンとタイカレー　グリーン",
//         "StandardName": "１１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2591459",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3544060",
//         "JanCode": "4901133081316",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "チキンとタイカレー　イエロー",
//         "StandardName": "１１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2591460",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3544079",
//         "JanCode": "4901133081323",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "愛知県篠島産ちりめん　徳用",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592438",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3555259",
//         "JanCode": "4903156031064",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマト食品株式会社",
//         "OrderClient": "ヤマト食品株式会社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ボンヌママン　ストロベリージャム",
//         "StandardName": "２２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592614",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3557235",
//         "JanCode": "0000045108013",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ボンヌママン　ブルーベリージャム",
//         "StandardName": "２２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592615",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3557243",
//         "JanCode": "0000045108020",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "バターチキンカレー　ココナッツミルク仕立て",
//         "StandardName": "１１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592662",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3557766",
//         "JanCode": "4901133081347",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "コーンクリーム",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592663",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3557774",
//         "JanCode": "4901133610981",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "ライトツナフレーク　減塩",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592664",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3557782",
//         "JanCode": "4901133884856",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "減塩",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップケーキどこでもスイーツ缶　メープル風味",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592847",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3559793",
//         "JanCode": "4560440931433",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "防災",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップケーキどこでもスイーツ缶　フルーツミックス",
//         "StandardName": "５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592848",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3559807",
//         "JanCode": "4560440931457",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "防災",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フォー",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2592939",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3560821",
//         "JanCode": "4901483021215",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノリタイム３０束",
//         "StandardName": "１２切５枚３０束",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2593791",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3570533",
//         "JanCode": "4904071231638",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お徳用おにぎり焼のり４０枚",
//         "StandardName": "３切４０枚　板のり１３．３３枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2593793",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3570568",
//         "JanCode": "4904071406654",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "てりやきのり卓上７２枚",
//         "StandardName": "１０切７２枚（板のり７．２枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2593795",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3570584",
//         "JanCode": "4904071406340",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おにぎりには塩のり１６枚２個パック",
//         "StandardName": "３切１６枚×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594072",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3573664",
//         "JanCode": "4901673293675",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "焼のりおにぎり・おもち",
//         "StandardName": "３切４０枚（板のり１３．３枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594073",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3573672",
//         "JanCode": "4901673290209",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "伊勢志摩産あおさのり",
//         "StandardName": "８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594078",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3573729",
//         "JanCode": "4902371224855",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ボンヌママン　ビターオレンジマーマレード",
//         "StandardName": "２２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594705",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3580687",
//         "JanCode": "0000045108044",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ボンヌママン　マロンクリーム",
//         "StandardName": "２２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594706",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3580695",
//         "JanCode": "0000045108082",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おもち・おにぎり焼のり",
//         "StandardName": "３切４０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594864",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3582442",
//         "JanCode": "4901191452400",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "卓上味付のりモーニングパック",
//         "StandardName": "１０切５０枚×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594869",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3582493",
//         "JanCode": "4901191230671",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付のり１００",
//         "StandardName": "１２切１００枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594872",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3582523",
//         "JanCode": "4901191231203",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産焼のり寿司はね",
//         "StandardName": "板のり１０枚×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2594877",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3582582",
//         "JanCode": "4901191413470",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食塩無添加　雑穀ミックス　キヌア",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596088",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3596362",
//         "JanCode": "4901133245565",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食塩無添加　雑穀ミックス　スーパー大麦",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596093",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3596419",
//         "JanCode": "4901133245503",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩やさしい液体塩こうじ",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596414",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3599930",
//         "JanCode": "4902401508337",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "両班韓国海苔",
//         "StandardName": "板のり６枚分（８切８枚６袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596415",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3599949",
//         "JanCode": "8801047221128",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "マロニーちゃん",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596431",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3600122",
//         "JanCode": "4902902103000",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まごわやさしいふりかけ",
//         "StandardName": "３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596434",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3600157",
//         "JanCode": "4904534041026",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "納豆ふりかけ",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596435",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3600165",
//         "JanCode": "4904534040128",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産　塩昆布",
//         "StandardName": "３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596631",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3602370",
//         "JanCode": "4903097200604",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "パワーご飯手作りふりかけ",
//         "StandardName": "８７ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2596632",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3602389",
//         "JanCode": "4902833815638",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "青とびおにぎりのり（千葉木更津・盤洲干潟産）",
//         "StandardName": "３切２０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2597112",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3607704",
//         "JanCode": "4969570110303",
//         "LargeClassName": "乾物",
//         "PayeeClient": "千葉県漁連",
//         "OrderClient": "千葉県漁連",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おつゆふ",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2597197",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3608654",
//         "JanCode": "4902220016471",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           },
//           {
//             "TagId": "00000034",
//             "TagName": "弁当"
//           },
//           {
//             "TagId": "00000831",
//             "TagName": "象徴コマ"
//           }
//         ],
//         "GoodsName": "おむすび山　減塩鮭わかめ",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2597608",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3613186",
//         "JanCode": "4902106839415",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000064",
//             "TagName": "ごはんのおとも"
//           },
//           {
//             "TagId": "00000831",
//             "TagName": "象徴コマ"
//           }
//         ],
//         "GoodsName": "おむすび山　ゆずおかか",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2597609",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3613194",
//         "JanCode": "4902106839422",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "みそ汁の具",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2597615",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3613259",
//         "JanCode": "4902220016518",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おむすび山　焼きたらこ",
//         "StandardName": "３１ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2597648",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3613615",
//         "JanCode": "4902106838777",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しそわかめ",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2597649",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3613623",
//         "JanCode": "4970905100791",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　オレンジ",
//         "StandardName": "１２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2598059",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3618161",
//         "JanCode": "0000045186103",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "小容量",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　いちご",
//         "StandardName": "１２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2598064",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3618234",
//         "JanCode": "0000045185809",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "小容量",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　ブルーベリー",
//         "StandardName": "１２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2598065",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3618242",
//         "JanCode": "0000045185816",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "小容量",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ザーネワンダーホイップクリーム",
//         "StandardName": "２５０ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2598218",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3619923",
//         "JanCode": "4003490040231",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップゼリー８０℃　コーヒー",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2598223",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3619982",
//         "JanCode": "4901138882857",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーン　ホール",
//         "StandardName": "３８０ｇ（固形量２４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2598552",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3623610",
//         "JanCode": "4972195067013",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "栗甘露煮",
//         "StandardName": "２００ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2598907",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3627578",
//         "JanCode": "0000049521580",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2019　32000点",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダと食べるスーパーフード　ローストキヌア",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599126",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3629988",
//         "JanCode": "4902571459118",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダと食べるスーパーフード　ポピーシード",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599127",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3629996",
//         "JanCode": "4902571459125",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダと食べる　大麦フレーク",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599129",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3630013",
//         "JanCode": "4902571459064",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産長ひじき",
//         "StandardName": "１２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599224",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3631079",
//         "JanCode": "4902220025497",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産芽ひじき",
//         "StandardName": "１４ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599227",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3631109",
//         "JanCode": "4902220025473",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "コーン＆ベジタブル",
//         "StandardName": "３８０ｇ（固形量２４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599357",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3632520",
//         "JanCode": "4902204423394",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "熊本県天草産海藻サラダ",
//         "StandardName": "１２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599370",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3632679",
//         "JanCode": "4994790311193",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "煮干し",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599394",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3632946",
//         "JanCode": "4902220013500",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "信州産大豆ナカセンナリ使用こうや豆腐",
//         "StandardName": "６２ｇ（４枚入）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599676",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3636046",
//         "JanCode": "4902029111063",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "柿安牛肉しぐれおこわ",
//         "StandardName": "１．５合用（お茶碗約３杯分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599859",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3638294",
//         "JanCode": "4901011618412",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "自然甘北海道産スイートコーン　（ホールカーネル）",
//         "StandardName": "２３０ｇ（固形量１４５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2599998",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3639827",
//         "JanCode": "4901504110430",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "シーズンパック",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000067",
//             "TagName": "冬至"
//           }
//         ],
//         "GoodsName": "ゆであずき　北海道十勝産小豆使用",
//         "StandardName": "１９０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2600000",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3639843",
//         "JanCode": "4901605511648",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道コーン　ホール",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2600392",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3644189",
//         "JanCode": "4901577069505",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道コーン　ホール",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2600393",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3644197",
//         "JanCode": "4901577069512",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道コーン　ホール",
//         "StandardName": "５０ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2600401",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3644286",
//         "JanCode": "4901577069505",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道コーン　ホール",
//         "StandardName": "１００ｇ×８",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2600402",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3644294",
//         "JanCode": "4901577069512",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お徳用ソフトパック　かつお枯節ソフトけずり",
//         "StandardName": "２ｇ×３０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2600513",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3645584",
//         "JanCode": "4902833168499",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "有明産　初づみ焼のり＜焼きたて配達＞",
//         "StandardName": "板のり１０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2600874",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3649571",
//         "JanCode": "4541044313108",
//         "LargeClassName": "乾物",
//         "PayeeClient": "山陽商事",
//         "OrderClient": "山陽商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "花かつお",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601024",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3651312",
//         "JanCode": "4902220066216",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いわしみそ煮",
//         "StandardName": "１００ｇ（固形量７０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601050",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3651606",
//         "JanCode": "4901901573616",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "ガンガン",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いわし煮付",
//         "StandardName": "１００ｇ（固形量７０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601052",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3651622",
//         "JanCode": "4901901573630",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "ガンガン",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000061",
//             "TagName": "ストック"
//           }
//         ],
//         "GoodsName": "いわし蒲焼",
//         "StandardName": "１００ｇ（固形量７０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601071",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3651886",
//         "JanCode": "4901901218098",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "3",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "伊勢志摩産芽ひじき",
//         "StandardName": "１１ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601113",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3652335",
//         "JanCode": "4902378013810",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産一番摘み焼のり",
//         "StandardName": "板のり１０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601399",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3655571",
//         "JanCode": "4902220066612",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "ピーナッツバター砂糖・食塩不使用",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601453",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3656225",
//         "JanCode": "4901401040793",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "おにぎり具材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産梅１００％カリカリ梅",
//         "StandardName": "２６ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601464",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3656349",
//         "JanCode": "4902765319525",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "なめらかねりごま黒",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601681",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3658732",
//         "JanCode": "4902220272532",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "なめらかねりごま白",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601682",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3658740",
//         "JanCode": "4902220272860",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産海藻サラダ",
//         "StandardName": "７ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601683",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3658759",
//         "JanCode": "4902378032514",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "梅塩昆布",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2601684",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3658767",
//         "JanCode": "4902378052406",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "青源の本格あまざけ",
//         "StandardName": "６２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2602301",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3665895",
//         "JanCode": "4986348400251",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000059",
//             "TagName": "中華アジアン"
//           },
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "杏仁豆腐の素（ソフトタイプ）　シロップ付",
//         "StandardName": "７０ｇ×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2602515",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3668258",
//         "JanCode": "4902220025602",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "産直ごぼうで作った乾燥ごぼう",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2602593",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3669106",
//         "JanCode": "4902220272839",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印アルゼンチン産純粋はちみつ",
//         "StandardName": "１５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2602927",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3672786",
//         "JanCode": "4901390181286",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2020年5・6・11・12月共同仕入れ",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "青森県産スライスごぼう笹切り",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2602929",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3672808",
//         "JanCode": "4519727210365",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おかかふりかけ昆布・椎茸入り",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2602939",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3672905",
//         "JanCode": "4902381007561",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おかかふりかけ胡麻入り",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2602940",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3672913",
//         "JanCode": "4902381007554",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産みかん",
//         "StandardName": "２９５ｇ（固形量１７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2603277",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3676633",
//         "JanCode": "4901605330522",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "浅漬けの素　こうじ漬け",
//         "StandardName": "５０ｇ×３袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2603496",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3679047",
//         "JanCode": "4901108013977",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "浅漬けの素　あわせだし",
//         "StandardName": "５０ｇ×３袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2603503",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3679136",
//         "JanCode": "4901108013960",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本の穀物　もちもち五穀",
//         "StandardName": "３０ｇ×６袋入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2603509",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3679195",
//         "JanCode": "4901515354403",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "雑穀かつおふりかけ",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2603679",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3681149",
//         "JanCode": "4994790308506",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産　玄米十六雑穀米",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2603690",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3681270",
//         "JanCode": "4994790312145",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道コーン　クリーム",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2604314",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3688178",
//         "JanCode": "4901577069529",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道コーン　クリーム",
//         "StandardName": "１５０ｇ×８",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2604320",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3688232",
//         "JanCode": "4901577069529",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "江戸前千葉の焼のり",
//         "StandardName": "板のり１０枚×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2604341",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3688453",
//         "JanCode": "4969570100328",
//         "LargeClassName": "乾物",
//         "PayeeClient": "千葉県漁連",
//         "OrderClient": "千葉県漁連",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "Ｓｕｎ＆Ｔａｂｌｅ　とろける北海道ミルク",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2604348",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3688542",
//         "JanCode": "4901671300757",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "熊本県和水町産唐辛子ホール",
//         "StandardName": "８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2605132",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3697452",
//         "JanCode": "4902028311570",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さばのカレー煮",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2605323",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3699641",
//         "JanCode": "4901901586272",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さばのトマト煮",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2605324",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3699668",
//         "JanCode": "4901901586289",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はちみつレモン",
//         "StandardName": "４８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2605532",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3702022",
//         "JanCode": "4902220025268",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "越後特産車麩　四回巻",
//         "StandardName": "１１枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2605550",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3702227",
//         "JanCode": "4901632008555",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "もち麦",
//         "StandardName": "８００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606017",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3707512",
//         "JanCode": "4902220004805",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーツポンチ",
//         "StandardName": "２００ｇ（固形量１２０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606459",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3713210",
//         "JanCode": "4902220312658",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "価値",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダ用揚ちりめん",
//         "StandardName": "３８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606545",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3714195",
//         "JanCode": "4903123000499",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマヒデ食品",
//         "OrderClient": "ヤマヒデ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "チキンとインドカレー　赤カレー",
//         "StandardName": "１１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606734",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3716333",
//         "JanCode": "4901133502651",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "チキンとインドカレー黒カレー",
//         "StandardName": "１１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606735",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3716341",
//         "JanCode": "4901133502644",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "欧州産アカシアはちみつ≪倒立容器≫",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606892",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3718077",
//         "JanCode": "0000049521818",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2018.6.1～",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さっぱりおいしい海草サラダ",
//         "StandardName": "２～３人分",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606902",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3718182",
//         "JanCode": "4903307640688",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "チョレギ風海藻サラダ",
//         "StandardName": "２～３人分",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606903",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3718190",
//         "JanCode": "4903307640787",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産アカシア蜂蜜",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606948",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3718697",
//         "JanCode": "4976662209029",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "6,9,11,2,3,4月希望",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産ボダイジュ蜂蜜",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2606949",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3718700",
//         "JanCode": "4976662209050",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "フリー月",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "おいしいぬか床",
//         "StandardName": "８００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2607628",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3726290",
//         "JanCode": "4904502100823",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "北海道知床産　羅臼昆布",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2607643",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3726460",
//         "JanCode": "4902371303789",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000698",
//             "TagName": "季節"
//           }
//         ],
//         "GoodsName": "炊くだけおこわ　栗おこわ",
//         "StandardName": "２合用",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2607652",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3726568",
//         "JanCode": "4902220026852",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩あさ漬の素",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2607716",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3727297",
//         "JanCode": "4904502123075",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "Ｓｕｎ＆Ｔａｂｌｅ　香ばしアーモンド",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2608009",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3730735",
//         "JanCode": "4901671300832",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "漁協の食べるいりこ（瀬戸内産）",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2608072",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3731413",
//         "JanCode": "4971717201027",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "やきとりたれ味",
//         "StandardName": "７５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2608087",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3731677",
//         "JanCode": "4902511011598",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カットわかめ（韓国産）",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2608092",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3731723",
//         "JanCode": "4902371440255",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "刻み昆布",
//         "StandardName": "２２ｇ×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2608136",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3732215",
//         "JanCode": "4902371223476",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明産焼のり重等級原料使用",
//         "StandardName": "板のり８枚×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2608326",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3734315",
//         "JanCode": "4971617111839",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国太楼",
//         "OrderClient": "国太楼",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産おでんこんぶ",
//         "StandardName": "１６ｇ×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2608917",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3741117",
//         "JanCode": "4902371331263",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　山形県産　ミックスフルーツ",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2609056",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3742814",
//         "JanCode": "4901592905154",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩　さば水煮",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2610187",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3755541",
//         "JanCode": "4901901575207",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "機能性",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩　さばみそ煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2610190",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3755584",
//         "JanCode": "4901901575214",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "森永　甘酒（フリーズドライ）",
//         "StandardName": "４袋入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2610823",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3762599",
//         "JanCode": "4902888552960",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "きざみのり",
//         "StandardName": "１２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611031",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3764931",
//         "JanCode": "4902220084050",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーツみつ豆",
//         "StandardName": "２０５ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611033",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3764966",
//         "JanCode": "4902220074525",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シュガートースト（メイプルバター風味）",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611045",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3765083",
//         "JanCode": "4902220016259",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ホイップピーナッツクリーム（ピーナッツ粒入り）",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611049",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3765121",
//         "JanCode": "4902220074938",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "切り落とし羅臼昆布",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611247",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3767310",
//         "JanCode": "4902371336060",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "アヲハタ　ピーナッツクリーム",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611388",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3768953",
//         "JanCode": "0000045201905",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "コープデリクーポン",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "愛媛県産和栗甘露煮　無漂白",
//         "StandardName": "２００ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611600",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3771296",
//         "JanCode": "4901605441204",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           },
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "ウコンたくあん漬の素",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611606",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3771369",
//         "JanCode": "4904056218043",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           },
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "まろやか白菜漬の素",
//         "StandardName": "９０ｇ（３０ｇ×３）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611609",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3771393",
//         "JanCode": "4904056218067",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           },
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "野沢菜漬の素（野沢菜３０ｋｇ用）",
//         "StandardName": "９０ｇ（３０ｇ×３）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611611",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3771415",
//         "JanCode": "4904056218098",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産みかん",
//         "StandardName": "２９５ｇ（固形量１７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2611875",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3774341",
//         "JanCode": "4902560110020",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱ほぐし身",
//         "StandardName": "６５ｇ（固形量４０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2612523",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3781461",
//         "JanCode": "4902165269512",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "音戸にぼし",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2612630",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3782670",
//         "JanCode": "4901497466231",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産フリーズドライみつば",
//         "StandardName": "０．１５ｇ×４包",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2612799",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3784525",
//         "JanCode": "4972530990532",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           },
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "北海道産　ほたて干貝柱",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2613064",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3787451",
//         "JanCode": "4972150922197",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "栗甘露煮",
//         "StandardName": "２００ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2613642",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3794040",
//         "JanCode": "0000049520804",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "粉末にぼしミックス",
//         "StandardName": "９５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2613963",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3797651",
//         "JanCode": "4904825109411",
//         "LargeClassName": "乾物",
//         "PayeeClient": "カネソ２２",
//         "OrderClient": "カネソ２２",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "３種の麦ミックス（キヌアと黒米入り）",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614069",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3798860",
//         "JanCode": "4901577073076",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "月花いわし水煮",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614503",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3803686",
//         "JanCode": "4901901556138",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "月花いわし煮付",
//         "StandardName": "２００ｇ（固形量１３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614506",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3803716",
//         "JanCode": "4901901556121",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "あごだし味付のり　減塩",
//         "StandardName": "１０切５０枚（板のり５枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614636",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3805131",
//         "JanCode": "4901673295372",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "韓国味付のり（オリーブオイル使用）",
//         "StandardName": "８切８枚３袋（板のり３枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614645",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3805239",
//         "JanCode": "8805425502298",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はぼまい昆布しょうゆ味　おかずのり",
//         "StandardName": "８切５枚１０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614646",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3805247",
//         "JanCode": "4901673295365",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと果実　いちじく",
//         "StandardName": "２５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614670",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3805514",
//         "JanCode": "4562452230283",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スープ用糸寒天",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2614815",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3807177",
//         "JanCode": "4901138885261",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ミニパック緑豆春雨",
//         "StandardName": "４０ｇ×４個入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2615105",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3810399",
//         "JanCode": "4902220012312",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000225",
//             "TagName": "いばらき"
//           }
//         ],
//         "GoodsName": "コンデンスミルク",
//         "StandardName": "４８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2615534",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3815285",
//         "JanCode": "4974701100191",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒天のジュレ　みかん",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2615579",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3815773",
//         "JanCode": "4902635977909",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒天のジュレ　もも",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2615586",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3815862",
//         "JanCode": "4902635977923",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒天のジュレ　ぶどう",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2615589",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3815897",
//         "JanCode": "4902635977947",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒天のジュレ　フルーツミックス",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2615592",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3815927",
//         "JanCode": "4902635977954",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "浅漬けの素",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2615846",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3818829",
//         "JanCode": "4902220087631",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　ヤングコーン",
//         "StandardName": "１００ｇ（固形量５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616525",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3827232",
//         "JanCode": "4901577223358",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　ヤングコーン",
//         "StandardName": "１００ｇ（固形量５０ｇ）×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616527",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3827259",
//         "JanCode": "4901577223358",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　ブラックオリーブ（スライス）",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616528",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3827267",
//         "JanCode": "4901577068560",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　ブラックオリーブ（スライス）",
//         "StandardName": "２５ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616531",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3827291",
//         "JanCode": "4901577068560",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道大豆",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616539",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3827380",
//         "JanCode": "4901577073120",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダクラブ　北海道大豆",
//         "StandardName": "６０ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616541",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3827402",
//         "JanCode": "4901577073120",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お湯で溶ける粉末寒天",
//         "StandardName": "８ｇ（２ｇ×４袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616750",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3829715",
//         "JanCode": "4901138881775",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産　焼のり《卓上タイプ》",
//         "StandardName": "１０切６０枚（板のり６枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616753",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3829758",
//         "JanCode": "4902220084623",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "沖縄県産黒糖使用　黒みつ",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616855",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3830861",
//         "JanCode": "4902220074761",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あさりしょうが煮",
//         "StandardName": "９０ｇ（固形量６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2616971",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3832198",
//         "JanCode": "4901901289838",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "デルモンテ　濃厚クリームコーン　粒入り",
//         "StandardName": "３８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618141",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3845109",
//         "JanCode": "4902204423158",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "高たんぱく質１２穀ブレンド",
//         "StandardName": "１８０ｇ（３０ｇ×６袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618475",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3848779",
//         "JanCode": "4970805011784",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "グルテンフリー１２穀ブレンド",
//         "StandardName": "１８０ｇ（３０ｇ×６袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618476",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3848787",
//         "JanCode": "4970805011791",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印アルゼンチン産純粋はちみつ",
//         "StandardName": "７００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618481",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3848833",
//         "JanCode": "4901390181026",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "2020年5・6・11・12月共同仕入れ",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "牛乳寒天フルーツ入り。",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618482",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3848841",
//         "JanCode": "4901592891082",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ブルーベリージャム",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618538",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3849465",
//         "JanCode": "4990303100513",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いか味付",
//         "StandardName": "１３０ｇ（固形量５５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618777",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3852091",
//         "JanCode": "4902150128497",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ピリッと辛いあいこちゃんツナ（かつお油漬フレーク）",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2618808",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3852431",
//         "JanCode": "4953009113553",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "美味しい鱒味付け　昆布仕込",
//         "StandardName": "１５０ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2619346",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3858383",
//         "JanCode": "4953009113522",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "オリーブオイルツナ（まぐろ油漬）",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2619352",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3858456",
//         "JanCode": "4902431025873",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000225",
//             "TagName": "いばらき"
//           }
//         ],
//         "GoodsName": "あんみつ",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2619733",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3862704",
//         "JanCode": "4974813111382",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産大豆使用雪豆腐粉末",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2620717",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3873587",
//         "JanCode": "4973858001504",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産玄米　発芽米",
//         "StandardName": "７５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2620928",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3875997",
//         "JanCode": "4908049474973",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さんま缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さんま蒲焼",
//         "StandardName": "１００ｇ（固形量８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2621055",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3877388",
//         "JanCode": "4901901356141",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産さば　水煮",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2621926",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3887049",
//         "JanCode": "4901133114618",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "具が溶け込んだ　完熟トマトカレー（中辛）",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2621933",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3887138",
//         "JanCode": "4901133763632",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "具が溶け込んだ　スパイシーカレー（辛口）",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2621947",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3887286",
//         "JanCode": "4901133763649",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮缶",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2621983",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3887677",
//         "JanCode": "4972195030079",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "発芽玄米　新潟県産特別栽培米コシヒカリ使用",
//         "StandardName": "１２０ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2624745",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3918629",
//         "JanCode": "4964843150802",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "菌茸類の缶詰",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産マッシュルームドライパック（まるごとスライス）",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625153",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3923134",
//         "JanCode": "4902220087495",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "菌茸類の缶詰",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産マッシュルームドライパック（まるごとスライス）",
//         "StandardName": "５０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625156",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3923169",
//         "JanCode": "4902220090426",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産果実　黄桃",
//         "StandardName": "２９５ｇ（固形量１７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625158",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3923185",
//         "JanCode": "4902220077151",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産スイートコーンドライパック",
//         "StandardName": "５０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625161",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3923215",
//         "JanCode": "4902220095247",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーンドライパック",
//         "StandardName": "５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625190",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3923533",
//         "JanCode": "4902220095308",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大豆ドライパック",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625195",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3923592",
//         "JanCode": "4902220094899",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大豆ドライパック",
//         "StandardName": "６０ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625196",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3923606",
//         "JanCode": "4902220094905",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本の野菜　笹切りごぼう",
//         "StandardName": "１８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625584",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3927938",
//         "JanCode": "4972560700255",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はじめて食べるもち麦",
//         "StandardName": "１５０ｇ（２５ｇ×６袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625646",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3928616",
//         "JanCode": "4902571161226",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産もち麦",
//         "StandardName": "８００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625651",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3928667",
//         "JanCode": "4902571130314",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶入りソフトパン（ストロベリー味）",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625700",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3929191",
//         "JanCode": "4900369427011",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶入りソフトパン（ブルーベリー味）",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625711",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3929310",
//         "JanCode": "4900369477207",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "長野県産　りんご蜜",
//         "StandardName": "１２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625728",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3929507",
//         "JanCode": "4969808006033",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "長野県産　あじわい里山蜜",
//         "StandardName": "１２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625729",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3929515",
//         "JanCode": "4969808107808",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "缶入りソフトパン（オレンジ味）",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625731",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3929531",
//         "JanCode": "4900369062038",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "長野県産　百花蜜",
//         "StandardName": "１２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625735",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3929582",
//         "JanCode": "4969808006019",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あわ雪ふ",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2625990",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3932400",
//         "JanCode": "4973322050106",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "かつおフレーク味付",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2626470",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3937720",
//         "JanCode": "4901901441366",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "使い切りかつおパック",
//         "StandardName": "１ｇ×３０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2626819",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3941582",
//         "JanCode": "4903065046555",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さばみそ煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2626862",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3942147",
//         "JanCode": "4972195030604",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産小粒どんこしいたけ",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2627454",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3948900",
//         "JanCode": "4970310035527",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産小粒どんこしいたけ",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2627464",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3949028",
//         "JanCode": "4970310035510",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産無選別しいたけエコパック",
//         "StandardName": "４５ｇ＋５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2627468",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3949060",
//         "JanCode": "4970310035534",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　栃木県産　和梨（豊水）",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2627605",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3950565",
//         "JanCode": "4901592922694",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000839",
//             "TagName": "ぜんざい"
//           }
//         ],
//         "GoodsName": "ぜんざい",
//         "StandardName": "１人前（１５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2627609",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3950611",
//         "JanCode": "4902560211819",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産５品目の海の恵み",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2627709",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3951723",
//         "JanCode": "4902371444109",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "つぶあん",
//         "StandardName": "６５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2628213",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3957381",
//         "JanCode": "4901401014428",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "こしあん",
//         "StandardName": "６５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2628215",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3957411",
//         "JanCode": "4901401014435",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "ケーキシロップ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000833",
//             "TagName": "シロップ"
//           }
//         ],
//         "GoodsName": "メイプルシロップ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2628216",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3957438",
//         "JanCode": "4901815887151",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産小豆使用ゆであずき　かるあま",
//         "StandardName": "１６５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2628218",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3957454",
//         "JanCode": "4904851700422",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産ごぼうドライパック",
//         "StandardName": "４０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2628751",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3963357",
//         "JanCode": "4902220093656",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "価値",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "恋香桃（白桃もちづき種）",
//         "StandardName": "２９５ｇ（固形量１７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2628932",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3965368",
//         "JanCode": "4902220095865",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "丹波黒黒大豆　２Ｌ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2629447",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3971139",
//         "JanCode": "4902220272556",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産３種の乾燥野菜ミックス",
//         "StandardName": "５３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2629481",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3971546",
//         "JanCode": "4902220272167",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000225",
//             "TagName": "いばらき"
//           }
//         ],
//         "GoodsName": "キムチ職人（粉末キムチの素）",
//         "StandardName": "２８ｇ（１４ｇ×２）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2629902",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3976165",
//         "JanCode": "4519527000821",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "新発田麩",
//         "StandardName": "４個",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2630442",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3982114",
//         "JanCode": "4960952591864",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ヨーグルトで食べようみかん（パウチ）",
//         "StandardName": "１５０ｇ（固形量４５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2631164",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3990095",
//         "JanCode": "4901605803163",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "釧路のいわし　水煮",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2631549",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3994376",
//         "JanCode": "4901901127567",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "ケーキシロップ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000833",
//             "TagName": "シロップ"
//           }
//         ],
//         "GoodsName": "コクと深みのケーキシロップ",
//         "StandardName": "１２０ｇ（２０ｇ×６）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2631642",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "3995380",
//         "JanCode": "4901760435766",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "昭和産業（食品）",
//         "OrderClient": "昭和産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "雑穀ぜんざい",
//         "StandardName": "１人前（２５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632436",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4004213",
//         "JanCode": "4994790301088",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "豆乳おからパウダー",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632461",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4004507",
//         "JanCode": "4959520000228",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九鬼　国産ごまふりかけ　のりかつお",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632738",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4007603",
//         "JanCode": "4972370500946",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000841",
//             "TagName": "その他"
//           }
//         ],
//         "GoodsName": "国産もち麦",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632902",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009401",
//         "JanCode": "4902220095773",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "ヘルシーコープ",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "秋田県産あきたこまちの発芽玄米（ドライタイプ）",
//         "StandardName": "７００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632903",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009428",
//         "JanCode": "4902220096701",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000225",
//             "TagName": "いばらき"
//           }
//         ],
//         "GoodsName": "田舎はちみつ　６月　涼葉",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632906",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009452",
//         "JanCode": "4580540310068",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手ずり風すりごま金",
//         "StandardName": "６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632915",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009541",
//         "JanCode": "4902220107483",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手ずり風すりごま黒",
//         "StandardName": "８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632916",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009568",
//         "JanCode": "4902220107469",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手ずり風すりごま白",
//         "StandardName": "８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632929",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009703",
//         "JanCode": "4902220107452",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "具が溶け込んだスパイシーカレー（辛口）",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632931",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009738",
//         "JanCode": "4901133763649",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "具が溶け込んだ深煮込み甘口カレー",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632937",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009797",
//         "JanCode": "4901133763618",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サラダチキン　プレーン",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632938",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009800",
//         "JanCode": "4901133069994",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "具が溶け込んだ　深煮込みカレー（中辛）",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632954",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4009975",
//         "JanCode": "4901133763601",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "具が溶け込んだ赤ワインカレー（中辛）",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2632959",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4010027",
//         "JanCode": "4901133763625",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "カナダ産純粋はちみつ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2633177",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4012429",
//         "JanCode": "4902220116485",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "切干大根（北海道産）",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2633617",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4017277",
//         "JanCode": "4902220084869",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "伊勢志摩産　芽ひじき",
//         "StandardName": "１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2633620",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4017307",
//         "JanCode": "4902220107490",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "芽ひじき（天然ひじき使用）≪韓国産≫",
//         "StandardName": "２２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2633624",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4017358",
//         "JanCode": "4902220115372",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "塩ひじき（国産芽ひじき使用）",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2633630",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4017412",
//         "JanCode": "4902220113996",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "徳用かつおパック（枯節）",
//         "StandardName": "２．５ｇ×３０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2633633",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4017447",
//         "JanCode": "4902220117086",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000774",
//             "TagName": "ＭＳＣ"
//           }
//         ],
//         "GoodsName": "はごろもシーチキンマイルド水煮",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2633638",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4017501",
//         "JanCode": "4902220093694",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "価値",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "帆立貝柱水煮フレーク",
//         "StandardName": "７０ｇ（固形量４０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634524",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4027388",
//         "JanCode": "4902150123263",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "アヲハタ　黒胡麻クリーム",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634743",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4029798",
//         "JanCode": "0000045201912",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付けうずら卵（しょうゆ）",
//         "StandardName": "１６個",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634745",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4029828",
//         "JanCode": "4975242017832",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "佐渡サーモン　銀ざけ中骨水煮",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634814",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4030575",
//         "JanCode": "4902150126516",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000774",
//             "TagName": "ＭＳＣ"
//           }
//         ],
//         "GoodsName": "はごろもシーチキンマイルド水煮",
//         "StandardName": "５０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634912",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4031652",
//         "JanCode": "4902220093694",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "価値",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "北海道十勝ねりあん",
//         "StandardName": "２７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634941",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4032047",
//         "JanCode": "4901486101662",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "北海道十勝つぶあん",
//         "StandardName": "２７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634947",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4032128",
//         "JanCode": "4901486101679",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップゼリー８０℃　オレンジ味",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634987",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4032551",
//         "JanCode": "4901138882819",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップゼリー８０℃　クール（サイダー味）",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634988",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4032578",
//         "JanCode": "4901138882888",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップゼリー８０℃　ピーチ味",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634989",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4032586",
//         "JanCode": "4901138882864",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップゼリー８０℃　青りんご味",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2634990",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4032594",
//         "JanCode": "4901138882833",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ぬか漬けの素",
//         "StandardName": "３００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635006",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4032764",
//         "JanCode": "4901108014936",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のさば　梅じそ風味",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635218",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4035194",
//         "JanCode": "4902431015263",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "あいこちゃんツナまぐろ水煮フレーク　食塩不使用",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635809",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4041801",
//         "JanCode": "4953009113812",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "あいこちゃんツナまぐろ水煮フレーク　食塩不使用",
//         "StandardName": "７０ｇ×１２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635812",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4041844",
//         "JanCode": "4953009113829",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "あいこちゃん　ツナまぐろ水煮フレーク",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635819",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4041917",
//         "JanCode": "4953009113775",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にんべん　フレッシュパックソフト",
//         "StandardName": "２ｇ×２０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635841",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4042166",
//         "JanCode": "4902381008438",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃんツナ　まぐろ油漬けフレーク　ガーリック",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635949",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4043359",
//         "JanCode": "4953009113782",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃんツナ　まぐろ油漬けフレーク　ガーリック",
//         "StandardName": "７０ｇ×１２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635951",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4043375",
//         "JanCode": "4953009113799",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキのコンビーフ",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635956",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4043421",
//         "JanCode": "0000049335330",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキのコンビーフ",
//         "StandardName": "８０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635958",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4043456",
//         "JanCode": "4902161610523",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000003",
//             "TagName": "低脂肪"
//           }
//         ],
//         "GoodsName": "ノザキの脂肪分５０％カットコンビーフ",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635963",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4043502",
//         "JanCode": "0000049335354",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000003",
//             "TagName": "低脂肪"
//           }
//         ],
//         "GoodsName": "ノザキの脂肪分５０％カットコンビーフ",
//         "StandardName": "８０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2635965",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4043529",
//         "JanCode": "4902161610554",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "はぼまい昆布しょうゆ味のり",
//         "StandardName": "１０切５０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636232",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4046471",
//         "JanCode": "4901673259527",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "秘伝つけ焼きいわし蒲焼",
//         "StandardName": "１００ｇ（固形量８０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636277",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4047028",
//         "JanCode": "4901901304234",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しおキャベツの素",
//         "StandardName": "１３ｇ×３袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636278",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4047036",
//         "JanCode": "4954797001183",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ラップｄｅカンタンぬかチューブ",
//         "StandardName": "１７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636293",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4047192",
//         "JanCode": "4954797002524",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "乳酸菌入り浅漬けの素",
//         "StandardName": "６０ｇ（２０ｇ×３）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636298",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4047249",
//         "JanCode": "4954797001794",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さけ（からふとます）水煮　復刻版",
//         "StandardName": "２２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636572",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4050371",
//         "JanCode": "4902165573589",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "バリバリ職人卓上味付のり",
//         "StandardName": "３０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636640",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4051122",
//         "JanCode": "4901191231708",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お手軽素材　国産　おからの粉",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636884",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4053834",
//         "JanCode": "4955974102624",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "無糖のあずき",
//         "StandardName": "１３５ｇ（４５ｇ×３）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636902",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4054024",
//         "JanCode": "4901006351157",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "すみっコぐらしふりかけ　容器入",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636962",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4054687",
//         "JanCode": "4902820123135",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "すみっコぐらしふりかけ　ミニパック",
//         "StandardName": "２０袋入（４種）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636963",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4054695",
//         "JanCode": "4902820120370",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃんツナ　まぐろ油漬けフレーク",
//         "StandardName": "７０ｇ×１２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636968",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4054741",
//         "JanCode": "4953009113737",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "あいこちゃんツナ　まぐろ油漬けフレーク",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636969",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4054768",
//         "JanCode": "4953009113720",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ふっくら蒸しミックス豆",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636970",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4054776",
//         "JanCode": "4901033725181",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "カット野菜",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ふっくら蒸し大豆",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2636971",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4054784",
//         "JanCode": "4901033725174",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "点心専科　マンゴープリン",
//         "StandardName": "５００ｇ（４～５人分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2637135",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4056582",
//         "JanCode": "4902635978241",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "点心専科　杏仁豆腐",
//         "StandardName": "５００ｇ（４～５人分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2637136",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4056590",
//         "JanCode": "4902635978234",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "台湾産無着色干しえび",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2637497",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4060555",
//         "JanCode": "4903156020198",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ヤマト食品株式会社",
//         "OrderClient": "ヤマト食品株式会社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "1",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "チップ入りゴーゴーごましおくん",
//         "StandardName": "２１ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2637674",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4062566",
//         "JanCode": "4902820106930",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "チップ入り手のりたま",
//         "StandardName": "１８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2637675",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4062574",
//         "JanCode": "4902820101959",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごま工房　味付けごま　たこ焼味",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2637676",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4062582",
//         "JanCode": "4901155313341",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "カット車麩",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2637765",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4063597",
//         "JanCode": "4960952591710",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "根昆布入りとろろ",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638216",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4068564",
//         "JanCode": "4902220122554",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "わしたポーク　鶏肉入り",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638417",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4070771",
//         "JanCode": "4996665003240",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "沖縄県物産公社",
//         "OrderClient": "沖縄県物産公社",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩浅漬けの素　レギュラー",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638418",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4070798",
//         "JanCode": "4901108015070",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手間いらずしょうが香る黒豆おこわ",
//         "StandardName": "２合用（３６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638537",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4072103",
//         "JanCode": "4904655110700",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーンドライパック",
//         "StandardName": "５５ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638652",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4073371",
//         "JanCode": "4902220095308",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産厚切り洋梨",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638856",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4075633",
//         "JanCode": "4901401201873",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産大粒みかん",
//         "StandardName": "１９０ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638857",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4075641",
//         "JanCode": "4901401010499",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "他単一フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産厚切りりんご",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638858",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4075668",
//         "JanCode": "4901401201866",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産厚切り黄桃",
//         "StandardName": "１９５ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638859",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4075676",
//         "JanCode": "4901401010345",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "密陽寒天",
//         "StandardName": "２本入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638907",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4076206",
//         "JanCode": "4971889121185",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "早採りこんぶやわらか一番",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2638966",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4076850",
//         "JanCode": "4905923750451",
//         "LargeClassName": "乾物",
//         "PayeeClient": "フレッシュフーズ九州（食品）",
//         "OrderClient": "フレッシュフーズ九州（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "鮭の中骨水煮（銀鮭中骨水煮）",
//         "StandardName": "１７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2639401",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4081641",
//         "JanCode": "4986302203409",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産小粒どんこしいたけ",
//         "StandardName": "５０ｇ＋５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2639520",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4082966",
//         "JanCode": "4970310035602",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "瀬戸内海産　食べる煮干し",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2639628",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4084152",
//         "JanCode": "4902220094738",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "早戻し九州産軸なししいたけ≪小葉≫",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2639634",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4084217",
//         "JanCode": "4902220122622",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ちっちゃなひとくちこうや豆腐だし付き",
//         "StandardName": "８６ｇ（こうや豆腐５６ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2639636",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4084233",
//         "JanCode": "4902220122660",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産くきわかめ",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640166",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4090055",
//         "JanCode": "4902220123452",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "とろけるプリン",
//         "StandardName": "１０人分（５人分×２）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640357",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4092163",
//         "JanCode": "4901138884684",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "液体塩こうじ",
//         "StandardName": "３００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640527",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4094042",
//         "JanCode": "4902401509686",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フレッシュパック本枯鰹節物語",
//         "StandardName": "２．５ｇ×２０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640684",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4095820",
//         "JanCode": "4902381205936",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本橋だし場　かつぶしめし削り",
//         "StandardName": "３ｇ×７袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640685",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4095839",
//         "JanCode": "4902381208869",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "本枯鰹節ソフト削り血合い抜き",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640686",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4095847",
//         "JanCode": "4902381207817",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "本枯鰹節糸削り血合い抜き",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640687",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4095855",
//         "JanCode": "4902381207800",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "プラス糀　発酵ぬかどこ",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640690",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4095898",
//         "JanCode": "4549671001078",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000069",
//             "TagName": "節分"
//           }
//         ],
//         "GoodsName": "焼のり寿司はね",
//         "StandardName": "板のり１０枚×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640725",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4096282",
//         "JanCode": "4902220134373",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産３種の根菜スライスミックス",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2640999",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4099303",
//         "JanCode": "4902220116973",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "国内産ハトムギ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2641459",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4104447",
//         "JanCode": "4994790313180",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ふりかける野菜（玉ねぎミックス）",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2641685",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4106946",
//         "JanCode": "4580553490122",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "丹波篠山黒豆　２Ｌ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2642214",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4112814",
//         "JanCode": "4908549016062",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "丹波篠山黒豆　３Ｌ",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2642215",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4112822",
//         "JanCode": "4908549016055",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "プチ蜜－華",
//         "StandardName": "２５ｇ×３本",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2642501",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4116038",
//         "JanCode": "4580540310259",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "プチ蜜－雅",
//         "StandardName": "２５ｇ×３本",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2642502",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4116046",
//         "JanCode": "4580540310266",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "おにぎり具材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000133",
//             "TagName": "価値コマ"
//           }
//         ],
//         "GoodsName": "三陸産茎わかめご飯の素",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2642667",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4117859",
//         "JanCode": "4903307679503",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "加賀棒ほうじ茶ラテクリーム",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2642750",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4118766",
//         "JanCode": "4901401202115",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "糀パウダー",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2642751",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4118774",
//         "JanCode": "4582496696043",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道のいわし水煮",
//         "StandardName": "１５０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2643110",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4122720",
//         "JanCode": "4901901331186",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産一番摘み味付のり",
//         "StandardName": "１０切５０枚（板のり５枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2643761",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4129881",
//         "JanCode": "4902220123056",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お徳用塩こんぶ",
//         "StandardName": "５８ｇ×２袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2643919",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4131711",
//         "JanCode": "4901159624641",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "産直信州産ふじりんごで作ったりんごジャム",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2643935",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4131894",
//         "JanCode": "4902220124435",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "1",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "青のり",
//         "StandardName": "２．３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2644341",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4136403",
//         "JanCode": "4977873852424",
//         "LargeClassName": "乾物",
//         "PayeeClient": "千年屋",
//         "OrderClient": "千年屋",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ハンガリー産アカシアはちみつ",
//         "StandardName": "７５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2644343",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4136438",
//         "JanCode": "4902395168432",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "やきとりたれ味",
//         "StandardName": "７５ｇ（固形量５５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2644511",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4138279",
//         "JanCode": "4902511011499",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃん牡蠣油漬　にんにく入り",
//         "StandardName": "１６０ｇ（固形量７５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2645018",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4143892",
//         "JanCode": "4953009113911",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "炊き込みご飯の具材",
//         "StandardName": "３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2645020",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4143914",
//         "JanCode": "4972150922937",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "銀ざけ中骨水煮",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2645908",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4153790",
//         "JanCode": "4902150125069",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しそ入りひじきふりかけ（増量）",
//         "StandardName": "１００ｇ＋１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2645982",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4154614",
//         "JanCode": "4902371254111",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にんべん　鶏そぼろふりかけ",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2646303",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4158156",
//         "JanCode": "4902381008834",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "お茶漬",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "永谷園のお茶づけ海苔",
//         "StandardName": "８袋入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2646305",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4158172",
//         "JanCode": "4902388002200",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "鯖味噌煮　九州旬のさば使用",
//         "StandardName": "１５０ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2646467",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4159969",
//         "JanCode": "4941821000328",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "めちゃラクアイスの素　バニラ風味",
//         "StandardName": "２～３人分（５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2646775",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4163370",
//         "JanCode": "4902170096035",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "瀬戸内レモンのレモネード",
//         "StandardName": "６００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2646980",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4165632",
//         "JanCode": "4901401202535",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "８月のジャム　いちじく",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2646981",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4165640",
//         "JanCode": "4908010734433",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "９月のジャム　くり",
//         "StandardName": "１５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2646982",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4165659",
//         "JanCode": "4908010734440",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "プラス糀　発酵ぬかどこ補充用",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2647422",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4170598",
//         "JanCode": "4549671001450",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           },
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "生塩こうじ　麹の花",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2647617",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4172744",
//         "JanCode": "4902663013914",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三杯酢　伊豆産天草使用　ところてん（たれ付）",
//         "StandardName": "８５ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2647657",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4173171",
//         "JanCode": "4978263300396",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "一番採り生どんこ使用　椎茸",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2647864",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4175522",
//         "JanCode": "4985761820165",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お徳用くるま麩（無選別）",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2647876",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4175662",
//         "JanCode": "4960952592083",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さんま缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さんま蒲焼",
//         "StandardName": "１００ｇ（固形量８０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649019",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4188489",
//         "JanCode": "4901901375777",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000002",
//             "TagName": "低糖質"
//           },
//           {
//             "TagId": "00000578",
//             "TagName": "糖質オフ"
//           },
//           {
//             "TagId": "00000839",
//             "TagName": "ぜんざい"
//           }
//         ],
//         "GoodsName": "甘さすっきりの糖質・カロリー５０％オフ豆乳ぜんざい",
//         "StandardName": "１人前（１５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649084",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4189183",
//         "JanCode": "4901011600608",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産カットわかめ（増量）",
//         "StandardName": "１５ｇ＋１．５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649368",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4192338",
//         "JanCode": "4902371412115",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付のり　卓上タイプ（スタンドタイプ）",
//         "StandardName": "１０切９０枚（板のり９枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649409",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4192761",
//         "JanCode": "4902220146635",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付のり≪卓上タイプ≫",
//         "StandardName": "１０切８０枚（板のり８枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649410",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4192788",
//         "JanCode": "4902220146604",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "本枯節かつおパックソフト削り（鹿児島県枕崎製造本枯節使用）",
//         "StandardName": "３ｇ×１０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649445",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4193164",
//         "JanCode": "4902220136728",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃん　中骨入り鱒味付け昆布仕込",
//         "StandardName": "１５０ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649579",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4194640",
//         "JanCode": "4953009113973",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "岩手県産北限の干しあみえび",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649625",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4195140",
//         "JanCode": "4972488004060",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "かに缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "かにみそ　かに肉入り",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649626",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4195159",
//         "JanCode": "4901901248026",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印　純粋ひまわりはちみつ",
//         "StandardName": "７５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649627",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4195167",
//         "JanCode": "4901390181514",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "フルーツソース",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ブルーベリーソース",
//         "StandardName": "３２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649654",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4195485",
//         "JanCode": "4964937022206",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "フルーツソース",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ストロベリーソース",
//         "StandardName": "３２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649655",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4195493",
//         "JanCode": "4964937022213",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付のり詰め替え用",
//         "StandardName": "１２切９０枚（板のり７．５枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649800",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4197097",
//         "JanCode": "4901191231197",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しじみ醤油味付のり詰め替え用",
//         "StandardName": "１２切９０枚（板のり７．５枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2649801",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4197100",
//         "JanCode": "4901191231081",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産光黒大豆",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2650592",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4205871",
//         "JanCode": "4907129101112",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "みやここうじ",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2650606",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4206037",
//         "JanCode": "4970085017711",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "かに缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるずわいがにほぐしみ",
//         "StandardName": "固形量１１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2650608",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4206053",
//         "JanCode": "4901901377986",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "めちゃラクレンジケーキミックス　プレーン",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2650816",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4208366",
//         "JanCode": "4902170096165",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産ちりめん",
//         "StandardName": "３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2650952",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4209869",
//         "JanCode": "4902220283835",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シャキッとコーンクリーム",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2651211",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4212711",
//         "JanCode": "4902560226219",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃん牛タンそぼろ",
//         "StandardName": "６０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2651701",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4218167",
//         "JanCode": "4953009113997",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "直火焼　かつお厚削り",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652076",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4222296",
//         "JanCode": "4902833223471",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産　大納言小豆",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652140",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4223004",
//         "JanCode": "4902220272648",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "麦",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "胚芽押麦",
//         "StandardName": "５４０ｇ（４５ｇ×１２袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652141",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4223012",
//         "JanCode": "4902220154555",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "きなこ餅",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652142",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4223020",
//         "JanCode": "4901075021326",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "越後製菓",
//         "OrderClient": "越後製菓",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あんこ餅",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652143",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4223039",
//         "JanCode": "4901075021333",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "越後製菓",
//         "OrderClient": "越後製菓",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "コメダ特製小倉あん",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652338",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4225171",
//         "JanCode": "4958655202453",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "北海道白口浜産　天然函館真昆布",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652487",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4226828",
//         "JanCode": "4972150923781",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナスーパーノンオイル",
//         "StandardName": "５０ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652536",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4227360",
//         "JanCode": "4901133999345",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトかつおフレーク",
//         "StandardName": "５０ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652544",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4227441",
//         "JanCode": "4901133999352",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いちごバター（国産いちご使用）",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652720",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4229428",
//         "JanCode": "4901401202795",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000805",
//             "TagName": "乾物びより"
//           }
//         ],
//         "GoodsName": "京都産丹波大納言小豆",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652756",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4229819",
//         "JanCode": "4908520850289",
//         "LargeClassName": "乾物",
//         "PayeeClient": "全国農協食品",
//         "OrderClient": "全国農協食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "２月のジャム　日向夏",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652919",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4231600",
//         "JanCode": "4908010734372",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "４月のジャム　河内晩柑",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652921",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4231627",
//         "JanCode": "4908010734402",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "５月のジャム　うめ",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652922",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4231635",
//         "JanCode": "4908010734396",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "６月のジャム　パイナップル",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652923",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4231643",
//         "JanCode": "4908010734488",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "７月のジャム　白桃",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2652924",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4231651",
//         "JanCode": "4908010734426",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "フルーツソース",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "蔵王高原農園　キウイソース",
//         "StandardName": "３２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653181",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4234472",
//         "JanCode": "4964937022220",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "コメダ珈琲店　パキッテこしあん",
//         "StandardName": "２７ｇ×３個",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653386",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4236734",
//         "JanCode": "4958655400354",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "焼きとりヤンニョム味",
//         "StandardName": "６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653508",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4238087",
//         "JanCode": "4901133579561",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "伊勢志摩産天然カットわかめ",
//         "StandardName": "１０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653509",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4238095",
//         "JanCode": "4902378033009",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "蔵王高原農園　果肉入りミックスゼリー",
//         "StandardName": "８３ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653511",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4238117",
//         "JanCode": "4964937050926",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "牛焼肉",
//         "StandardName": "８５ｇ（固形量６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653514",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4238141",
//         "JanCode": "4902150122051",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ガパオ＆ごはん　本場ジャスミンライスとガパオ",
//         "StandardName": "ガパオ１１５ｇ・ごはん１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653880",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4242203",
//         "JanCode": "4901133785023",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "タイカレー＆ごはん　本場ジャスミンライスとグリーンカレー",
//         "StandardName": "カレー１１５ｇ・ごはん１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2653881",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4242211",
//         "JanCode": "4901133785016",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "アルゼンチン産純粋はちみつ",
//         "StandardName": "１２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654015",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4243692",
//         "JanCode": "4902395268149",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ＳｕｉＳｕｉオープン　うまい！鯖匠　さば水煮",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654204",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4245784",
//         "JanCode": "4902150131084",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ＳｕｉＳｕｉオープンうまい！鯖匠　さばみそ煮",
//         "StandardName": "１８０ｇ（固形量１３５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654205",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4245792",
//         "JanCode": "4902150131091",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ＳｕｉＳｕｉオープン　うまい！鯖匠　さば煮付",
//         "StandardName": "１８０ｇ（固形量１３５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654206",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4245806",
//         "JanCode": "4902150131107",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ＳｕｉＳｕｉオープン　うまい！鯖匠　さばうめ風味",
//         "StandardName": "１８０ｇ（固形量１３５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654207",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4245814",
//         "JanCode": "4902150131114",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１０月のジャム　ラ・フランス",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654245",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4246233",
//         "JanCode": "4908010734457",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１１月のジャム　ふじりんご",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654246",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4246241",
//         "JanCode": "4908010734464",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "抽選8,000",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１２月のジャム　ネーブルオレンジ",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654247",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4246268",
//         "JanCode": "4908010734471",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１月のジャム　ゴールドキウイ",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654248",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4246276",
//         "JanCode": "4908010734365",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "紅はるかのさつま芋バター",
//         "StandardName": "１５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654489",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4248910",
//         "JanCode": "4902220157280",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産　無着色　小えび",
//         "StandardName": "１６ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654492",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4248945",
//         "JanCode": "4902220157037",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000056",
//             "TagName": "カルシウム補給"
//           }
//         ],
//         "GoodsName": "ホイップココアクリーム　Ｃａ入",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654493",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4248953",
//         "JanCode": "4902220144877",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ミックスビーンズドライパック",
//         "StandardName": "５５ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654550",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4249585",
//         "JanCode": "4902220159130",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ミックスビーンズドライパック",
//         "StandardName": "５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654551",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4249593",
//         "JanCode": "4902220159123",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ミックスビーンズドライパック",
//         "StandardName": "１２０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654552",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4249607",
//         "JanCode": "4902220159154",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ミックスビーンズドライパック",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654767",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4251970",
//         "JanCode": "4902220159147",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "素のまま国産野菜　みそ汁の具　キャベツと３種の野菜",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654914",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4253582",
//         "JanCode": "4901592926357",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "素のまま国産野菜　みそ汁の具　白菜と３種の野菜",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654916",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4253604",
//         "JanCode": "4901592926364",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごまミックス",
//         "StandardName": "１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654950",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4253973",
//         "JanCode": "4571107213328",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産青のり入焼のり",
//         "StandardName": "板のり１０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654951",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4253981",
//         "JanCode": "4902122047108",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産極手巻のり",
//         "StandardName": "２切１０枚（板のり５枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654952",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4254007",
//         "JanCode": "4902122045715",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手すきおぼろ昆布",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2654953",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4254015",
//         "JanCode": "4979547134812",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "つぶあんジャム",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655576",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4260961",
//         "JanCode": "4901815880275",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あま酒かたねり（濃縮タイプ）",
//         "StandardName": "３５０ｇ（５人前）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655619",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4261437",
//         "JanCode": "4970085022838",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "涼味専科　杏仁豆腐",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655641",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4261682",
//         "JanCode": "4902635979019",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "涼味専科　マンゴープリン",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655642",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4261690",
//         "JanCode": "4902635979026",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "涼味専科　みつまめ",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655643",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4261704",
//         "JanCode": "4902635979033",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "たいまつ食品",
//         "OrderClient": "たいまつ食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さばみそ煮",
//         "StandardName": "８０ｇ（固形量６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655861",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4264118",
//         "JanCode": "4902220312702",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655862",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4264126",
//         "JanCode": "4902220312733",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "切干大根（宮崎県産）",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2655895",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4264487",
//         "JanCode": "4902220271733",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さばみそ煮",
//         "StandardName": "８０ｇ（固形量６０ｇ）×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656009",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4265734",
//         "JanCode": "4902220979851",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮",
//         "StandardName": "８０ｇ×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656010",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4265742",
//         "JanCode": "4902220979844",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "プラス糀　発酵ぬかどこチューブ",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656251",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4268415",
//         "JanCode": "4549671001535",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産　ふのり",
//         "StandardName": "８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656316",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4269144",
//         "JanCode": "4582324211462",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "塩こうじ（徳用）",
//         "StandardName": "４２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656613",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4272501",
//         "JanCode": "4902401510040",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるごと国産みかん（身割れ入り）",
//         "StandardName": "１９０ｇ（固形量９５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656670",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4273133",
//         "JanCode": "4901605330614",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "“ＣＡＮ”Ｐの達人　グリーンバーガーソイパティテリヤキソース",
//         "StandardName": "１４０ｇ（固形量８５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656772",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4274245",
//         "JanCode": "4901592927323",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "”ＣＡＮ”Ｐの達人　グリーンバーガーソイパティトマトのソース",
//         "StandardName": "１４０ｇ（固形量８５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656773",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4274253",
//         "JanCode": "4901592927316",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "氷温熟成さば水煮",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656873",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4275365",
//         "JanCode": "4901133114694",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お釜にポン",
//         "StandardName": "４．６ｇ×５０粒",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656903",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4275691",
//         "JanCode": "4901760432604",
//         "LargeClassName": "乾物",
//         "PayeeClient": "昭和産業（食品）",
//         "OrderClient": "昭和産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "やきとり　６缶アソート",
//         "StandardName": "６種各１缶",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2656987",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4276612",
//         "JanCode": "4902511012472",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱",
//         "StandardName": "６５ｇ（固形量３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657192",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4278879",
//         "JanCode": "4901901032274",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱（形不揃い）",
//         "StandardName": "１２５ｇ（固形量５５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657193",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4278887",
//         "JanCode": "4902165434866",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱（形不揃い）",
//         "StandardName": "１２５ｇ（固形量５５ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657194",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4278895",
//         "JanCode": "4902165619645",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば味付",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657729",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4284828",
//         "JanCode": "4972195031106",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のさば味付醤油味",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657730",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4284836",
//         "JanCode": "4902431070293",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産原料十六穀ごはんの素",
//         "StandardName": "２５ｇ×８袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657907",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4286774",
//         "JanCode": "4902220171422",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "こうや豆腐　徳用",
//         "StandardName": "１６５ｇ（１０個入）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657908",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4286782",
//         "JanCode": "4902220272396",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "おにぎり具材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "五色の花むすび",
//         "StandardName": "１合用×８袋入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657909",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4286790",
//         "JanCode": "4902220174850",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "期間限定　ふりかけチップトリオ",
//         "StandardName": "１５ｇ（６袋入）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2657973",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4287509",
//         "JanCode": "4902820101973",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "そいたん　畑の肉と牛タンの甘辛醤油そぼろ",
//         "StandardName": "６０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2658291",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4291018",
//         "JanCode": "4953009114062",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　静岡県産　三ヶ日みかん",
//         "StandardName": "１９０ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2658315",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4291263",
//         "JanCode": "4901592927064",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ゆかり味付のりカップＲ　しそ風味",
//         "StandardName": "８切３２枚（板のり４枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2658401",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4292219",
//         "JanCode": "4903182042072",
//         "LargeClassName": "乾物",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000774",
//             "TagName": "ＭＳＣ"
//           }
//         ],
//         "GoodsName": "ＭＳＣツナフレーク油漬（パウチ）",
//         "StandardName": "５０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2658494",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4293231",
//         "JanCode": "4901901625568",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "1",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "花の真珠　国産百花純粋はちみつ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2658995",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4298756",
//         "JanCode": "4973882122770",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "埼玉養蜂",
//         "OrderClient": "埼玉養蜂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "花の真珠　国産あかしあ純粋はちみつ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2658996",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4298764",
//         "JanCode": "4973882122763",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "埼玉養蜂",
//         "OrderClient": "埼玉養蜂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付韓国のり卓上タイプ",
//         "StandardName": "８切４０枚（板のり５枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659425",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4303601",
//         "JanCode": "4902604902567",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000839",
//             "TagName": "ぜんざい"
//           }
//         ],
//         "GoodsName": "十勝産小豆のぜんざい　カロリーオフ",
//         "StandardName": "１６０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659575",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4305337",
//         "JanCode": "4902220176359",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーズンセレクト　メイプルりんごバター",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659577",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4305353",
//         "JanCode": "4902220176861",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "しょうが湯（高知県産しょうが使用）",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659578",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4305361",
//         "JanCode": "4902220178193",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "清水もつカレー",
//         "StandardName": "１７０ｇ（固形量６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659744",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4307208",
//         "JanCode": "4902560060035",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ヤンニョムツナ",
//         "StandardName": "６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659985",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4309847",
//         "JanCode": "4901133063039",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "唐辛子ツナ野菜入り",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659986",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4309855",
//         "JanCode": "4901133063138",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "パン・アキモト　おいしい備蓄食　ＰＡＮＣＡＮ　６缶セット",
//         "StandardName": "３種各２缶",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2659998",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4309995",
//         "JanCode": "4900369472011",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000069",
//             "TagName": "節分"
//           }
//         ],
//         "GoodsName": "炊くだけおこわ　赤飯小豆おこわ",
//         "StandardName": "２合用",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2660159",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4311787",
//         "JanCode": "4902220176885",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "らくらく炊きたてくり入り赤飯おこわ",
//         "StandardName": "２合用",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2660784",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4318706",
//         "JanCode": "4901011613677",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートチーズクリーム",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2660888",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4319850",
//         "JanCode": "4902220176793",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産焼のり　おにぎり・おもち用",
//         "StandardName": "３切５０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2660935",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4320379",
//         "JanCode": "4902220185283",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000300",
//             "TagName": "とちぎ"
//           }
//         ],
//         "GoodsName": "北海道ゆであずき（パウチ）",
//         "StandardName": "２００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2661273",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4324080",
//         "JanCode": "4901006310833",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "純粋アルゼンチン＆ハンガリー産はちみつ〈倒立容器〉",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2661302",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4324447",
//         "JanCode": "4976173104479",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "純粋アルゼンチン＆カナダ産はちみつ",
//         "StandardName": "７２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2661303",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4324455",
//         "JanCode": "4976173104295",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "純粋アルゼンチン＆カナダ産はちみつ",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2661304",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4324463",
//         "JanCode": "4976173104417",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000002",
//             "TagName": "低糖質"
//           }
//         ],
//         "GoodsName": "ぜんざい　糖質４０％オフ",
//         "StandardName": "１人前（１５０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2661944",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4331559",
//         "JanCode": "4902560212236",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "かに缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるずわいがにほぐしみ",
//         "StandardName": "５５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2662478",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4337476",
//         "JanCode": "4901901384953",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ふえるわかめちゃん　三陸わかめお徳用",
//         "StandardName": "２８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2662857",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4341643",
//         "JanCode": "4903307623261",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ピスタチオクリーム（ピスタチオ粒入り）",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663141",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4344766",
//         "JanCode": "4902220178254",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ゼラチン",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663142",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4344774",
//         "JanCode": "4902220480425",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さんま缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ゆずが香る　さんまみぞれ煮",
//         "StandardName": "１００ｇ（固形量８０ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663334",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4346882",
//         "JanCode": "4901901649779",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "桃缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産白桃（不揃い）",
//         "StandardName": "１９５ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663338",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4346920",
//         "JanCode": "4901605301935",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーチェＳｗｅｅｔｓ　マンゴー杏仁",
//         "StandardName": "１５０ｇ（３人分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663627",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4350111",
//         "JanCode": "4902402900154",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "木村屋總本店監修　小倉あんバター",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663632",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4350170",
//         "JanCode": "4958655202798",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ゆであずき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道カップゆであずき",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663664",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4350510",
//         "JanCode": "4901006310826",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000868",
//             "TagName": "年末商材"
//           }
//         ],
//         "GoodsName": "丹波黒大豆　特粒",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663786",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4351878",
//         "JanCode": "4907129100726",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "お茶漬",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "春の七草　七草茶漬",
//         "StandardName": "３袋入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2663898",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4353099",
//         "JanCode": "4901673854159",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナフレーク　オイル無添加",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664049",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4354753",
//         "JanCode": "4902220194094",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道厚真産ハスカップでつくったジャム",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664271",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4357191",
//         "JanCode": "4901401202603",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "アスパラガス缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "訳あってお得　北海道産アスパラガス",
//         "StandardName": "２５０ｇ（固形量１６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664272",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4357205",
//         "JanCode": "4901504051139",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ぜんざいファミリーパック　４人前",
//         "StandardName": "４００ｇ（２００ｇ×２袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664286",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4357353",
//         "JanCode": "4901006370325",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "惣菜缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "松屋牛めし缶",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664376",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4358406",
//         "JanCode": "4907982024092",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印　アルゼンチン産＆カナダ産純粋はちみつ",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664552",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4360370",
//         "JanCode": "4901390181958",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "サクラ印　アルゼンチン産＆カナダ産純粋はちみつ",
//         "StandardName": "７００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664553",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4360389",
//         "JanCode": "4901390181965",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           },
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "あいこちゃん鰯水煮　食塩不使用",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664770",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4362764",
//         "JanCode": "4953009113928",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カップゼリー８０℃　ストロベリー味",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2664944",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4364767",
//         "JanCode": "4901138882802",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "海藻サラダ",
//         "StandardName": "８ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2665049",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4365917",
//         "JanCode": "4902220187942",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "海藻サラダ",
//         "StandardName": "１６ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2665050",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4365925",
//         "JanCode": "4902220187959",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "プラス糀　生塩糀　お徳用",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2665857",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4374800",
//         "JanCode": "4902713126519",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "３月のジャムとちおとめ",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666222",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4378814",
//         "JanCode": "4908012325202",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "炊き込みわかめ",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666562",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4382560",
//         "JanCode": "4902765001192",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "産直ごぼうで作った乾燥ごぼう",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666711",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4384199",
//         "JanCode": "4902220195732",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "即席漬の素",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "白キムチの素",
//         "StandardName": "３００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666792",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4385098",
//         "JanCode": "4977071104462",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ポールスタア",
//         "OrderClient": "ポールスタア",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢みかん",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666965",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4386981",
//         "JanCode": "4901901647522",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢ミックス",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666966",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4387007",
//         "JanCode": "4901901647553",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢みかん",
//         "StandardName": "１９０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666968",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4387023",
//         "JanCode": "4901901647522",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢ミックス",
//         "StandardName": "１９０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2666972",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4387074",
//         "JanCode": "4901901647553",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "混ぜ込みきざみたくあん",
//         "StandardName": "３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667114",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4388623",
//         "JanCode": "4901049104840",
//         "LargeClassName": "乾物",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "早摘みあかもく",
//         "StandardName": "１３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667120",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4388704",
//         "JanCode": "4902903090231",
//         "LargeClassName": "乾物",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産の果実をつかった　いちごジャム",
//         "StandardName": "３６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667145",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4388984",
//         "JanCode": "4902220199112",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "産直栃木県産とちおとめで作ったいちごのソース",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667146",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4388992",
//         "JanCode": "4902220191758",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大きな果肉のいちごジャム",
//         "StandardName": "３６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667147",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389018",
//         "JanCode": "4902220199129",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大きな果肉のチェリージャム",
//         "StandardName": "３６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667149",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389034",
//         "JanCode": "4902220199174",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大きな果肉のブルーベリージャム",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667150",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389042",
//         "JanCode": "4902220199105",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大きな果肉のりんごジャム",
//         "StandardName": "３６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667151",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389050",
//         "JanCode": "4902220199181",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大きな果肉のブルーベリージャム甘さひかえめ",
//         "StandardName": "３８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667152",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389069",
//         "JanCode": "4902220199136",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢ぶどう",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667196",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389549",
//         "JanCode": "4901901647638",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "竜王黒大豆　特粒（滋賀県産丹波黒大豆）",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667197",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389557",
//         "JanCode": "4907129101303",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "くらこん　減塩塩こんぶ",
//         "StandardName": "２７ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667199",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389573",
//         "JanCode": "4901159904163",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "くらこん　塩こんぶ",
//         "StandardName": "５０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667200",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389581",
//         "JanCode": "4901159824645",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "くらこん　減塩塩こんぶ",
//         "StandardName": "２７ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667201",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389603",
//         "JanCode": "4901159224216",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢ぶどう",
//         "StandardName": "１９０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667203",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4389638",
//         "JanCode": "4901901647638",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーチキンＳｍｉｌｅ　水煮Ｌフレーク",
//         "StandardName": "５０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667264",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4390288",
//         "JanCode": "4902560022309",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーズンセレクト　いちごミルク",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667592",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4394003",
//         "JanCode": "4902220192625",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いわし蒲焼",
//         "StandardName": "９０ｇ（固形量６０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667593",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4394011",
//         "JanCode": "4972195025280",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いわし蒲焼",
//         "StandardName": "９０ｇ（固形量６０ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667594",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4394038",
//         "JanCode": "4972195079788",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "日本のさば水煮　食塩不使用　昆布だし使用",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667601",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4394100",
//         "JanCode": "4902431027464",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "伊勢志摩産カットわかめ（ＭＥＬ認証）",
//         "StandardName": "１２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2667807",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4396367",
//         "JanCode": "4902220192731",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "旬獲れ鯖味噌煮",
//         "StandardName": "１７５ｇ（固形量１３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668014",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4398645",
//         "JanCode": "4953009114109",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "旬獲れ鯖水煮",
//         "StandardName": "１７５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668015",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4398653",
//         "JanCode": "4953009114093",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ハチミツ",
//         "SmallClassName": "はちみつ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "アルゼンチン産純粋はちみつ",
//         "StandardName": "４００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668017",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4398688",
//         "JanCode": "4902220198061",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三島の青のり",
//         "StandardName": "３．２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668117",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4399803",
//         "JanCode": "4902765001482",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "めちゃラク　カスタードクリームミックス",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668330",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4402162",
//         "JanCode": "4902170096462",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "めちゃラク　レンジでクレープミックス",
//         "StandardName": "７０ｇ（６枚分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668331",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4402170",
//         "JanCode": "4902170096479",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "夕張メロンプリン",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668626",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4405412",
//         "JanCode": "4970249000719",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さばみそ煮",
//         "StandardName": "１６０ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668726",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4406524",
//         "JanCode": "4972195030727",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば水煮",
//         "StandardName": "１６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668727",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4406532",
//         "JanCode": "4972195030277",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産４種の豆のミックスビーンズドライパック",
//         "StandardName": "５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668968",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4409191",
//         "JanCode": "4902220192113",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "1",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "豆類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産４種の豆のミックスビーンズドライパック",
//         "StandardName": "５５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2668969",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4409205",
//         "JanCode": "4902220192120",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "1",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000776",
//             "TagName": "ＳＰ"
//           }
//         ],
//         "GoodsName": "ヤマキ　かつおパック",
//         "StandardName": "２ｇ×４０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669042",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4410017",
//         "JanCode": "4903065046616",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シャリーチェ×カルピス",
//         "StandardName": "１８０ｇ（２～３人分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669105",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4410718",
//         "JanCode": "4902402906958",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シャリーチェ　スイカソーダ味",
//         "StandardName": "１８０ｇ（２～３人分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669121",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4410882",
//         "JanCode": "4902402901472",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のいわし水煮",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669142",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4411110",
//         "JanCode": "4902431026795",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のいわし味噌煮",
//         "StandardName": "１４０ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669143",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4411129",
//         "JanCode": "4902431024876",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "日本のいわし味付",
//         "StandardName": "１４０ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669144",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4411137",
//         "JanCode": "4902431024883",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごま油香る　味付韓国産もみのり",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669264",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4412478",
//         "JanCode": "4902220136537",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産はるさめ",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669327",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4413156",
//         "JanCode": "4902938031995",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃん脂のりのり　いわし　生姜パワー",
//         "StandardName": "１４０ｇ（固形量９５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669817",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4418581",
//         "JanCode": "4953009114123",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産鯖水煮",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669820",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4418638",
//         "JanCode": "4907982024047",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産鯖味噌煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669821",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4418646",
//         "JanCode": "4907982022173",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ピンクグレープフルーツジャム",
//         "StandardName": "２８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669822",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4418654",
//         "JanCode": "4901401204102",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "秋鮭の中骨水煮",
//         "StandardName": "１７５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669823",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4418662",
//         "JanCode": "4907982051166",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "パインアップル缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "Ｋ＆Ｋ　インドネシアパインスライス（輪切り）",
//         "StandardName": "５６５ｇ（固形量３４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669899",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4419537",
//         "JanCode": "4901592929242",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ＳｕｉＳｕｉオープンさば水煮２缶パック",
//         "StandardName": "１８０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2669935",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4419952",
//         "JanCode": "4902150132050",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒いわし蒲焼",
//         "StandardName": "１００ｇ（固形量８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670167",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4422503",
//         "JanCode": "4571133671680",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒いわし水煮",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670168",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4422511",
//         "JanCode": "4571133671628",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "寒いわし水煮食塩不使用",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670169",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4422538",
//         "JanCode": "4571133671635",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "うまい！いわし味噌煮",
//         "StandardName": "１５０ｇ（固形量９５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670279",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4423720",
//         "JanCode": "4901688111872",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "うまい！いわし醤油煮",
//         "StandardName": "１５０ｇ（固形量９５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670280",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4423739",
//         "JanCode": "4901688111865",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "液切りしないで使える！国産鶏ささみフレーク",
//         "StandardName": "４０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670281",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4423747",
//         "JanCode": "4901688130804",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーチキンＳｍｉｌｅ　Ｌフレーク",
//         "StandardName": "５０ｇ×８",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670300",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4423968",
//         "JanCode": "4902560022378",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒いわし醤油煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670468",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4425804",
//         "JanCode": "4571133671604",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "寒いわし味噌煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670469",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4425812",
//         "JanCode": "4571133671611",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "俺のＢａｋｅｒｙ絶品フレンチトースト風",
//         "StandardName": "９５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670535",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4426584",
//         "JanCode": "4550454738760",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "瀬戸内からの贈り物　レモンママレード",
//         "StandardName": "１９５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670627",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4427580",
//         "JanCode": "4562452231761",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "パントッピング",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "かけるご褒美　あん×バター",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670679",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4428153",
//         "JanCode": "4901006372633",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "パントッピング",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "つぶあんトッピング",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2670680",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4428161",
//         "JanCode": "4901006370226",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "音戸にぼし",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671105",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4432908",
//         "JanCode": "4901497466309",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "焼きとり　たれ味",
//         "StandardName": "６５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671192",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4433858",
//         "JanCode": "4901133568138",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナアイフレーク",
//         "StandardName": "５５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671312",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4435184",
//         "JanCode": "4901133585401",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "焼きとり　塩味",
//         "StandardName": "６５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671456",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4436776",
//         "JanCode": "4901133568121",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道冬島産　日高昆布（お試しサイズ）",
//         "StandardName": "１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671857",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4441206",
//         "JanCode": "4972150924177",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナフレーク（かつお油漬）",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671897",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4441648",
//         "JanCode": "4902220207152",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ライトツナフレーク（かつお油無添加）",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671898",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4441656",
//         "JanCode": "4902220207183",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "かつおパックソフト削り（使い切りパック）",
//         "StandardName": "１ｇ×２４袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671931",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4442016",
//         "JanCode": "4902220192748",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いりごま黒",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671940",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4442105",
//         "JanCode": "4902220206995",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いりごま白",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2671946",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4442172",
//         "JanCode": "4902220206988",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "淡路島産天然カットわかめ",
//         "StandardName": "１２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672590",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4449339",
//         "JanCode": "4979547151963",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "Ｓｐｏｏｎ　Ｆｒｅｅ　いちご",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672627",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4449754",
//         "JanCode": "4562452231624",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "Ｓｐｏｏｎ　Ｆｒｅｅ　ブルーベリー",
//         "StandardName": "１６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672628",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4449762",
//         "JanCode": "4562452231648",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "炊くだけ簡単らくらくパエリア",
//         "StandardName": "２～３人前",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672839",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4452070",
//         "JanCode": "4902220203055",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "やきとりたれ味",
//         "StandardName": "２６０ｇ（固形量２００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672861",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4452305",
//         "JanCode": "4902511012991",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーズンセレクト　ショコラベリー",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672876",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4452461",
//         "JanCode": "4902220205868",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あんバター",
//         "StandardName": "１５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672882",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4452542",
//         "JanCode": "4902220205592",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000067",
//             "TagName": "冬至"
//           }
//         ],
//         "GoodsName": "ゆず茶（高知県産ゆず使用）",
//         "StandardName": "３００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2672888",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4452607",
//         "JanCode": "4902220205707",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "みかん缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にっぽんの果実　和歌山県産八朔",
//         "StandardName": "１９０ｇ（固形量１１０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673012",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4453972",
//         "JanCode": "4901592929679",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産無選別しいたけ",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673044",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4454324",
//         "JanCode": "4970310035831",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ブルーベリージャム",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673212",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4456165",
//         "JanCode": "4954222235565",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いちごジャム",
//         "StandardName": "２５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673213",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4456173",
//         "JanCode": "4954222235558",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "こうや豆腐　徳用",
//         "StandardName": "１６５ｇ（１０個入）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673223",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4456300",
//         "JanCode": "4902220212033",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "シーチキンＳｍｉｌｅマイルド",
//         "StandardName": "５０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673377",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4458036",
//         "JanCode": "4902560022590",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ボンヌママン　ラズベリージャム",
//         "StandardName": "２２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673489",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4459245",
//         "JanCode": "0000045108099",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "さば水煮　食塩不使用",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2673778",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4462432",
//         "JanCode": "4901901000877",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "業務用だし",
//         "StandardName": "１７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674186",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4466934",
//         "JanCode": "4904825309125",
//         "LargeClassName": "乾物",
//         "PayeeClient": "カネソ２２",
//         "OrderClient": "カネソ２２",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "訳あってお得　国産われ栗甘露煮（無漂白）",
//         "StandardName": "２００ｇ（固形量１００ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674324",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4468449",
//         "JanCode": "4908725002537",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "レンジで簡単おしるこ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674368",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4468929",
//         "JanCode": "4901006371186",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "レンジで簡単ぜんざい",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674369",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4468937",
//         "JanCode": "4901006371179",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000002",
//             "TagName": "低糖質"
//           }
//         ],
//         "GoodsName": "レンジで簡単糖質５０％オフぜんざい",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674370",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4468945",
//         "JanCode": "4901006370646",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "濃厚ぜんざい",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674373",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4468988",
//         "JanCode": "4901006370486",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産　するめ",
//         "StandardName": "５枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674397",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4469240",
//         "JanCode": "4972150924382",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "鳴門金時芋あん",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674540",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4470826",
//         "JanCode": "4901401204300",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "俺のＢａｋｅｒｙスイートポテト風トースト",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674541",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4470834",
//         "JanCode": "4550557469493",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "松前漬の素たれなし",
//         "StandardName": "６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674552",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4470958",
//         "JanCode": "4902371229485",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           },
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "松前漬の素たれつき",
//         "StandardName": "具材２８ｇ、タレ３５ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674553",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4470966",
//         "JanCode": "4902371221489",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さんま缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるまるさんまの塩焼き（筒切り）",
//         "StandardName": "６５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674709",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4472675",
//         "JanCode": "4902056012890",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あいこちゃん脂のりのり　いわし　黒ごまパワー",
//         "StandardName": "１４０ｇ（固形量９５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2674901",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4474783",
//         "JanCode": "4953009114178",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "もったいないバナナジャム",
//         "StandardName": "１４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675200",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4478061",
//         "JanCode": "4974636001709",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "さば照焼き",
//         "StandardName": "１００ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675262",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4478762",
//         "JanCode": "4901901003236",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "お気に入りしるこ",
//         "StandardName": "１８０ｇ（３６ｇ×５袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675392",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4480171",
//         "JanCode": "4901006391085",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ホッとフルーツジンジャー　アップル",
//         "StandardName": "２２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675393",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4480198",
//         "JanCode": "4964937022466",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ホッとフルーツジンジャー　レモン",
//         "StandardName": "２２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675394",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4480201",
//         "JanCode": "4964937022459",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産昆布使用　とろろ昆布",
//         "StandardName": "２５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675395",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4480228",
//         "JanCode": "4902220213160",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "納豆用やくみ",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675435",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4480651",
//         "JanCode": "4902915371007",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000698",
//             "TagName": "季節"
//           }
//         ],
//         "GoodsName": "赤坂璃宮監修　中華おこわセット",
//         "StandardName": "２～３人前（３３４ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675636",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4482867",
//         "JanCode": "4901011613837",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "栗甘露煮",
//         "StandardName": "２５０ｇ（固形量１２５ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675637",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4482875",
//         "JanCode": "4901605441242",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "西尾の抹茶　抹茶パンナコッタの素",
//         "StandardName": "８０ｇ（４食分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675918",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4485971",
//         "JanCode": "4972643213054",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "西尾の抹茶　抹茶アイスの素",
//         "StandardName": "８０ｇ（４食分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675919",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4485998",
//         "JanCode": "4972643213047",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "５５　ストロベリー＆ラズベリー",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2675920",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4486005",
//         "JanCode": "0000045218828",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "コメダ珈琲店監修ピーナッツクリーム　",
//         "StandardName": "１８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676179",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4488873",
//         "JanCode": "4978931203110",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーンドライパック",
//         "StandardName": "５５ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676180",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4488881",
//         "JanCode": "4902220095285",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "果実缶",
//         "SmallClassName": "混合フルーツ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーツポンチ（国産果実使用）",
//         "StandardName": "２００ｇ（固形量１２０ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676481",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4492218",
//         "JanCode": "4902220216192",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000027",
//             "TagName": "七夕"
//           }
//         ],
//         "GoodsName": "星のふ（焼き麩）",
//         "StandardName": "２２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676483",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4492234",
//         "JanCode": "4902463014982",
//         "LargeClassName": "乾物",
//         "PayeeClient": "常陸屋本舗（食品）",
//         "OrderClient": "常陸屋本舗（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手作りおはぎセット",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676637",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4493923",
//         "JanCode": "4904655111301",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産紫花豆",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676639",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4493958",
//         "JanCode": "4904655371507",
//         "LargeClassName": "乾物",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ぶり中骨煮付",
//         "StandardName": "１４０ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676697",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4494598",
//         "JanCode": "4901901003243",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "クレープの素",
//         "StandardName": "１袋（１８０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2676977",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4497686",
//         "JanCode": "4904131536048",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "とりレバー　たれ味　",
//         "StandardName": "６５ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2677145",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4499530",
//         "JanCode": "4901133568367",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000305",
//             "TagName": "ながの"
//           }
//         ],
//         "GoodsName": "水ようかんの素",
//         "StandardName": "１００ｇ（５人分）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2677258",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4500776",
//         "JanCode": "4901138801360",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "コンビーフ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキのニューコンミート",
//         "StandardName": "８０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2677427",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4502620",
//         "JanCode": "4902161610585",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "タニタ食堂監修雑穀ごはんもち麦入り",
//         "StandardName": "１８０ｇ（３０ｇ×６袋）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2677549",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4504070",
//         "JanCode": "4902571161318",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "にんべんかつお枯節パックソフト削り",
//         "StandardName": "２ｇ×２０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2677550",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4504089",
//         "JanCode": "4902381009541",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "もぎたてコーン",
//         "StandardName": "２００ｇ（固形量１５５ｇ）×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2677659",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4505271",
//         "JanCode": "4901133966101",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "煮干し",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産にぼし",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2677673",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4505433",
//         "JanCode": "4902833776717",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ほたて貝柱水煮（ほぐし身）",
//         "StandardName": "７０ｇ（固形量４３ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678235",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4511662",
//         "JanCode": "4902220171675",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "切り餅付きぜんざい",
//         "StandardName": "３食入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678283",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4512189",
//         "JanCode": "4560440939125",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "牛乳とまぜてつくるムースベース　いちご",
//         "StandardName": "５００ｍｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678513",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4514726",
//         "JanCode": "4973630118543",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "うずら卵水煮",
//         "StandardName": "６個×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678515",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4514742",
//         "JanCode": "4902220214891",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "のりたま　大袋",
//         "StandardName": "５２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678822",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4518152",
//         "JanCode": "4902820108026",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味道楽　大袋",
//         "StandardName": "５２ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678823",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4518160",
//         "JanCode": "4902820108040",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ピンクの梅ごましお　",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678824",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4518179",
//         "JanCode": "4902820106336",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩ごましお　",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678825",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4518187",
//         "JanCode": "4902820106329",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごま一粒一粒に味をつけたごましお",
//         "StandardName": "３４ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2678826",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4518195",
//         "JanCode": "4902820106343",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ひじき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひじきドライパック（韓国産芽ひじき使用）",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679020",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4520327",
//         "JanCode": "4902220232796",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ご飯がススムいわしのキムチ煮",
//         "StandardName": "１００ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679115",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4521374",
//         "JanCode": "4907982051197",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "いわし缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国産いわししょうゆ味",
//         "StandardName": "１００ｇ（固形量７０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679116",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4521382",
//         "JanCode": "4907982011443",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "くらこん　塩こんぶ",
//         "StandardName": "４７ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679334",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4523784",
//         "JanCode": "4901159924642",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "韓国海苔味付",
//         "StandardName": "８切８枚３袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679462",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4525183",
//         "JanCode": "4972727300830",
//         "LargeClassName": "乾物",
//         "PayeeClient": "小善本店",
//         "OrderClient": "小善本店",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000063",
//             "TagName": "かさばる物"
//           },
//           {
//             "TagId": "00000113",
//             "TagName": "重たいもの"
//           }
//         ],
//         "GoodsName": "おいしい雑穀　十五穀（徳用タイプ）",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679540",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4526058",
//         "JanCode": "4902220214952",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "ぬか床",
//         "StandardName": "１ｋｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679543",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4526082",
//         "JanCode": "4972560651564",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "塩こうじ",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679855",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4529502",
//         "JanCode": "4902401511474",
//         "LargeClassName": "乾物",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "春雨",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "北海道産じゃがいもでんぷん１００％使用　はるさめ",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2679856",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4529510",
//         "JanCode": "4901632808247",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "フルーツソース",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いちごミルクの素",
//         "StandardName": "２７５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680023",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4531388",
//         "JanCode": "4964937022558",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実ゼリーマンゴー（ピューレ入り）",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680044",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4531671",
//         "JanCode": "4901605805372",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実ゼリー国産温州蜜柑",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680060",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4531868",
//         "JanCode": "4901605805310",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実ゼリー国産甘夏",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680072",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4531981",
//         "JanCode": "4901605805341",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実ゼリー山形県産佐藤錦",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680077",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4532058",
//         "JanCode": "4901605805396",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実ゼリー国産果実彩り寒天",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680079",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4532074",
//         "JanCode": "4901605805419",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "オニザキのつきごま金",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680080",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4532082",
//         "JanCode": "4947303117256",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実ゼリー三種果実",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680087",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4532155",
//         "JanCode": "4901605805334",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "果実ゼリー国産果実白桃",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680117",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4532481",
//         "JanCode": "4901605805303",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "46",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "しそ梅酢",
//         "StandardName": "１ｌ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680363",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4535197",
//         "JanCode": "4901583100513",
//         "LargeClassName": "乾物",
//         "PayeeClient": "風見（食品）",
//         "OrderClient": "風見（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "漬物材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "国産赤しそ",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680377",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4535340",
//         "JanCode": "4901583100063",
//         "LargeClassName": "乾物",
//         "PayeeClient": "風見（食品）",
//         "OrderClient": "風見（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ご飯がススムさばのキムチ煮",
//         "StandardName": "１９０ｇ（固形量１４０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680478",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4536460",
//         "JanCode": "4907982023088",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ドライカレー風サバカレーライス",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680479",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4536479",
//         "JanCode": "4907982023255",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "鯖水煮　九州旬のさば使用",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680502",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4536738",
//         "JanCode": "4941821000311",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "いちごジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１００％フルーツ　ストロベリー",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680589",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4537661",
//         "JanCode": "4901815881463",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１００％フルーツ　瀬戸内レモン",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680596",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4537750",
//         "JanCode": "4901815881500",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１００％フルーツ　瀬戸内レモン",
//         "StandardName": "１４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680607",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4537874",
//         "JanCode": "4901815881579",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "ブルーベリージャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１００％フルーツ　ブルーベリー",
//         "StandardName": "３４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680618",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4537998",
//         "JanCode": "4901815881470",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "オレンジママレード",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "１００％フルーツ　マーマレード",
//         "StandardName": "３４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680620",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4538013",
//         "JanCode": "4901815881487",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "本枯節かつおパックソフト削り（鹿児島県枕崎製造本枯節使用）",
//         "StandardName": "２ｇ×１０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680625",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4538072",
//         "JanCode": "4902220234257",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "徳用かつおパック（枯れ節）",
//         "StandardName": "２ｇ×３０袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680631",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4538137",
//         "JanCode": "4902220234233",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "業務用だし",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680709",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4539001",
//         "JanCode": "4902220234646",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "甜杏仁豆腐の素",
//         "StandardName": "４０ｇ（２０ｇ×２）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680941",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4541588",
//         "JanCode": "4560251200193",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾燥野菜",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ごぼう人参ミックス",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2680968",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4541871",
//         "JanCode": "4902220145461",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ひじき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひじきドライパック（韓国産芽ひじき使用）《パウチ》",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681049",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4542789",
//         "JanCode": "4902220232802",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "プラス糀　塩糀パウダー　ボトル",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681164",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4544048",
//         "JanCode": "4902713136037",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ナチュラルカラふル　花（焼き麩）　",
//         "StandardName": "１５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681506",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4547802",
//         "JanCode": "4902463014456",
//         "LargeClassName": "乾物",
//         "PayeeClient": "常陸屋本舗（食品）",
//         "OrderClient": "常陸屋本舗（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "漬物材",
//         "SmallClassName": "ぬか",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000014",
//             "TagName": "漬物づくり"
//           }
//         ],
//         "GoodsName": "発酵ぬかみそ　漬けるだけ！",
//         "StandardName": "３５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681603",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4548876",
//         "JanCode": "4970085054341",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "アジアン満喫　マンゴープリン４個入",
//         "StandardName": "８３ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681616",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4549015",
//         "JanCode": "4964937051695",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産無選別しいたけ",
//         "StandardName": "４５ｇ＋５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681617",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4549023",
//         "JanCode": "4970310035886",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーチェ　濃厚ブルーベリーブドウ",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681618",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4549031",
//         "JanCode": "4902402885802",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おうちで凍らせて食べる甘酒アイス（スリムパウチタイプ）",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681628",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4549147",
//         "JanCode": "4904851300271",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "おうちで凍らせて食べるしるこアイス（スリムパウチタイプ）",
//         "StandardName": "７０ｇ×４",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2681629",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4549155",
//         "JanCode": "4904851300264",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           },
//           {
//             "TagId": "00000581",
//             "TagName": "ナチュラル"
//           }
//         ],
//         "GoodsName": "あいこちゃん　青の鯖水煮食塩不使用",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "0",
//         "Pcode": "P2681813",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4551192",
//         "JanCode": "4953009114291",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いつものジュレ　パイン",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682060",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4554043",
//         "JanCode": "4964937051633",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いつものジュレ　マンゴー",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682061",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4554051",
//         "JanCode": "4964937051640",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いつものジュレ　みかん",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682062",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4554078",
//         "JanCode": "4964937051619",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いつものジュレ　白桃",
//         "StandardName": "１３５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682063",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4554086",
//         "JanCode": "4964937051626",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "かに缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるずわいがに水煮（ほぐしみ）",
//         "StandardName": "固形量５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682067",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4554124",
//         "JanCode": "4901901294658",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "韓国のり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付のり（韓国産のり使用）≪卓上タイプ≫",
//         "StandardName": "１０切９０枚（板のり９枚）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682233",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4555953",
//         "JanCode": "4902220146659",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ひじき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひじきドライパック（国産芽ひじき使用）",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682633",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4560345",
//         "JanCode": "4902220235834",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ひじき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひじきドライパック（国産芽ひじき使用）",
//         "StandardName": "４０ｇ×５",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682634",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4560353",
//         "JanCode": "4902220235988",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ひじき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひじきドライパック（国産芽ひじき使用）",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682635",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4560361",
//         "JanCode": "4902220236060",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "ひじき缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000061",
//             "TagName": "ストック"
//           }
//         ],
//         "GoodsName": "ひじきドライパック（国産芽ひじき使用）",
//         "StandardName": "１００ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682636",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4560388",
//         "JanCode": "4902220236053",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "味付のり８０",
//         "StandardName": "１２切８０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682644",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4560477",
//         "JanCode": "4901191231357",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000001",
//             "TagName": "減塩"
//           }
//         ],
//         "GoodsName": "減塩味付のり８０",
//         "StandardName": "１２切８０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682645",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4560485",
//         "JanCode": "4901191231456",
//         "LargeClassName": "乾物",
//         "PayeeClient": "大森屋（食品）",
//         "OrderClient": "大森屋（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "めちゃラクアイスの素　コールドストーン",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682777",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4561937",
//         "JanCode": "4902170096592",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢完熟マンゴー",
//         "StandardName": "１９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682900",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4563298",
//         "JanCode": "4901901005124",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルティシエちょっと贅沢完熟マンゴー",
//         "StandardName": "１９０ｇ×６",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682903",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4563336",
//         "JanCode": "4901901005124",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "３種の野菜入り麩",
//         "StandardName": "３０ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2682976",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4564138",
//         "JanCode": "4902463014432",
//         "LargeClassName": "乾物",
//         "PayeeClient": "常陸屋本舗（食品）",
//         "OrderClient": "常陸屋本舗（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "かに缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "まるずわいがに水煮（ほぐしみ）",
//         "StandardName": "固形量　５５ｇ×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2683042",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4564847",
//         "JanCode": "4901901294795",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "麩",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000308",
//             "TagName": "にいがた"
//           }
//         ],
//         "GoodsName": "車麩",
//         "StandardName": "６枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2683068",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4565142",
//         "JanCode": "4960952592694",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あさり水煮",
//         "StandardName": "６５ｇ（固形量３０ｇ）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2683075",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4565215",
//         "JanCode": "4901901006053",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000066",
//             "TagName": "迎春"
//           }
//         ],
//         "GoodsName": "大分産どんこしいたけ",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2683435",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4569636",
//         "JanCode": "4970310036050",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "味付けのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ゆかり味付のりカップＧ　しそ風味",
//         "StandardName": "８切２６枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2683654",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4572033",
//         "JanCode": "4903182041327",
//         "LargeClassName": "乾物",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "ひじき",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ひじき白和えの素（豆腐半丁用）",
//         "StandardName": "２５ｇ×３袋",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2683980",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4575636",
//         "JanCode": "4979457150162",
//         "LargeClassName": "乾物",
//         "PayeeClient": "ぎょれん北光",
//         "OrderClient": "ぎょれん北光",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "すみっコぐらしこうや豆腐　ダシ付",
//         "StandardName": "５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2683982",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4575652",
//         "JanCode": "4902029111490",
//         "LargeClassName": "乾物",
//         "PayeeClient": "高千穂物産",
//         "OrderClient": "高千穂物産",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "昆布",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "くらこん　塩こんぶ",
//         "StandardName": "１３０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684109",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4577043",
//         "JanCode": "4901159304390",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "他の果実ジャム",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "Ｆｒｕｉｔｓ×Ｆｒｕｉｔｓ　パインアップル",
//         "StandardName": "２６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684113",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4577094",
//         "JanCode": "4901401205116",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "あま酒かたねり（濃縮タイプ）",
//         "StandardName": "２８０ｇ（４人前）",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684514",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4581490",
//         "JanCode": "4970085024320",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "煮干し・削り節",
//         "SmallClassName": "削り節",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "かつおソフト削り",
//         "StandardName": "６０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684599",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4582446",
//         "JanCode": "4902381006380",
//         "LargeClassName": "乾物",
//         "PayeeClient": "三菱食品（食品）",
//         "OrderClient": "三菱食品（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "カットわかめ（韓国産）",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684600",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4582454",
//         "JanCode": "4902371440057",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "岩手県産カットわかめ",
//         "StandardName": "２４ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684601",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4582462",
//         "JanCode": "4902371441399",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日東海藻（食品）",
//         "OrderClient": "日東海藻（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ジャム",
//         "SmallClassName": "クリームスプレット",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "いちご＆ホワイトチョコホイップクリーム",
//         "StandardName": "１００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684863",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4585321",
//         "JanCode": "4902220236879",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ドライパック３種アソート（大豆・ひじき・ミックスビーンズ）",
//         "StandardName": "３袋入",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2684864",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4585348",
//         "JanCode": "4902220236831",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "国内産おにぎり焼のり",
//         "StandardName": "３切３０枚　板のり１０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685030",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4587170",
//         "JanCode": "4904071408955",
//         "LargeClassName": "乾物",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "製菓材",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [
//           {
//             "TagId": "00000025",
//             "TagName": "ひなまつり"
//           }
//         ],
//         "GoodsName": "ゼラチン",
//         "StandardName": "７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685032",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4587197",
//         "JanCode": "4902220242559",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "フルーチェＳｗｅｅｔｓ　マンゴープリン味",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685109",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4588037",
//         "JanCode": "4902402919125",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "加藤産業（食品）",
//         "OrderClient": "加藤産業（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "56",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "九州産乾しいたけスライス",
//         "StandardName": "２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685252",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4589602",
//         "JanCode": "4970310036166",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "椎茸・乾燥野菜",
//         "SmallClassName": "乾ししいたけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "大分産上どんこしいたけ",
//         "StandardName": "４５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685253",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4589610",
//         "JanCode": "4970310036180",
//         "LargeClassName": "乾物",
//         "PayeeClient": "九州椎茸販売（食品）",
//         "OrderClient": "九州椎茸販売（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海藻",
//         "SmallClassName": "わかめ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "三陸産カットわかめ",
//         "StandardName": "２４ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685342",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4590643",
//         "JanCode": "4902378033399",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "オニザキのいりごま白",
//         "StandardName": "８５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685561",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4593049",
//         "JanCode": "4947303113012",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ぜんざい　十勝産あずき１００％使用",
//         "StandardName": "１人前（１６０ｇ）×１０",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685562",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4593057",
//         "JanCode": "4901605512133",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "スイートコーンドライパック",
//         "StandardName": "１２０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685646",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4594002",
//         "JanCode": "4902220199358",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "農産缶",
//         "SmallClassName": "スィートコーン缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食塩無添加スイートコーン",
//         "StandardName": "５０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685719",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4594819",
//         "JanCode": "4901133338151",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "いなば食品",
//         "OrderClient": "いなば食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（オイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ツナフレーク油漬け油切り不要",
//         "StandardName": "７０ｇ×７",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685722",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4594843",
//         "JanCode": "4901901006855",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "ツナ缶（ノンオイル）",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ツナフレーク食塩・オイル不使用",
//         "StandardName": "７０ｇ×７",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685723",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4594851",
//         "JanCode": "4901901006848",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "マルハニチロ（ドライ）",
//         "OrderClient": "マルハニチロ（ドライ）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "製菓材",
//         "SmallClassName": "デザート",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "手作りどら焼きセット",
//         "StandardName": "５００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2685807",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4595777",
//         "JanCode": "4904655111509",
//         "LargeClassName": "粉加工",
//         "PayeeClient": "虎屋産業",
//         "OrderClient": "虎屋産業",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "便利なミニこうや豆腐（うす切りタイプ）",
//         "StandardName": "８０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686118",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4599217",
//         "JanCode": "4902220214945",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "麩・凍りどうふ・春雨",
//         "SmallClassName": "凍りどうふ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "アンパンマンこうや豆腐　味だし付き",
//         "StandardName": "５３ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686358",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4601858",
//         "JanCode": "4902758202759",
//         "LargeClassName": "乾物",
//         "PayeeClient": "下田商事",
//         "OrderClient": "下田商事",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "貝類缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "美味しい帆立姿炊",
//         "StandardName": "７０ｇ（固形量４０ｇ）×２",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686361",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4601882",
//         "JanCode": "4953009113607",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "国分（食品）",
//         "OrderClient": "国分（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "海苔",
//         "SmallClassName": "焼きのり",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "有明海産焼のり　おにぎり・おもち用",
//         "StandardName": "３切４０枚",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686435",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4602706",
//         "JanCode": "4902220244423",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "2",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さば缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "燻肴－ｉｂｕｓａ－　ひとくちスモーク金華さば",
//         "StandardName": "５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686668",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4605276",
//         "JanCode": "4580051921326",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "燻肴－ｉｂｕｓａ－　ひとくちスモークサーモン",
//         "StandardName": "５５ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686670",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4605292",
//         "JanCode": "4580051921333",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "ふりかけ・茶漬け",
//         "SmallClassName": "ふりかけ",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "甘旨おかか",
//         "StandardName": "４０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686717",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4605802",
//         "JanCode": "4901049105298",
//         "LargeClassName": "乾物",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ストンロルズ　いか煮付け",
//         "StandardName": "１２０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2686719",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4605829",
//         "JanCode": "4580051922361",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "伊藤忠食品",
//         "OrderClient": "伊藤忠食品",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "豆類",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "兵庫県産丹波黒大豆",
//         "StandardName": "１５０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "1",
//         "Pcode": "P2687105",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4610067",
//         "JanCode": "4903004110552",
//         "LargeClassName": "乾物",
//         "PayeeClient": "中田商店（食品）",
//         "OrderClient": "中田商店（食品）",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "水産缶",
//         "SmallClassName": "さけ缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "銀鮭中骨水煮（塩味控えめ）",
//         "StandardName": "１７０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "0",
//         "Pcode": "P2689095",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4631978",
//         "JanCode": "4986302203614",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "畜肉調理缶",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "ノザキのポークランチョンミート",
//         "StandardName": "２００ｇ",
//         "AllCoop": "1",
//         "EnableSet": "0",
//         "Pcode": "P2691674",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4660420",
//         "JanCode": "4902161635403",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "サンヨー堂",
//         "OrderClient": "サンヨー堂",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "雑穀・米麦",
//         "SmallClassName": "ごま",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "食べるごま（しょうゆ味）",
//         "StandardName": "９０ｇ",
//         "AllCoop": "1",
//         "EnableSet": "0",
//         "Pcode": "P2691836",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4662202",
//         "JanCode": "4902220249398",
//         "LargeClassName": "乾物",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "1",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       },
//       {
//         "MediumType": "001",
//         "MediumName": "ハピデリ",
//         "ClassName": "食品",
//         "MiddleClassName": "畜肉缶・調理缶",
//         "SmallClassName": "その他",
//         "CategoryTagId": "",
//         "CategoryTagName": "",

//         "TagInfoList": [],
//         "GoodsName": "鶏ささみフレーク　油・食塩無添加",
//         "StandardName": "７０ｇ×３",
//         "AllCoop": "1",
//         "EnableSet": "0",
//         "Pcode": "P2692200",
//         "RelationPcode": "",
//         "CoopCode": "210",
//         "ItemCode": "4666216",
//         "JanCode": "4902220248216",
//         "LargeClassName": "缶詰",
//         "PayeeClient": "日本生協連中央支所",
//         "OrderClient": "日本生協連中央支所",
//         "ApplyTermEnd": "99999999",
//         "GoodsMemo": "",
//         "CatalogInfoList": [
//           {
//             "OrderCode": "2025120",
//             "CatalogId": "20250602",
//             "Status": "1",
//             "PricePattern": "0",
//             "PricePatternName": "",
//             "FeatureCode": "",
//             "FeatureName": "",
//             "SelectedOthers": "0",
//             "KomaPromotion": "  ",
//             "KomaPromotionName": "",
//             "DispValue1": null,
//             "DispValue2": null
//           }
//         ],
//         "NumSum": null,
//         "PriceSum": null
//       }
//     ]
//   }
// };
const getOtherMediumsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: ['ハピデリ', '新発売', 'ぐるめぐり'],
  },
};
const getBuyerCodeForAgentResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    // obj: ['99900001', '99900002'],
    obj: [],
  },
};
const outputCycleItemInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      FileName:
        '/tmp/peace/data/WebData/downloadtemp/KYMW1200_001_00000001_302_20240814_161931.xlsx',
    },
  },
};
const getStaffBuyerSelectItemsResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        ClassCode: "01",
        BuyerCode: "00000001"
      },
      {
        ClassCode: "01",
        BuyerCode: "00000002"
      },
      {
        ClassCode: "01",
        BuyerCode: "00000003"
      },
      {
        ClassCode: "01",
        BuyerCode: "00000004"
      },
      {
        ClassCode: "02",
        BuyerCode: "00000002"
      },
      {
        ClassCode: "03",
        BuyerCode: "00000001"
      },
      {
        ClassCode: "03",
        BuyerCode: "00000002"
      },
      {
        ClassCode: "03",
        BuyerCode: "00000003"
      },
      {
        ClassCode: "03",
        BuyerCode: "00000004"
      },
      {
        ClassCode: "04",
        BuyerCode: "00000004"
      }
    ]
  }
}
